import { useVeltClient, VeltSidebarButton, VeltHuddle, VeltPresence, VeltCommentTool, VeltHuddleTool } from '@veltdev/react';
import { useEffect, useState } from 'react';

export default function YourDocument() {

  // Get the Velt client
  const { client } = useVeltClient();

  useEffect(() => {
    if (client) {
      // Set a document ID
      client.setDocumentId('protopie-id');
    }
  }, [client]);

  return (
    <div>
      <>
  <meta charSet="utf-8" />
  <meta
    name="viewport"
    content="width=device-width,height=device-height,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover"
  />
  <meta name="apple-mobile-web-app-capable" content="yes" />
  <meta
    name="apple-mobile-web-app-status-bar-style"
    content="black-translucent"
  />
  <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
  <meta
    httpEquiv="Content-Security-Policy"
    content="upgrade-insecure-requests"
  />
  <meta name="theme-color" content="#000000" />
  <meta
    name="description"
    content="ProtoPie is the easiest tool used to turn your UI/UX design ideas into highly interactive prototypes for mobile, desktop, web, all the way to IoT."
  />
  <meta
    name="keyword"
    content="prototype design, prototyping tool, prototyping tools, prototyping tool for mac, prototyping tool for Windows, app ui design, interaction, interaction design, protopie, app design, Interactive prototyping, mobile design, code free prototyping tool, design tool, sensor prototyping, interaction design, prototyping software, offline design tool, ios prototyping, android prototyping, proto pie, 프로토 파이, 프로토파이, cloud, URL share, video, windows, 스튜디오씨드, studio xid"
  />
  <meta property="fb:app_id" content={462675533923571} />
  <meta property="og:url" content="https://cloud.protopie.io/" />
  <meta property="og:title" content="ProtoPie Cloud" />
  <meta property="og:site_name" content="ProtoPie Cloud" />
  <meta property="og:type" content="website" />
  <meta
    property="og:description"
    content="ProtoPie is the easiest tool used to turn your UX design ideas into highly interactive prototypes for mobile, desktop, web, all the way to IoT."
  />
  <meta
    property="og:image"
    content="https://www.protopie.io/public/assets/image/img_share_190808.jpg"
  />
  <meta property="og:image:width" content={600} />
  <meta property="og:image:height" content={315} />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="ProtoPie Cloud" />
  <meta
    name="twitter:description"
    content="ProtoPie is the easiest tool used to turn your UX design ideas into highly interactive prototypes for mobile, desktop, web, all the way to IoT."
  />
  <meta
    name="twitter:image"
    content="https://www.protopie.io/public/assets/image/img_share_190808.jpg"
  />
  <meta itemProp="name" content="ProtoPie Cloud" />
  <meta
    itemProp="description"
    content="ProtoPie is the easiest tool used to turn your UX design ideas into highly interactive prototypes for mobile, desktop, web, all the way to IoT."
  />
  <meta
    itemProp="image"
    content="https://www.protopie.io/public/assets/image/img_share_190808.jpg"
  />
  <meta itemProp="url" content="https://cloud.protopie.io/" />
  <title>ProtoPie Cloud</title>
  <noscript>
    &lt;iframe
    src="https://www.googletagmanager.com/ns.html?id=GTM-5MFSRL3&amp;gtm_auth=&amp;gtm_preview=&amp;gtm_cookies_win=x"
    height="0" width="0" style="display:none;visibility:hidden"
    id="tag-manager"&gt;&lt;/iframe&gt;
  </noscript>
  <noscript>
    &lt;iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5MFSRL3"
    height="0" width="0"
    style="display:none;visibility:hidden"&gt;&lt;/iframe&gt;&lt;iframe
    src="https://www.googletagmanager.com/ns.html?id=GTM-KLQFH87" height="0"
    width="0" style="display:none;visibility:hidden"&gt;&lt;/iframe&gt;
  </noscript>
  <div id="root">
    <header className="sc-egAHoP bzCyQY">
      <div className="sc-kefYRu sc-lruFP bFBFca fnGKMB">
        <a
          href="https://www.protopie.io"
          target="_blank"
          rel="noreferrer"
          className="sc-jIeqeR eNhUsM"
        >
          <svg
            width={302}
            height={302}
            viewBox="0 0 302 302"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="sc-CnrYG cCAfXl"
          >
            <path
              d="M298.422 91.8263C298.422 88.3261 298.422 84.8255 298.402 81.325C298.384 78.3762 298.35 75.4282 298.27 72.4808C298.097 66.0569 297.718 59.5779 296.575 53.2255C295.417 46.7816 293.525 40.7842 290.543 34.9292C287.612 29.1744 283.783 23.9084 279.214 19.343C274.647 14.7775 269.379 10.951 263.622 8.02158C257.761 5.03916 251.757 3.14773 245.306 1.98947C238.953 0.848746 232.473 0.470531 226.049 0.296989C223.099 0.217196 220.15 0.183561 217.199 0.165312C213.697 0.143843 210.195 0.145632 206.692 0.145632L166.027 0H135.613L95.6672 0.145632C92.158 0.145632 88.6489 0.143843 85.1398 0.165312C82.1835 0.183561 79.2287 0.217196 76.2735 0.296989C69.8345 0.470531 63.3391 0.849103 56.971 1.99126C50.5113 3.14916 44.4986 5.03987 38.6297 8.02015C32.8606 10.95 27.5817 14.7768 23.0045 19.343C18.428 23.908 14.5919 29.1729 11.6553 34.9267C8.66533 40.7845 6.76962 46.7855 5.60814 53.233C4.46456 59.5829 4.08563 66.0598 3.91137 72.4808C3.83194 75.4285 3.79759 78.3766 3.7797 81.325C3.75823 84.8259 3.57825 89.1745 3.57825 92.675V132.067V162.807L3.76002 203.037C3.76002 206.542 3.75859 210.047 3.7797 213.552C3.79759 216.505 3.83194 219.457 3.91173 222.409C4.08563 228.841 4.46528 235.329 5.60993 241.69C6.77105 248.143 8.66641 254.149 11.6538 260.011C14.5908 265.774 18.4277 271.047 23.0045 275.619C27.5813 280.191 32.8588 284.022 38.6268 286.956C44.4993 289.942 50.5149 291.836 56.9785 292.996C63.3437 294.138 69.8371 294.517 76.2735 294.691C79.2287 294.771 82.1839 294.805 85.1402 294.822C88.6493 294.844 92.158 294.844 95.6672 294.844H135.974H166.464H206.692C210.195 294.844 213.697 294.844 217.199 294.822C220.15 294.805 223.099 294.771 226.049 294.691C232.475 294.517 238.958 294.138 245.314 292.994C251.761 291.835 257.762 289.941 263.62 286.957C269.378 284.024 274.646 280.191 279.214 275.619C283.782 271.048 287.611 265.775 290.542 260.014C293.525 254.148 295.418 248.139 296.577 241.682C297.718 235.324 298.097 228.838 298.27 222.409C298.35 219.457 298.384 216.505 298.402 213.552C298.422 210.047 298.422 206.542 298.422 203.037C298.422 203.037 298.422 163.518 298.422 162.807V132.035C298.422 131.511 298.422 91.8263 298.422 91.8263Z"
              fill="url(#paint0_linear_3361_71)"
            />
            <g filter="url(#filter0_dd_3361_71)">
              <g filter="url(#filter1_ii_3361_71)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M151.802 217.563V247.002C146.939 247.002 142.526 245.067 139.281 241.931C139.269 241.931 139.269 241.931 139.269 241.921L136.838 239.017L57.2329 144.267C57.1807 144.242 57.1432 144.19 57.1161 144.137L56.7948 143.765C56.7697 143.737 56.7551 143.712 56.7321 143.685C56.3441 143.158 56.0103 142.59 55.7912 141.97C55.495 141.235 55.328 140.436 55.303 139.61V139.121C55.303 138.966 55.3155 138.809 55.3426 138.654C55.4824 137.031 56.1772 135.583 57.2329 134.449C58.5327 133.043 60.4104 132.154 62.4801 132.154H80.0203L151.789 217.575L151.802 217.563Z"
                  fill="url(#paint1_linear_3361_71)"
                  style={{ mixBlendMode: "multiply" }}
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M151.802 217.563V247.002C146.939 247.002 142.526 245.067 139.281 241.931C139.269 241.931 139.269 241.931 139.269 241.921L136.838 239.017L57.2329 144.267C57.1807 144.242 57.1432 144.19 57.1161 144.137L56.7948 143.765C56.7697 143.737 56.7551 143.712 56.7321 143.685C56.3441 143.158 56.0103 142.59 55.7912 141.97C55.495 141.235 55.328 140.436 55.303 139.61V139.121C55.303 138.966 55.3155 138.809 55.3426 138.654C55.4824 137.031 56.1772 135.583 57.2329 134.449C58.5327 133.043 60.4104 132.154 62.4801 132.154H80.0203L151.789 217.575L151.802 217.563Z"
                  fill="url(#paint2_linear_3361_71)"
                  style={{ mixBlendMode: "multiply" }}
                />
              </g>
              <g filter="url(#filter2_ii_3361_71)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M151.802 217.563V247.002C146.939 247.002 142.526 245.067 139.281 241.931C139.269 241.931 139.269 241.931 139.269 241.921L136.838 239.017L77.4456 168.33L57.2329 144.267C57.1807 144.242 57.1432 144.19 57.1161 144.137L56.7948 143.765C56.7697 143.737 56.7551 143.712 56.7321 143.685C56.3441 143.158 56.0103 142.59 55.7912 141.97C55.495 141.235 55.328 140.436 55.303 139.61V139.121C55.303 138.966 55.3155 138.809 55.3426 138.654C55.4824 137.031 56.1772 135.583 57.2329 134.449C58.5327 133.043 60.4104 132.154 62.4801 132.154H80.0203L88.2678 141.97L110.411 168.33L146.718 211.538L151.789 217.575L151.802 217.563Z"
                  fill="url(#paint3_linear_3361_71)"
                  fillOpacity="0.4"
                />
              </g>
              <g filter="url(#filter3_ii_3361_71)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M151.802 178.456V217.762L151.789 217.775L57.0993 105.38C57.0034 105.273 56.9074 105.152 56.8114 105.029C56.39 104.489 56.0394 103.886 55.7849 103.22C55.4971 102.485 55.328 101.688 55.303 100.845V100.361C55.3509 98.5644 56.075 96.9472 57.2329 95.7181C58.5244 94.2928 60.4042 93.4122 62.4801 93.4122H80.1642L151.802 178.456Z"
                  fill="url(#paint4_linear_3361_71)"
                  style={{ mixBlendMode: "multiply" }}
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M151.802 178.456V217.762L151.789 217.775L57.0993 105.38C57.0034 105.273 56.9074 105.152 56.8114 105.029C56.39 104.489 56.0394 103.886 55.7849 103.22C55.4971 102.485 55.328 101.688 55.303 100.845V100.361C55.3509 98.5644 56.075 96.9472 57.2329 95.7181C58.5244 94.2928 60.4042 93.4122 62.4801 93.4122H80.1642L151.802 178.456Z"
                  fill="url(#paint5_linear_3361_71)"
                  style={{ mixBlendMode: "multiply" }}
                />
              </g>
              <g filter="url(#filter4_ii_3361_71)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M151.802 178.456V217.762L151.789 217.775L146.724 211.754L110.417 168.661L88.2698 142.371L80.0203 132.575L57.0993 105.38C57.0034 105.273 56.9074 105.152 56.8114 105.029C56.39 104.489 56.0394 103.886 55.7849 103.22C55.4971 102.485 55.328 101.688 55.303 100.845V100.361C55.3509 98.5644 56.075 96.9472 57.2329 95.7181C58.5244 94.2928 60.4042 93.4122 62.4801 93.4122H80.1642L88.4263 103.22L113.156 132.575L121.405 142.371L143.553 168.661L151.802 178.456Z"
                  fill="url(#paint6_linear_3361_71)"
                  fillOpacity="0.3"
                  style={{ mixBlendMode: "multiply" }}
                />
              </g>
              <g filter="url(#filter5_ii_3361_71)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M62.1772 54C60.1096 54 58.2152 54.8721 56.93 56.3013C55.772 57.5115 55.0522 59.1577 55 60.9478V61.4235C55.023 62.2727 55.1899 63.0696 55.4882 63.802C55.5008 63.8667 55.5279 63.9189 55.5509 63.9835C55.7845 64.5365 56.0788 65.0497 56.4522 65.5275C56.5795 65.709 56.7234 65.8759 56.8778 66.0282C56.9028 66.0679 56.9404 66.1054 56.98 66.1451L151.498 178.33V247C151.951 247 152.389 246.988 152.825 246.95C157.161 246.643 161.072 244.788 164.019 241.945C164.033 241.945 164.033 241.945 164.033 241.93L166.464 239.036L246.187 144.4C246.289 144.298 246.379 144.181 246.471 144.067C246.907 143.526 247.254 142.919 247.51 142.252C247.833 141.455 248 140.581 248 139.652V61.1794C248 59.287 247.266 57.549 246.058 56.2889C244.758 54.8721 242.891 54 240.806 54H62.1772Z"
                  fill="url(#paint7_linear_3361_71)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M62.1772 54C60.1096 54 58.2152 54.8721 56.93 56.3013C55.772 57.5115 55.0522 59.1577 55 60.9478V61.4235C55.023 62.2727 55.1899 63.0696 55.4882 63.802C55.5008 63.8667 55.5279 63.9189 55.5509 63.9835C55.7845 64.5365 56.0788 65.0497 56.4522 65.5275C56.5795 65.709 56.7234 65.8759 56.8778 66.0282C56.9028 66.0679 56.9404 66.1054 56.98 66.1451L151.498 178.33V247C151.951 247 152.389 246.988 152.825 246.95C157.161 246.643 161.072 244.788 164.019 241.945C164.033 241.945 164.033 241.945 164.033 241.93L166.464 239.036L246.187 144.4C246.289 144.298 246.379 144.181 246.471 144.067C246.907 143.526 247.254 142.919 247.51 142.252C247.833 141.455 248 140.581 248 139.652V61.1794C248 59.287 247.266 57.549 246.058 56.2889C244.758 54.8721 242.891 54 240.806 54H62.1772Z"
                  fill="url(#paint8_linear_3361_71)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M62.1772 54C60.1096 54 58.2152 54.8721 56.93 56.3013C55.772 57.5115 55.0522 59.1577 55 60.9478V61.4235C55.023 62.2727 55.1899 63.0696 55.4882 63.802C55.5008 63.8667 55.5279 63.9189 55.5509 63.9835C55.7845 64.5365 56.0788 65.0497 56.4522 65.5275C56.5795 65.709 56.7234 65.8759 56.8778 66.0282C56.9028 66.0679 56.9404 66.1054 56.98 66.1451L151.498 178.33V247C151.951 247 152.389 246.988 152.825 246.95C157.161 246.643 161.072 244.788 164.019 241.945C164.033 241.945 164.033 241.945 164.033 241.93L166.464 239.036L246.187 144.4C246.289 144.298 246.379 144.181 246.471 144.067C246.907 143.526 247.254 142.919 247.51 142.252C247.833 141.455 248 140.581 248 139.652V61.1794C248 59.287 247.266 57.549 246.058 56.2889C244.758 54.8721 242.891 54 240.806 54H62.1772Z"
                  fill="url(#paint9_linear_3361_71)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M62.1772 54C60.1096 54 58.2152 54.8721 56.93 56.3013C55.772 57.5115 55.0522 59.1577 55 60.9478V61.4235C55.023 62.2727 55.1899 63.0696 55.4882 63.802C55.5008 63.8667 55.5279 63.9189 55.5509 63.9835C55.7845 64.5365 56.0788 65.0497 56.4522 65.5275C56.5795 65.709 56.7234 65.8759 56.8778 66.0282C56.9028 66.0679 56.9404 66.1054 56.98 66.1451L151.498 178.33V247C151.951 247 152.389 246.988 152.825 246.95C157.161 246.643 161.072 244.788 164.019 241.945C164.033 241.945 164.033 241.945 164.033 241.93L166.464 239.036L246.187 144.4C246.289 144.298 246.379 144.181 246.471 144.067C246.907 143.526 247.254 142.919 247.51 142.252C247.833 141.455 248 140.581 248 139.652V61.1794C248 59.287 247.266 57.549 246.058 56.2889C244.758 54.8721 242.891 54 240.806 54H62.1772Z"
                  fill="url(#paint10_linear_3361_71)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M62.1772 54C60.1096 54 58.2152 54.8721 56.93 56.3013C55.772 57.5115 55.0522 59.1577 55 60.9478V61.4235C55.023 62.2727 55.1899 63.0696 55.4882 63.802C55.5008 63.8667 55.5279 63.9189 55.5509 63.9835C55.7845 64.5365 56.0788 65.0497 56.4522 65.5275C56.5795 65.709 56.7234 65.8759 56.8778 66.0282C56.9028 66.0679 56.9404 66.1054 56.98 66.1451L151.498 178.33V247C151.951 247 152.389 246.988 152.825 246.95C157.161 246.643 161.072 244.788 164.019 241.945C164.033 241.945 164.033 241.945 164.033 241.93L166.464 239.036L246.187 144.4C246.289 144.298 246.379 144.181 246.471 144.067C246.907 143.526 247.254 142.919 247.51 142.252C247.833 141.455 248 140.581 248 139.652V61.1794C248 59.287 247.266 57.549 246.058 56.2889C244.758 54.8721 242.891 54 240.806 54H62.1772Z"
                  fill="url(#paint11_linear_3361_71)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M62.1772 54C60.1096 54 58.2152 54.8721 56.93 56.3013C55.772 57.5115 55.0522 59.1577 55 60.9478V61.4235C55.023 62.2727 55.1899 63.0696 55.4882 63.802C55.5008 63.8667 55.5279 63.9189 55.5509 63.9835C55.7845 64.5365 56.0788 65.0497 56.4522 65.5275C56.5795 65.709 56.7234 65.8759 56.8778 66.0282C56.9028 66.0679 56.9404 66.1054 56.98 66.1451L151.498 178.33V247C151.951 247 152.389 246.988 152.825 246.95C157.161 246.643 161.072 244.788 164.019 241.945C164.033 241.945 164.033 241.945 164.033 241.93L166.464 239.036L246.187 144.4C246.289 144.298 246.379 144.181 246.471 144.067C246.907 143.526 247.254 142.919 247.51 142.252C247.833 141.455 248 140.581 248 139.652V61.1794C248 59.287 247.266 57.549 246.058 56.2889C244.758 54.8721 242.891 54 240.806 54H62.1772Z"
                  fill="url(#paint12_linear_3361_71)"
                />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_dd_3361_71"
                x="39.9429"
                y="42.5279"
                width="233.152"
                height="233.155"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="5.01905" dy="8.60408" />
                <feGaussianBlur stdDeviation="10.0381" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.875 0 0 0 0 0.843 0 0 0 0.63 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_3361_71"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="2.15102" dy="4.30204" />
                <feGaussianBlur stdDeviation="7.17007" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.771137 0 0 0 0 0.469437 0 0 0 0 0.40806 0 0 0 0.3 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_dropShadow_3361_71"
                  result="effect2_dropShadow_3361_71"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect2_dropShadow_3361_71"
                  result="shape"
                />
              </filter>
              <filter
                id="filter1_ii_3361_71"
                x="42.1035"
                y="132.154"
                width="126.19"
                height="139.227"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="16.4911" dy="40.8694" />
                <feGaussianBlur stdDeviation="12.1891" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.651 0 0 0 0 0.58 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_3361_71"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-13.1995" dy="87.1163" />
                <feGaussianBlur stdDeviation="11.8796" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.875 0 0 0 0 0.843 0 0 0 0.48 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_innerShadow_3361_71"
                  result="effect2_innerShadow_3361_71"
                />
              </filter>
              <filter
                id="filter2_ii_3361_71"
                x="55.303"
                y="124.266"
                width="105.82"
                height="122.736"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="0.717007" dy="-8.60408" />
                <feGaussianBlur stdDeviation="3.22653" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.604589 0 0 0 0 0.591667 0 0 0 0.2 0"
                />
                <feBlend
                  mode="multiply"
                  in2="shape"
                  result="effect1_innerShadow_3361_71"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="9.32109" dy="-7.88708" />
                <feGaussianBlur stdDeviation="4.66055" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_innerShadow_3361_71"
                  result="effect2_innerShadow_3361_71"
                />
              </filter>
              <filter
                id="filter3_ii_3361_71"
                x="42.1035"
                y="93.4122"
                width="126.19"
                height="148.742"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="16.4911" dy="40.8694" />
                <feGaussianBlur stdDeviation="12.1891" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.651 0 0 0 0 0.58 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_3361_71"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-13.1995" dy="87.1163" />
                <feGaussianBlur stdDeviation="11.8796" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.875 0 0 0 0 0.843 0 0 0 0.48 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_innerShadow_3361_71"
                  result="effect2_innerShadow_3361_71"
                />
              </filter>
              <filter
                id="filter4_ii_3361_71"
                x="55.303"
                y="91.9782"
                width="101.518"
                height="127.948"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="2.15102" dy="-1.43401" />
                <feGaussianBlur stdDeviation="5.37755" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.996078 0 0 0 0 0.458823 0 0 0 0 0.411765 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_3361_71"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="11.4721" dy="2.15102" />
                <feGaussianBlur stdDeviation="2.50953" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_innerShadow_3361_71"
                  result="effect2_innerShadow_3361_71"
                />
              </filter>
              <filter
                id="filter5_ii_3361_71"
                x="40.6627"
                y="43.2495"
                width="207.337"
                height="213.068"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-14.3373" dy="-10.7505" />
                <feGaussianBlur stdDeviation="10.3948" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="hard-light"
                  in2="shape"
                  result="effect1_innerShadow_3361_71"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1.43273" dy="9.31777" />
                <feGaussianBlur stdDeviation="8.96209" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.87451 0 0 0 0 0.843137 0 0 0 0.7 0"
                />
                <feBlend
                  mode="soft-light"
                  in2="effect1_innerShadow_3361_71"
                  result="effect2_innerShadow_3361_71"
                />
              </filter>
              <linearGradient
                id="paint0_linear_3361_71"
                x1="22.1849"
                y1="-0.00000583375"
                x2="256.199"
                y2="294.844"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.0001" stopColor="white" />
                <stop offset={1} stopColor="#F6F8FC" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_3361_71"
                x1="113.255"
                y1="165.397"
                x2="96.4696"
                y2="178.569"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFA794" stopOpacity="0.3" />
                <stop offset={1} stopColor="#FF9794" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_3361_71"
                x1="113.255"
                y1="165.397"
                x2="96.4696"
                y2="178.569"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFA794" stopOpacity="0.3" />
                <stop offset={1} stopColor="#FF9794" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_3361_71"
                x1="111.826"
                y1="208.045"
                x2="129.83"
                y2="191.957"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFDFD7" />
                <stop offset={1} stopColor="#FFDFD7" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_3361_71"
                x1="113.255"
                y1="129.409"
                x2="94.6419"
                y2={148}
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFA794" stopOpacity="0.3" />
                <stop offset={1} stopColor="#FF9794" />
              </linearGradient>
              <linearGradient
                id="paint5_linear_3361_71"
                x1="113.255"
                y1="129.409"
                x2="94.6419"
                y2={148}
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFA794" stopOpacity="0.3" />
                <stop offset={1} stopColor="#FF9794" />
              </linearGradient>
              <linearGradient
                id="paint6_linear_3361_71"
                x1="117.187"
                y1="174.8"
                x2="136.13"
                y2="155.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFA694" />
                <stop offset={1} stopColor="#FFB7A9" />
              </linearGradient>
              <linearGradient
                id="paint7_linear_3361_71"
                x1="214.404"
                y1="183.025"
                x2="83.9528"
                y2="93.3109"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
              <linearGradient
                id="paint8_linear_3361_71"
                x1="214.404"
                y1="183.025"
                x2="83.9528"
                y2="93.3109"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
              <linearGradient
                id="paint9_linear_3361_71"
                x1="214.404"
                y1="183.025"
                x2="83.9528"
                y2="93.3109"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
              <linearGradient
                id="paint10_linear_3361_71"
                x1="214.404"
                y1="183.025"
                x2="83.9528"
                y2="93.3109"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
              <linearGradient
                id="paint11_linear_3361_71"
                x1="214.404"
                y1="183.025"
                x2="83.9528"
                y2="93.3109"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
              <linearGradient
                id="paint12_linear_3361_71"
                x1="214.404"
                y1="183.025"
                x2="83.9528"
                y2="93.3109"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
            </defs>
          </svg>
        </a>
        <div className="sc-hnSKwL dGdhBF">
          <form />
          <button
            color="secondary"
            data-id="NOT_CLICK_OUSIDE_TARGET"
            data-testid="pie-menu-button"
            className="sc-bdfBwQ sc-kTLXwr iyYfOE xuWzS is_visible isLatestVersion"
          >
            <span className="sc-fBVFAa lbofBo">Protopie</span>
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              color="#AAAAAA"
              className="sc-fubCfw hjsCMU sc-hymtyp bjqBjR"
            >
              <path d="M18 9L12 17.5L6 9L18 9Z" fill="black" />
            </svg>
          </button>
        </div>
        <div className="sc-hnSKwL sc-bDfZJo dGdhBF fPEXoP">
          <button
            color="secondary"
            data-id="NOT_CLICK_OUSIDE_TARGET"
            className="sc-bdfBwQ sc-cgwbBY sc-iHlIuj iyYfOE jvPGwS cqgPKv"
          >
            <svg
              width={16}
              height={16}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="sc-fQnAPK jZsgOT"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.65347 4C4.65347 4.55228 4.20576 5 3.65347 5C3.10119 5 2.65347 4.55228 2.65347 4C2.65347 3.44772 3.10119 3 3.65347 3C4.20576 3 4.65347 3.44772 4.65347 4ZM4.65347 8C4.65347 8.55229 4.20576 9 3.65347 9C3.10119 9 2.65347 8.55229 2.65347 8C2.65347 7.44772 3.10119 7 3.65347 7C4.20576 7 4.65347 7.44772 4.65347 8ZM3.65347 13C4.20576 13 4.65347 12.5523 4.65347 12C4.65347 11.4477 4.20576 11 3.65347 11C3.10119 11 2.65347 11.4477 2.65347 12C2.65347 12.5523 3.10119 13 3.65347 13Z"
                fill="black"
              />
              <path
                opacity="0.5"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.66666 3.33334H13.3333V4.66668H6.66666V3.33334ZM6.66666 7.33334H13.3333V8.66668H6.66666V7.33334ZM13.3333 11.3333H6.66666V12.6667H13.3333V11.3333Z"
                fill="black"
              />
            </svg>
            Recordings<span className="sc-dJbtFd idyEqu">0</span>
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              color="#AAAAAA"
              className="sc-fubCfw hjsCMU sc-euehnN dxXwnp"
            >
              <path d="M18 9L12 17.5L6 9L18 9Z" fill="black" />
            </svg>
          </button>
        </div>
      </div>

      <div style={{display:"flex"}} className="sc-jyAgXI sc-caVybk biUqfM cacrKk">
        <div style={{marginLeft:"12px"}}>
        <VeltPresence/>
        </div>
      
        <div style={{marginLeft:"12px"}}>
        <VeltHuddleTool/>
        </div>
        <div style={{marginLeft:"12px"}}>
        <VeltCommentTool/>
        </div>
        
        <div style={{marginLeft:"12px", marginRight:"12px"}}>
        <VeltSidebarButton/>
        </div>

        <button className="sc-eJugXh jyOoHp">
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="sc-iBRIXM fBKyPx"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.0756 7.12771C15.8703 5.92527 14.2086 5.18359 12.3734 5.18359C8.69614 5.18359 5.71518 8.1645 5.71518 11.8416C5.71518 15.5186 8.69614 18.4995 12.3734 18.4995C13.9244 18.4995 15.349 17.9705 16.4806 17.0823C17.5534 16.2402 18.3601 15.0773 18.7571 13.7408L20.6743 14.3103C20.1568 16.0526 19.1071 17.5633 17.7155 18.6555C16.2442 19.8103 14.3879 20.4995 12.3734 20.4995C7.59164 20.4995 3.71518 16.6233 3.71518 11.8416C3.71518 7.05986 7.59164 3.18359 12.3734 3.18359C14.7618 3.18359 16.9243 4.15135 18.4898 5.71361L20.2038 3.99968L20.643 9.15281L15.4897 8.7136L17.0756 7.12771Z"
              fill="#373737"
            />
          </svg>
          <div className="sc-hRYTmC kIeJEV">Restart</div>
        </button>
        <div className="sc-jxTFzB ktDwEE">
          <button
            data-id="NOT_CLICK_OUSIDE_TARGET"
            className="sc-cvFxhb gbUXwN"
          >
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="sc-fubCfw cqjzZd sc-gocZhG iuIkfm"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.9077 4.98009L12 2.13208L9.09226 4.98009L5.02233 5.02233L4.98009 9.09226L2.13208 12L4.98009 14.9077L5.02233 18.9777L9.09226 19.0199L12 21.8679L14.9077 19.0199L18.9777 18.9777L19.0199 14.9077L21.8679 12L19.0199 9.09226L18.9777 5.02233L14.9077 4.98009ZM12 15.4538C13.9075 15.4538 15.4538 13.9075 15.4538 12C15.4538 10.0925 13.9075 8.54623 12 8.54623C10.0925 8.54623 8.54623 10.0925 8.54623 12C8.54623 13.9075 10.0925 15.4538 12 15.4538Z"
                fill="black"
              />
            </svg>
            <div className="sc-hRYTmC kIeJEV">View Options</div>
          </button>
        </div>
        <div style={{marginTop:"4px"}} className="sc-jxTFzB ktDwEE">
          <button
            data-id="NOT_CLICK_OUSIDE_TARGET"
            className="sc-geEHAE kTTBHH isRedDotVisible"
          >
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              color="#373737"
              className="sc-fubCfw cEkgMk sc-cmhfzZ bvVXQw"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3L22 19H2L12 3ZM13 13H11V9H13V13ZM12 14.022C11.3096 14.022 10.75 14.5816 10.75 15.272C10.75 15.9623 11.3096 16.522 12 16.522C12.6904 16.522 13.25 15.9623 13.25 15.272C13.25 14.5816 12.6904 14.022 12 14.022Z"
                fill="black"
              />
            </svg>
            <div className="sc-hRYTmC kIeJEV">Issues with Prototype</div>
          </button>
        </div>
        <div className="sc-jxTFzB ktDwEE">
          <button
            data-id="NOT_CLICK_OUSIDE_TARGET"
            className="sc-bzDAFm eiJKxS"
          >
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              color="#373737"
              className="sc-fubCfw cEkgMk sc-iWBIdD gfVxgZ"
            >
              <rect
                opacity="0.5"
                x={13}
                y={4}
                width={7}
                height={7}
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 13H4V20H11V13ZM13 13H16.5V16.5H13V13ZM16.5 16.5H20V20H16.5V16.5Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 4H4V11H11V4ZM9 6H6V9H9V6Z"
                fill="black"
              />
            </svg>
            <div className="sc-hRYTmC kIeJEV">QR Code</div>
          </button>
        </div>
        <button
          color="primary"
          className="sc-bdfBwQ sc-bHqbil keZaJh sc-bqQUyE cBTVwD"
        >
          Copy link
        </button>
        <a
          color="secondary"
          className="sc-iixZWj kyfAwD"
          href="/login?retUrl=%252Fp%252F5d5a333fdbc83a848cb38105%253F_ga%253D2.33712550.664902746.1700176486-1466398994.1700176486%2526_gac%253D1.89608297.1700176508.Cj0KCQiAmNeqBhD4ARIsADsYfTeq6MvR9TO19PgzsFcti-hUDkKavQkw-6x3Xu9h_huWgIEygkhopf8aAp8OEALw_wcB"
        >
          Login
        </a>
      </div>
    </header>
    <main className="sc-kkNjgz jWOuAp isUiVisible">
      <div
        className="sc-hosATC JCZxq"
        id="PIE_CHILD_LAYERS_1700177867834"
        style={{ backgroundColor: "rgb(245, 245, 245)" }}
      >
        <div
          width={1900}
          height={1200}
          scale="0.5263157894736842"
          className="sc-fMmJVP ezfTOg"
        >
          <div width={1900} height={1200} className="sc-cPSbIS fZuZX" />
          <div
            id="webplayer-root"
            className="sc-dA-DaAA hfgxQL"
            style={{
              userSelect: "none",
              backgroundColor: "rgb(255, 255, 255)",
              width: 1900,
              height: 1200
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: 0,
                boxSizing: "border-box",
                overflow: "hidden"
              }}
            >
              <div
                data-layer-id="_ROOT_"
                data-layer-name="_ROOT_"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  transformOrigin: "0% 0%",
                  opacity: 1,
                  width: 1900,
                  height: 1200
                }}
              >
                <div
                  className="ContainerLayer"
                  style={{
                    position: "absolute",
                    boxSizing: "border-box",
                    transform: "perspective(200px) rotateX(0deg) rotateY(0deg)",
                    transformOrigin: "50% 50%",
                    width: 1900,
                    height: 1200,
                    borderRadius: 0,
                    backgroundColor: "rgb(73, 80, 87)"
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      boxSizing: "border-box",
                      overflow: "hidden",
                      borderRadius: 0
                    }}
                  >
                    <div
                      className="ContainerLayerContent"
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        top: 0,
                        left: 0
                      }}
                    >
                      <div
                        className="ContainerLayer"
                        data-layer-id="d5146bf2-bf38-4e92-a8ef-a9e784c6586e"
                        data-layer-name="maps"
                        style={{
                          position: "absolute",
                          boxSizing: "border-box",
                          pointerEvents: "none",
                          left: 740,
                          top: 0,
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 1160,
                          height: 1009,
                          borderRadius: 0,
                          backgroundColor: "rgba(255, 255, 255, 0)"
                        }}
                      >
                        <svg
                          width="1160px"
                          height="1009px"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            overflow: "visible"
                          }}
                        >
                          <defs />
                          <g>
                            <path />
                          </g>
                        </svg>
                        <div
                          className="ContainerLayerContent"
                          style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0
                          }}
                        >
                          <div
                            data-layer-id="daf2b412-fb6e-4fb7-8d8f-7be1d9d31a45"
                            data-layer-name="map light"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 0,
                              top: 0,
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 1160,
                              height: 1009
                            }}
                          >
                            <img
                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/a7693781852b6582e3c2f76eb22ad3a9020505d4.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9hNzY5Mzc4MTg1MmI2NTgyZTNjMmY3NmViMjJhZDNhOTAyMDUwNWQ0LnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=ZuFaWrcaypz1t60-PT9yZ2zN~mEapJzX~np39Orl86plgs2rtHYIxDz9nBrsxOlscI0zZxYISCXhTMU6RVkTJeDm9KZ8nJgP19nCXXlByK448icC1XRcdv7xvQynycQECRtkRzZrL4bWCGTpZ2CVylC~rfklwS98-kqu1x1g9n0JOoEOKZVht5R6eSq14TraPkyFtJ3TqGPJlfzZXlwkP-KUmsd6EESrJZDdgnuox3yidSOn16l2XiJ0tfmyPmJgNl5A9TlgGN8Nh6xmpU7kg4UmYqRgkwRcDvs2q8c4Bt~OEvB55rlmZ1sJeXrrtIs-x8luOiwHfQeWL0~E8EpAgg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                              style={{
                                objectFit: "cover",
                                position: "absolute",
                                boxSizing: "border-box",
                                width: "100%",
                                height: "100%",
                                display: "block",
                                opacity: 1,
                                clipPath: 'url("#pp-gen-3")'
                              }}
                            />
                            <svg
                              width="1160px"
                              height="1009px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs>
                                <clipPath id="pp-gen-3">
                                  <path
                                    d="
                  M0,0 
                  h1160 a0,0 0 0 1 0,0 
                  v1009 a0,0 0 0 1 -0,0 
                  h-1160 a0,0 0 0 1 -0,-0 
                  v-1009 a0,0 0 0 1 0,-0 
                  z
              "
                                  />
                                </clipPath>
                              </defs>
                              <g>
                                <path
                                  fill="rgba(210,210,210,0)"
                                  d="
                  M0,0 
                  h1160 a0,0 0 0 1 0,0 
                  v1009 a0,0 0 0 1 -0,0 
                  h-1160 a0,0 0 0 1 -0,-0 
                  v-1009 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                          </div>
                          <div
                            data-layer-id="c788028c-2ad5-40b2-b134-dfb2e3b5e13e"
                            data-layer-name="map dark"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 0,
                              top: 0,
                              transformOrigin: "0% 0%",
                              opacity: 0,
                              width: 1160,
                              height: 1009
                            }}
                          >
                            <img
                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/9267e3a74806c9853b9d7fd71ad91386a9b0ba11.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy85MjY3ZTNhNzQ4MDZjOTg1M2I5ZDdmZDcxYWQ5MTM4NmE5YjBiYTExLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=Q~NCinh4oEH-owoVrQ4GL8gqB6THxJ6jWyTCcnu4Z9iPXaVIiGYE4hZg~SmDjUqR21PYaE4D78YO9h80rWrm9woPzLrhMhs5PrAnkSSl49DyHB9LDv6zprCw8lahs-bnbkkzYOxqVJ8M-VgvCyH7Wg8XzvecFTiBdAsnMBascE16txi6D~1fgwjKRl7brVqeqlp-5TTTGXRZeReNIBUGd7UBRjsn3d3Uxd7Q2YK1zGV8n21gvB~7vXGWYvos8woEha0a3tnW~YxR4jZ0gjnIhbDgYk3j6HdSxkFdt7qLxNy0Z2NwJ8YzVopZ7EYJzFMwDjPx28Ae95G1zdKV6L~K7Q__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                              style={{
                                objectFit: "cover",
                                position: "absolute",
                                boxSizing: "border-box",
                                width: "100%",
                                height: "100%",
                                display: "block",
                                opacity: 1,
                                clipPath: 'url("#pp-gen-4")'
                              }}
                            />
                            <svg
                              width="1160px"
                              height="1009px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs>
                                <clipPath id="pp-gen-4">
                                  <path
                                    d="
                  M0,0 
                  h1160 a0,0 0 0 1 0,0 
                  v1009 a0,0 0 0 1 -0,0 
                  h-1160 a0,0 0 0 1 -0,-0 
                  v-1009 a0,0 0 0 1 0,-0 
                  z
              "
                                  />
                                </clipPath>
                              </defs>
                              <g>
                                <path
                                  fill="rgba(210,210,210,0)"
                                  d="
                  M0,0 
                  h1160 a0,0 0 0 1 0,0 
                  v1009 a0,0 0 0 1 -0,0 
                  h-1160 a0,0 0 0 1 -0,-0 
                  v-1009 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div
                        data-layer-id="cf408b2d-236c-4d4b-ab55-be290f9c6cf6"
                        data-layer-name="Rectangle 16"
                        style={{
                          position: "absolute",
                          boxSizing: "border-box",
                          pointerEvents: "none",
                          left: 740,
                          top: 630,
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 1160,
                          height: 470
                        }}
                      >
                        <svg
                          width="1160px"
                          height="470px"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            overflow: "visible"
                          }}
                        >
                          <defs>
                            <filter
                              id="pp-gen-1"
                              filterUnits="objectBoundingBox"
                              colorInterpolationFilters="sRGB"
                              x="-1%"
                              y="-2%"
                              width="101%"
                              height="103%"
                            >
                              <feOffset
                                in="SourceAlpha"
                                result="step0"
                                dx={0}
                                dy={-4}
                              />
                              <feGaussianBlur
                                in="step0"
                                result="step1"
                                stdDeviation={2}
                              />
                              <feComposite
                                in="step1"
                                result="step2"
                                in2="SourceAlpha"
                                operator="out"
                              />
                              <feColorMatrix
                                in="step2"
                                values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.15 0"
                                type="matrix"
                              />
                            </filter>
                          </defs>
                          <g>
                            <path
                              fill="black"
                              fillOpacity={1}
                              filter="url(#pp-gen-1)"
                              d="
                  M0,0 
                  h1160 a0,0 0 0 1 0,0 
                  v470 a0,0 0 0 1 -0,0 
                  h-1160 a0,0 0 0 1 -0,-0 
                  v-470 a0,0 0 0 1 0,-0 
                  z
              "
                            />
                            <path
                              fill="rgba(255,255,255,1)"
                              d="
                  M0,0 
                  h1160 a0,0 0 0 1 0,0 
                  v470 a0,0 0 0 1 -0,0 
                  h-1160 a0,0 0 0 1 -0,-0 
                  v-470 a0,0 0 0 1 0,-0 
                  z
              "
                            />
                          </g>
                        </svg>
                      </div>
                      <div
                        data-layer-id="c6d72c98-ea83-481f-ad1a-0c6565097ed2"
                        data-layer-name="Rectangle 5"
                        style={{
                          position: "absolute",
                          boxSizing: "border-box",
                          pointerEvents: "none",
                          left: 0,
                          top: 0,
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 740,
                          height: 1100
                        }}
                      >
                        <svg
                          width="740px"
                          height="1100px"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            overflow: "visible"
                          }}
                        >
                          <defs>
                            <filter
                              id="pp-gen-2"
                              filterUnits="objectBoundingBox"
                              colorInterpolationFilters="sRGB"
                              x="-1%"
                              y="-1%"
                              width="102%"
                              height="101%"
                            >
                              <feOffset
                                in="SourceAlpha"
                                result="step0"
                                dx={4}
                                dy={0}
                              />
                              <feGaussianBlur
                                in="step0"
                                result="step1"
                                stdDeviation={2}
                              />
                              <feComposite
                                in="step1"
                                result="step2"
                                in2="SourceAlpha"
                                operator="out"
                              />
                              <feColorMatrix
                                in="step2"
                                values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.25 0"
                                type="matrix"
                              />
                            </filter>
                          </defs>
                          <g>
                            <path
                              fill="black"
                              fillOpacity={1}
                              filter="url(#pp-gen-2)"
                              d="
                  M0,0 
                  h740 a0,0 0 0 1 0,0 
                  v1100 a0,0 0 0 1 -0,0 
                  h-740 a0,0 0 0 1 -0,-0 
                  v-1100 a0,0 0 0 1 0,-0 
                  z
              "
                            />
                            <path
                              fill="rgba(247,247,247,1)"
                              d="
                  M0,0 
                  h740 a0,0 0 0 1 0,0 
                  v1100 a0,0 0 0 1 -0,0 
                  h-740 a0,0 0 0 1 -0,-0 
                  v-1100 a0,0 0 0 1 0,-0 
                  z
              "
                            />
                          </g>
                        </svg>
                      </div>
                      <div
                        className="ContainerLayer"
                        data-layer-id="33916be7-d585-4ab0-93ee-b3bf4839d7c0"
                        data-layer-name="weather"
                        style={{
                          position: "absolute",
                          boxSizing: "border-box",
                          pointerEvents: "none",
                          left: 0,
                          top: 0,
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 1900,
                          height: 1100,
                          borderRadius: 0,
                          backgroundColor: "rgba(255, 255, 255, 0)"
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            boxSizing: "border-box",
                            overflow: "hidden",
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="ContainerLayerContent"
                            style={{
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              top: 0,
                              left: 0
                            }}
                          >
                            <div
                              data-layer-id="5c3452bf-19b9-4066-9fd7-9b6a25bee546"
                              data-layer-name="sky"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible",
                                pointerEvents: "none",
                                transformOrigin: "0% 0%",
                                opacity: 0,
                                width: 740,
                                height: 519
                              }}
                            >
                              <img
                                src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/7fa4088ea93efa94dbd31f206b887f98cfa0fd76.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy83ZmE0MDg4ZWE5M2VmYTk0ZGJkMzFmMjA2Yjg4N2Y5OGNmYTBmZDc2LnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=GzdNOu9LvNZLhr4ezNKzcPYUxoS9UvH9wbChQN8FhFDcJ9K~i-7VXon9A6HUYncmZNAluu99Go6tLcfHOgtA5hko6FhIJVrqq0-8xJE1UQaEyL76kexvUrZcnIyGhOC55nuskWsrMF2kjiKK0BZdpBdesEY6fvmJCOxRFZVxcaJI3rxgKXvvsC9haoC0UcSK1Jtv-bVakKV7I4tBwOcOLajENcWz8YJ35fox-GEg4CIqzYbl-6uMna5iEoP~sEXFlWZQQmJKhyXS2Rj4C0OHMIsTL~t1IZncJMh3TR0i5dxWyAMV8MNue--OgJk7K8lGzKkiBTwRnmlB~CEReGP~ZQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: 0
                                }}
                              />
                              <svg
                                width="740px"
                                height="519px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                            </div>
                            <div
                              data-layer-id="d3862420-ebf5-4d92-bdc8-5ca159e3c21b"
                              data-layer-name="stars"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: 0,
                                top: 0,
                                transformOrigin: "0% 0%",
                                opacity: 0,
                                width: 738,
                                height: 555
                              }}
                            >
                              <img
                                src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/8a28718cbd9d14e189851d46a58426f91a301c79.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy84YTI4NzE4Y2JkOWQxNGUxODk4NTFkNDZhNTg0MjZmOTFhMzAxYzc5LnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=J7xFJyQuHOxUBWXX31BVsgQOp0I6Vz~iIr8cwOfaz-j6fvHo5A30RNL88Fd8s7eKdYFCIufAxeExe5Vn5VUZdyYEsMZZmPchT3wBkXDpZbHAXEQTWUgoS9OLM4fHtgEIVpb7dggEuQqF4yB5llurWZDMDvwN0q3aKGQY0aHp8VZLX0ifkY6cNDdQrRthvmku4Vnpq8RmiF6Ilgj4KRI1Cf5bvy2qZ7qeJaJIqwzEBGm92ptX9oo2lDR3XacjJV7Du00BE~pZsBjlibzOlthzs5kFDc1YGUR4FCIrv-8Rdx3EakUcN-po-zgiwPhqvxWXkvUo7pwTdQgc98rQOE-HRQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                style={{
                                  objectFit: "fill",
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  width: "100%",
                                  height: "100%",
                                  display: "block",
                                  opacity: 1,
                                  clipPath: 'url("#pp-gen-5")'
                                }}
                              />
                              <svg
                                width="738px"
                                height="555px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs>
                                  <clipPath id="pp-gen-5">
                                    <path
                                      d="
                  M0,0 
                  h738 a0,0 0 0 1 0,0 
                  v555 a0,0 0 0 1 -0,0 
                  h-738 a0,0 0 0 1 -0,-0 
                  v-555 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </clipPath>
                                </defs>
                                <g>
                                  <path
                                    fill="rgba(210,210,210,0)"
                                    d="
                  M0,0 
                  h738 a0,0 0 0 1 0,0 
                  v555 a0,0 0 0 1 -0,0 
                  h-738 a0,0 0 0 1 -0,-0 
                  v-555 a0,0 0 0 1 0,-0 
                  z
              "
                                  />
                                </g>
                              </svg>
                            </div>
                            <div
                              data-layer-id="e24f2994-9e62-4434-bb73-bea9285ffeb0"
                              data-layer-name="sun"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: "-326px",
                                top: "-404px",
                                transformOrigin: "0% 0%",
                                opacity: 0,
                                width: 1833,
                                height: 1345
                              }}
                            >
                              <img
                                src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/396253d59d0b66d3165b09befa5b4daed860b9dd.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8zOTYyNTNkNTlkMGI2NmQzMTY1YjA5YmVmYTViNGRhZWQ4NjBiOWRkLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=RX5S7Rw9k0fljhCbU6V-rq~dJ5HeGrytqgRPKXjLIlUYKAO21AkCDGdCIjjtHbGuedvvB-TAuQttoMykRyALLtrwdBvJwH07APp-d3bJEZsj6Tah2zmm7rcCk3h-lOWVgS~I3izstIvcjJBbEM38-09Gwf~NuPKM5TM9caPXqxApaySuj9l6wEn6OickEY6RBjgbCxyCePRxUrywY8-mgeowpIjt7mJZ02ytfTzBzkQ-uAxdA-OV~DJ03gHMH-ZC7E6MHFzvA0YwS0qmO3FwxsU9fuFj0suCUbRvzurkmWQgoEQTAyiejg-L2yh~i3Z-tBL0uOC3va39AyNbUaw6Rg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                style={{
                                  objectFit: "fill",
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  width: "100%",
                                  height: "100%",
                                  display: "block",
                                  opacity: 1,
                                  clipPath: 'url("#pp-gen-6")'
                                }}
                              />
                              <svg
                                width="1833px"
                                height="1345px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs>
                                  <clipPath id="pp-gen-6">
                                    <path
                                      d="
                  M0,0 
                  h1833 a0,0 0 0 1 0,0 
                  v1345 a0,0 0 0 1 -0,0 
                  h-1833 a0,0 0 0 1 -0,-0 
                  v-1345 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </clipPath>
                                </defs>
                                <g>
                                  <path
                                    fill="rgba(210,210,210,0)"
                                    d="
                  M0,0 
                  h1833 a0,0 0 0 1 0,0 
                  v1345 a0,0 0 0 1 -0,0 
                  h-1833 a0,0 0 0 1 -0,-0 
                  v-1345 a0,0 0 0 1 0,-0 
                  z
              "
                                  />
                                </g>
                              </svg>
                            </div>
                            <div
                              data-layer-id="39aebba2-0b02-4044-afa9-8e4618ed2c53"
                              data-layer-name="moon"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: 360,
                                top: "-53px",
                                transformOrigin: "0% 0%",
                                opacity: 0,
                                width: 200,
                                height: 202
                              }}
                            >
                              <img
                                src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/c42e982fd9006cfdb9eb48a2552102de003868bb.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9jNDJlOTgyZmQ5MDA2Y2ZkYjllYjQ4YTI1NTIxMDJkZTAwMzg2OGJiLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=S9jtPb6CNFy~e1nwlafskTJzOpqyYATRah7fzpsXZd2cb8~ZP5KOHG2S93g8tX6Dum~DzS3lysdpgvROEJpPEumv2Gr7bJh8zEcLhZpT0i5flp9FkD3em4ydAN0qFpOmNtLjdxbPpsoeq~xskDssrob6uURBBynzywpM~2uHKePi2sLoXvPjwaxkwyzR2-ruseLTKz0k3fE2SqM20gPviC1AvryA5vxh~YZSN0TnEg10GG-7aRCoezsPR6m4748Gs3SKHFHg1eJW7N5Z0r2XcDVTeQ8Nioh7WiE9HMXKsdQULBEKBXVe9RTwYQmjBOgF9ueat4Bia5Vaz8I57A~piw__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                style={{
                                  objectFit: "fill",
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  width: "100%",
                                  height: "100%",
                                  display: "block",
                                  opacity: 1,
                                  clipPath: 'url("#pp-gen-7")'
                                }}
                              />
                              <svg
                                width="200px"
                                height="202px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs>
                                  <clipPath id="pp-gen-7">
                                    <path
                                      d="
                  M0,0 
                  h200 a0,0 0 0 1 0,0 
                  v202 a0,0 0 0 1 -0,0 
                  h-200 a0,0 0 0 1 -0,-0 
                  v-202 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </clipPath>
                                </defs>
                                <g>
                                  <path
                                    fill="rgba(210,210,210,0)"
                                    d="
                  M0,0 
                  h200 a0,0 0 0 1 0,0 
                  v202 a0,0 0 0 1 -0,0 
                  h-200 a0,0 0 0 1 -0,-0 
                  v-202 a0,0 0 0 1 0,-0 
                  z
              "
                                  />
                                </g>
                              </svg>
                            </div>
                            <div
                              data-layer-id="5f46d547-ba15-453b-a239-6db2566c7efc"
                              data-layer-name="rain"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: 0,
                                top: 0,
                                transformOrigin: "0% 0%",
                                opacity: 0,
                                width: 1900,
                                height: 1200
                              }}
                            >
                              <img
                                src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/e57456ac8620fbfc5d917fdb0e721deaf17498aa.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9lNTc0NTZhYzg2MjBmYmZjNWQ5MTdmZGIwZTcyMWRlYWYxNzQ5OGFhLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=OnptGLbrWEjTanODBIr1k4PrjemR414OtVCxBArleiez93gw1XpcT5P1txMooRpnd5LdCcSOotmsXkP9~BE~K3twlP-34lUIlWM1m38MBQG7uzkZjiOkKsMud5IgtXJBBe-aerfdmhj91FEngz1dzgnw0kG8x1ccVmEpPtylGm98XbtbPw~~kvLhF3ur0FknDaMyKejvHZoVuvfEEqA9m4IYjJROFqI0Mqq4WhDS~CgOTZ~OoIDk-ZrlelPfu-Pv-uumuC-jyzOlY9mzXrKxwvOk5IbJLnxODew5C3k3hDSs6NrpOBmYdZM8SwFU7pfjaJXAL-WPsG3fsMzSM2AcZQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                style={{
                                  objectFit: "fill",
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  width: "100%",
                                  height: "100%",
                                  display: "block",
                                  opacity: 1,
                                  clipPath: 'url("#pp-gen-8")'
                                }}
                              />
                              <svg
                                width="1900px"
                                height="1200px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs>
                                  <clipPath id="pp-gen-8">
                                    <path
                                      d="
                  M0,0 
                  h1900 a0,0 0 0 1 0,0 
                  v1200 a0,0 0 0 1 -0,0 
                  h-1900 a0,0 0 0 1 -0,-0 
                  v-1200 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </clipPath>
                                </defs>
                                <g>
                                  <path
                                    fill="rgba(210,210,210,0)"
                                    d="
                  M0,0 
                  h1900 a0,0 0 0 1 0,0 
                  v1200 a0,0 0 0 1 -0,0 
                  h-1900 a0,0 0 0 1 -0,-0 
                  v-1200 a0,0 0 0 1 0,-0 
                  z
              "
                                  />
                                </g>
                              </svg>
                            </div>
                            <div
                              className="ContainerLayer"
                              data-layer-id="4e669877-ffc3-4326-9404-743cb295ad7d"
                              data-layer-name="clouds"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: "-940px",
                                top: "-668px",
                                transformOrigin: "0% 0%",
                                opacity: 0,
                                width: 3473,
                                height: 2298,
                                borderRadius: 0,
                                backgroundColor: "rgba(255, 255, 255, 0)"
                              }}
                            >
                              <svg
                                width="3473px"
                                height="2298px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                              <div
                                className="ContainerLayerContent"
                                style={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "100%",
                                  top: 0,
                                  left: 0
                                }}
                              >
                                <div
                                  data-layer-id="a9dcdfb2-9161-4ea2-9a59-f22b9b6e755d"
                                  data-layer-name="image 31"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 0,
                                    top: 0,
                                    transformOrigin: "0% 0%",
                                    opacity: "0.6",
                                    width: 1920,
                                    height: 1440
                                  }}
                                >
                                  <img
                                    src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/91b3b5a035891ab748ebfa3e2670b8ad1eb6faf9.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy85MWIzYjVhMDM1ODkxYWI3NDhlYmZhM2UyNjcwYjhhZDFlYjZmYWY5LnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=VC8ofdS7~oJVgGyHwGVdJ88N8YTlA9PLi7Mhe9UgfEVgfml-yfAEXv479jjRj2WhM3J5pkv2Mu85UPgJ-x0Xw7Q-oCuv~0cBjFC4Ifp9MTqtjfgsjiUS~aNeEPA0IjvIaHW0MNoBcPk9UbaY7le~6EjrpE6qW93qEjzaEkRbaTxW7prrdeWue1DncLnIPAcWPa-KKGPsJZUIBduYPgwgRabd2POqhXxnRzQZMVTmmiOKGDcuclzE21eSw-YLIMS4R2mnax4fphqCa~mUW1u9xONznV97SAOlUgIa4r5BrHcU1t8Nt4wVsFuHwRvKdaCk2iI8nQk67C85bYAvMxPPSw__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                    style={{
                                      objectFit: "fill",
                                      position: "absolute",
                                      boxSizing: "border-box",
                                      width: "100%",
                                      height: "100%",
                                      display: "block",
                                      opacity: 1,
                                      clipPath: 'url("#pp-gen-14")'
                                    }}
                                  />
                                  <svg
                                    width="1920px"
                                    height="1440px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible"
                                    }}
                                  >
                                    <defs>
                                      <clipPath id="pp-gen-14">
                                        <path
                                          d="
                  M0,0 
                  h1920 a0,0 0 0 1 0,0 
                  v1440 a0,0 0 0 1 -0,0 
                  h-1920 a0,0 0 0 1 -0,-0 
                  v-1440 a0,0 0 0 1 0,-0 
                  z
              "
                                        />
                                      </clipPath>
                                    </defs>
                                    <g>
                                      <path
                                        fill="rgba(210,210,210,0)"
                                        d="
                  M0,0 
                  h1920 a0,0 0 0 1 0,0 
                  v1440 a0,0 0 0 1 -0,0 
                  h-1920 a0,0 0 0 1 -0,-0 
                  v-1440 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </g>
                                  </svg>
                                </div>
                                <div
                                  data-layer-id="7f6e8b4a-fadb-414a-9753-b0bf57478600"
                                  data-layer-name="image 32"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 1553,
                                    top: 1239,
                                    transformOrigin: "0% 0%",
                                    opacity: 1,
                                    width: 1920,
                                    height: 1059
                                  }}
                                >
                                  <img
                                    src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/a4d8f692d05ab8388fe4644626f397ab8bdc465e.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9hNGQ4ZjY5MmQwNWFiODM4OGZlNDY0NDYyNmYzOTdhYjhiZGM0NjVlLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=OcChPTUycEVDCIpQPdqVH9YJbkSvuYYKbxufixJFB~C2RbIJntuHRzori2MqUFBhTvlbmZirhxRMOsUNZMOxllNpAj5lb4vuu9XB6GHcI~eRmsJdyzddoxbBrv-GMzqWSzmBGnxYYAd5dCS2Otuenoa0BUeSchxvGoq60bh8TgJvhZEmLofXq6nKXDr6oMOogEvQt~nS6G-8LnmSPdYzkkl33R~fypp-2oMU8L11uNgGz1LgvNf-ZM5nySMm7mL~FXQg4xgPVfuS903PfgOSOeivT6eQvIe-unJ9LhRQLdNmNVqHFjHrngcX8ypSXHvcVc2QSnMtWnTooy6hcQbGuQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                    style={{
                                      objectFit: "fill",
                                      position: "absolute",
                                      boxSizing: "border-box",
                                      width: "100%",
                                      height: "100%",
                                      display: "block",
                                      opacity: 1,
                                      clipPath: 'url("#pp-gen-15")'
                                    }}
                                  />
                                  <svg
                                    width="1920px"
                                    height="1059px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible"
                                    }}
                                  >
                                    <defs>
                                      <clipPath id="pp-gen-15">
                                        <path
                                          d="
                  M0,0 
                  h1920 a0,0 0 0 1 0,0 
                  v1059 a0,0 0 0 1 -0,0 
                  h-1920 a0,0 0 0 1 -0,-0 
                  v-1059 a0,0 0 0 1 0,-0 
                  z
              "
                                        />
                                      </clipPath>
                                    </defs>
                                    <g>
                                      <path
                                        fill="rgba(210,210,210,0)"
                                        d="
                  M0,0 
                  h1920 a0,0 0 0 1 0,0 
                  v1059 a0,0 0 0 1 -0,0 
                  h-1920 a0,0 0 0 1 -0,-0 
                  v-1059 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </g>
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="ContainerLayer"
                              data-layer-id="c695a230-e5f8-4c63-a33d-3a3b9ca120f9"
                              data-layer-name="dark clouds"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: "-866px",
                                top: "-505px",
                                transformOrigin: "0% 0%",
                                opacity: 0,
                                width: 3472,
                                height: 2262,
                                borderRadius: 0,
                                backgroundColor: "rgba(255, 255, 255, 0)"
                              }}
                            >
                              <svg
                                width="3472px"
                                height="2262px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                              <div
                                className="ContainerLayerContent"
                                style={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "100%",
                                  top: 0,
                                  left: 0
                                }}
                              >
                                <div
                                  data-layer-id="25d99eee-3eb8-477a-a87a-967a1245313e"
                                  data-layer-name="image 33"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 0,
                                    top: 0,
                                    transformOrigin: "0% 0%",
                                    opacity: "0.8",
                                    width: 1920,
                                    height: 1080
                                  }}
                                >
                                  <img
                                    src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/2f200c66fd3cdc3ebff9f8808336dbbd01445142.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8yZjIwMGM2NmZkM2NkYzNlYmZmOWY4ODA4MzM2ZGJiZDAxNDQ1MTQyLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=VE8j3uELkDZKh6HkRMVz9rGMBAoBYH-FwqnZ0Bls9jI6do3W6nkdX1ht49M7~CTGNNtpF6-jVAdVXmfH~yySKNOk9-Q4UaQ1aY8ZBHqd49-ZvlVviSDSnVZcoocMStCwRvTYGGBVtRqTOadhk2qfOpM3zDpaQePH5CM0XLlo8dw5xsSnzK6vAI-UqMEAaZmNeojnJaqrH~qvs-qxP-Nmx9lqtAy1tP6BuOEvrtSsreKZZm0hsMtS7AG9Jxp3uTD0G10NRzOxP3DyveDvHTXg0xxolU-ifqaOZFvhdobUfGMg~t-c6-kRUaHEGmg8dkLPPDSw-r-KNhXv0sHpkHW1ww__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                    style={{
                                      objectFit: "fill",
                                      position: "absolute",
                                      boxSizing: "border-box",
                                      width: "100%",
                                      height: "100%",
                                      display: "block",
                                      opacity: 1,
                                      clipPath: 'url("#pp-gen-16")'
                                    }}
                                  />
                                  <svg
                                    width="1920px"
                                    height="1080px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible"
                                    }}
                                  >
                                    <defs>
                                      <clipPath id="pp-gen-16">
                                        <path
                                          d="
                  M0,0 
                  h1920 a0,0 0 0 1 0,0 
                  v1080 a0,0 0 0 1 -0,0 
                  h-1920 a0,0 0 0 1 -0,-0 
                  v-1080 a0,0 0 0 1 0,-0 
                  z
              "
                                        />
                                      </clipPath>
                                    </defs>
                                    <g>
                                      <path
                                        fill="rgba(210,210,210,0)"
                                        d="
                  M0,0 
                  h1920 a0,0 0 0 1 0,0 
                  v1080 a0,0 0 0 1 -0,0 
                  h-1920 a0,0 0 0 1 -0,-0 
                  v-1080 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </g>
                                  </svg>
                                </div>
                                <div
                                  data-layer-id="1637a62b-ef4a-4e1d-83f6-72b139aa2308"
                                  data-layer-name="image 34"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 1552,
                                    top: 1182,
                                    transformOrigin: "0% 0%",
                                    opacity: "0.8",
                                    width: 1920,
                                    height: 1080
                                  }}
                                >
                                  <img
                                    src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/2f200c66fd3cdc3ebff9f8808336dbbd01445142.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8yZjIwMGM2NmZkM2NkYzNlYmZmOWY4ODA4MzM2ZGJiZDAxNDQ1MTQyLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=VE8j3uELkDZKh6HkRMVz9rGMBAoBYH-FwqnZ0Bls9jI6do3W6nkdX1ht49M7~CTGNNtpF6-jVAdVXmfH~yySKNOk9-Q4UaQ1aY8ZBHqd49-ZvlVviSDSnVZcoocMStCwRvTYGGBVtRqTOadhk2qfOpM3zDpaQePH5CM0XLlo8dw5xsSnzK6vAI-UqMEAaZmNeojnJaqrH~qvs-qxP-Nmx9lqtAy1tP6BuOEvrtSsreKZZm0hsMtS7AG9Jxp3uTD0G10NRzOxP3DyveDvHTXg0xxolU-ifqaOZFvhdobUfGMg~t-c6-kRUaHEGmg8dkLPPDSw-r-KNhXv0sHpkHW1ww__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                    style={{
                                      objectFit: "fill",
                                      position: "absolute",
                                      boxSizing: "border-box",
                                      width: "100%",
                                      height: "100%",
                                      display: "block",
                                      opacity: 1,
                                      clipPath: 'url("#pp-gen-17")'
                                    }}
                                  />
                                  <svg
                                    width="1920px"
                                    height="1080px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible"
                                    }}
                                  >
                                    <defs>
                                      <clipPath id="pp-gen-17">
                                        <path
                                          d="
                  M0,0 
                  h1920 a0,0 0 0 1 0,0 
                  v1080 a0,0 0 0 1 -0,0 
                  h-1920 a0,0 0 0 1 -0,-0 
                  v-1080 a0,0 0 0 1 0,-0 
                  z
              "
                                        />
                                      </clipPath>
                                    </defs>
                                    <g>
                                      <path
                                        fill="rgba(210,210,210,0)"
                                        d="
                  M0,0 
                  h1920 a0,0 0 0 1 0,0 
                  v1080 a0,0 0 0 1 -0,0 
                  h-1920 a0,0 0 0 1 -0,-0 
                  v-1080 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </g>
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              data-layer-id="b8737b46-36d5-4227-86f6-c824dad26785"
                              data-layer-name="mist"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: "-20px",
                                top: 20,
                                transformOrigin: "0% 0%",
                                opacity: 0,
                                width: 1920,
                                height: 1080
                              }}
                            >
                              <img
                                src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/aa7d4187358a9a137764cd7d37e3c2253238cd62.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9hYTdkNDE4NzM1OGE5YTEzNzc2NGNkN2QzN2UzYzIyNTMyMzhjZDYyLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=BDcF79ewF2GUDXfuNVJZIdZajXZYS4jsv9jk3xv3dR8y9Y2kPqUij3n9mIoSshHhCXP8db-elOkqaFXycrUU4nOtOL3CS8doqBhu0HCBZJX2JPAvYE9H-Y9DJ6aZKgKZ5uAg2FBlGgYMBS-irrHBZ4aew4u-XncnjTgKcMSYR5PQVip4HXk4Pwi1CCMHhmrZDhmz84drWmx~p1GBnuoprSpRv5Yse2yfLcpP6EvH087yaqo2nb47kSkl5Kq73bEbV587~dtFr3i~6BKajcuDhI~wcz~RgRwPBia38DtZIPU14cbhVQQP5MGgIyZcOBPmOUoRArPCHvT7DxYVnIGXLg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                style={{
                                  objectFit: "fill",
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  width: "100%",
                                  height: "100%",
                                  display: "block",
                                  opacity: 1,
                                  clipPath: 'url("#pp-gen-9")'
                                }}
                              />
                              <svg
                                width="1920px"
                                height="1080px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs>
                                  <clipPath id="pp-gen-9">
                                    <path
                                      d="
                  M0,0 
                  h1920 a0,0 0 0 1 0,0 
                  v1080 a0,0 0 0 1 -0,0 
                  h-1920 a0,0 0 0 1 -0,-0 
                  v-1080 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </clipPath>
                                </defs>
                                <g>
                                  <path
                                    fill="rgba(210,210,210,0)"
                                    d="
                  M0,0 
                  h1920 a0,0 0 0 1 0,0 
                  v1080 a0,0 0 0 1 -0,0 
                  h-1920 a0,0 0 0 1 -0,-0 
                  v-1080 a0,0 0 0 1 0,-0 
                  z
              "
                                  />
                                </g>
                              </svg>
                            </div>
                            <div
                              data-layer-id="0fe5d766-1ac3-4aba-940e-ac70e51bb3d3"
                              data-layer-name="snow"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: 0,
                                top: 0,
                                transformOrigin: "0% 0%",
                                opacity: 0,
                                width: 1900,
                                height: 1100
                              }}
                            >
                              <img
                                src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/974b756820cbd3c9fb6215d97fee2f4ff8d1bb6d.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy85NzRiNzU2ODIwY2JkM2M5ZmI2MjE1ZDk3ZmVlMmY0ZmY4ZDFiYjZkLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=fFVrLhqom4MtpZ1zxuDkFohws7O0c3PGSwsHk-9r6XX3BWgBZ9DNsXN4T0KgZTnNY~hcVkOB3Au60KTqCoxNl-ajQk-o44x7daIPFqEAhv6-P0g3Hy8s6pKRhkHaGHOp-9HqDiPdnJPleViHO42uCe-iLdM741oq9OvU~EjhSuWFiFw3S4Ru57Wx8rhIn2yNP~IlbSWE1lu25oigEbwAYttWxDFpWoB0OH5JQgJl1MRHCKkGAWqL8M558KUN8rT8QUaal~U3V1BD-bkx7qJOWA3I2Vs0RYVYJV43mpN2vUVNohpBHhw8QGmLxOyQo9lb4qK8ntunN8~wxaekOFBNvA__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                style={{
                                  objectFit: "fill",
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  width: "100%",
                                  height: "100%",
                                  display: "block",
                                  opacity: 1,
                                  clipPath: 'url("#pp-gen-10")'
                                }}
                              />
                              <svg
                                width="1900px"
                                height="1100px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs>
                                  <clipPath id="pp-gen-10">
                                    <path
                                      d="
                  M0,0 
                  h1900 a0,0 0 0 1 0,0 
                  v1100 a0,0 0 0 1 -0,0 
                  h-1900 a0,0 0 0 1 -0,-0 
                  v-1100 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </clipPath>
                                </defs>
                                <g>
                                  <path
                                    fill="rgba(210,210,210,0)"
                                    d="
                  M0,0 
                  h1900 a0,0 0 0 1 0,0 
                  v1100 a0,0 0 0 1 -0,0 
                  h-1900 a0,0 0 0 1 -0,-0 
                  v-1100 a0,0 0 0 1 0,-0 
                  z
              "
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <svg
                          width="1900px"
                          height="1100px"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            overflow: "visible",
                            pointerEvents: "none"
                          }}
                        >
                          <defs />
                          <g>
                            <path />
                          </g>
                        </svg>
                      </div>
                      <div
                        className="ContainerLayer"
                        data-layer-id="1ba5dfa4-c85d-4bdd-8879-b9d7802820e9"
                        data-layer-name="car info"
                        style={{
                          position: "absolute",
                          boxSizing: "border-box",
                          pointerEvents: "none",
                          left: 60,
                          top: 325,
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 608,
                          height: 341,
                          borderRadius: 0,
                          backgroundColor: "rgba(255, 255, 255, 0)"
                        }}
                      >
                        <svg
                          width="608px"
                          height="341px"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            overflow: "visible"
                          }}
                        >
                          <defs />
                          <g>
                            <path />
                          </g>
                        </svg>
                        <div
                          className="ContainerLayerContent"
                          style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0
                          }}
                        >
                          <div
                            data-layer-id="248faedd-7d19-4cff-9a9b-8e620d19b618"
                            data-layer-name="tesla"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 0,
                              top: 75,
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 600,
                              height: 267
                            }}
                          >
                            <img
                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/58b7498b1211e01370bb5f2972b050b27ee7a6c0.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy81OGI3NDk4YjEyMTFlMDEzNzBiYjVmMjk3MmIwNTBiMjdlZTdhNmMwLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=N00aK3NvV0IlcioBYgxdJTxEYsQ8IbvzidoL4JE2nTcD92Tao-aOBUbnHmMcYbRAMhLWHGtP~b9eRHzg0K8MU4a5QECErUATatNVpnPh3L8vzpAR9k8xBxNd9gQ~4wXM0hcZIC8RybtUPNW28hRAYuESh5awMFJBfuAPf2t9KyXo0r2uMUbj7wltcMUXjNzwZzH~wH4YRZmyilMcZBtbFBKqlSxZz2~ttmoxgzxgx~RzJSmcIInHH6vzlp~IbcAAGUeQ2j4WKwYtsKXUVNEp-bGnCTymMmLF3fXlAJdezscYOFNolxhiDNBsokeg6C-AIfFBB3a8ONeMgOl2EWg1Ag__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                              style={{
                                objectFit: "fill",
                                position: "absolute",
                                boxSizing: "border-box",
                                width: "100%",
                                height: "100%",
                                display: "block",
                                opacity: 1,
                                clipPath: 'url("#pp-gen-11")'
                              }}
                            />
                            <svg
                              width="600px"
                              height="267px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs>
                                <clipPath id="pp-gen-11">
                                  <path
                                    d="
                  M0,0 
                  h600 a0,0 0 0 1 0,0 
                  v267 a0,0 0 0 1 -0,0 
                  h-600 a0,0 0 0 1 -0,-0 
                  v-267 a0,0 0 0 1 0,-0 
                  z
              "
                                  />
                                </clipPath>
                              </defs>
                              <g>
                                <path
                                  fill="rgba(210,210,210,0)"
                                  d="
                  M0,0 
                  h600 a0,0 0 0 1 0,0 
                  v267 a0,0 0 0 1 -0,0 
                  h-600 a0,0 0 0 1 -0,-0 
                  v-267 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="63e31ff3-4200-4d4c-b6ed-992fe8218316"
                            data-layer-name="Frunk"
                            style={{
                              position: "absolute",
                              top: 74,
                              left: 39,
                              pointerEvents: "none",
                              transformOrigin: "100% 50%",
                              opacity: "0.4",
                              width: 41,
                              height: 19,
                              transform: "scale(0.997516, 1)"
                            }}
                          >
                            <svg
                              width="41px"
                              height="19px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h41 a0,0 0 0 1 0,0 
                  v19 a0,0 0 0 1 -0,0 
                  h-41 a0,0 0 0 1 -0,-0 
                  v-19 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre",
                                  fontSize: 16,
                                  textAlign: "right",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily: "Gotham-Book, Gotham, sans-serif",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                Frunk
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="d35a7c83-f949-488a-b9d9-46ebb771a106"
                            data-layer-name="Trunk"
                            style={{
                              position: "absolute",
                              top: 19,
                              left: 553,
                              pointerEvents: "none",
                              transformOrigin: "0% 50%",
                              opacity: "0.4",
                              width: 40,
                              height: 19,
                              transform: "scale(1.00775, 1)"
                            }}
                          >
                            <svg
                              width="40px"
                              height="19px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h40 a0,0 0 0 1 0,0 
                  v19 a0,0 0 0 1 -0,0 
                  h-40 a0,0 0 0 1 -0,-0 
                  v-19 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre",
                                  fontSize: 16,
                                  textAlign: "left",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily: "Gotham-Book, Gotham, sans-serif",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                Trunk
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="c8a51d55-360e-4558-aaa4-b1f25fc6617e"
                            data-layer-name="Open"
                            style={{
                              position: "absolute",
                              top: 98,
                              left: 31,
                              pointerEvents: "none",
                              transformOrigin: "100% 50%",
                              transform:
                                "translate(0px, -0.5px) scale(0.998563, 1)",
                              opacity: 1,
                              width: 49,
                              height: 23
                            }}
                          >
                            <svg
                              width="49px"
                              height="23px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h49 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-49 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre",
                                  fontSize: 20,
                                  textAlign: "right",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily:
                                    "Gotham-Medium, Gotham, sans-serif",
                                  fontWeight: 500,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                Open
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="c32e3f18-c65a-49f3-a887-34fac42f61cb"
                            data-layer-name="Open"
                            style={{
                              position: "absolute",
                              top: 43,
                              left: 553,
                              pointerEvents: "none",
                              transformOrigin: "0% 50%",
                              transform:
                                "translate(0px, -0.5px) scale(0.998563, 1)",
                              opacity: 1,
                              width: 49,
                              height: 23
                            }}
                          >
                            <svg
                              width="49px"
                              height="23px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h49 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-49 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre",
                                  fontSize: 20,
                                  textAlign: "left",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily:
                                    "Gotham-Medium, Gotham, sans-serif",
                                  fontWeight: 500,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                Open
                              </div>
                            </div>
                          </div>
                          <div
                            data-layer-id="43fc9bf3-4c23-4e4e-b031-fc2a78ac7b92"
                            data-layer-name="Line 1"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 30,
                              top: 133,
                              transformOrigin: "50% 100%",
                              transform: "rotate(270deg)",
                              opacity: 1,
                              width: 120,
                              height: 1
                            }}
                          >
                            <svg
                              preserveAspectRatio="none"
                              viewBox="0 0 120 1"
                              width="120px"
                              height="1px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g
                                fill="rgba(0,0,0,0)"
                                stroke="rgba(0,0,0,0.1)"
                                strokeWidth={1}
                                strokeLinejoin="miter"
                                strokeLinecap="butt"
                              >
                                <line x1={0} y1="0.5" x2={120} y2="0.5" />
                              </g>
                            </svg>
                          </div>
                          <div
                            data-layer-id="401b4ea0-9ef9-44d6-87ba-6545c33eb086"
                            data-layer-name="Line 3"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 317,
                              top: 73,
                              transformOrigin: "50% 100%",
                              transform: "rotate(270deg)",
                              opacity: 1,
                              width: 60,
                              height: 1
                            }}
                          >
                            <svg
                              preserveAspectRatio="none"
                              viewBox="0 0 60 1"
                              width="60px"
                              height="1px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g
                                fill="rgba(0,0,0,0)"
                                stroke="rgba(0,0,0,0.1)"
                                strokeWidth={1}
                                strokeLinejoin="miter"
                                strokeLinecap="butt"
                              >
                                <line x1={0} y1="0.5" x2={60} y2="0.5" />
                              </g>
                            </svg>
                          </div>
                          <div
                            data-layer-id="b20e893b-7ad5-4dc2-848d-98c1cb8a895c"
                            data-layer-name="Line 2"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 484,
                              top: 78,
                              transformOrigin: "50% 100%",
                              transform: "rotate(270deg)",
                              opacity: 1,
                              width: 120,
                              height: 1
                            }}
                          >
                            <svg
                              preserveAspectRatio="none"
                              viewBox="0 0 120 1"
                              width="120px"
                              height="1px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g
                                fill="rgba(0,0,0,0)"
                                stroke="rgba(0,0,0,0.1)"
                                strokeWidth={1}
                                strokeLinejoin="miter"
                                strokeLinecap="butt"
                              >
                                <line x1={0} y1="0.5" x2={120} y2="0.5" />
                              </g>
                            </svg>
                          </div>
                          <div
                            className="ContainerLayer"
                            data-layer-id="7523cd40-b4a5-4ce8-b724-88e8a613d8e1"
                            data-layer-name="lock"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 327,
                              top: 0,
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 30,
                              height: 28,
                              borderRadius: 0,
                              backgroundColor: "rgba(255, 255, 255, 0)"
                            }}
                          >
                            <svg
                              width="30px"
                              height="28px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path />
                              </g>
                            </svg>
                            <div
                              className="ContainerLayerContent"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0
                              }}
                            >
                              <div
                                data-layer-id="fab2bf62-d7a8-49d9-af16-379f13eafd30"
                                data-layer-name="Rectangle 9"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 8,
                                  top: 12,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 22,
                                  height: 16
                                }}
                              >
                                <svg
                                  width="22px"
                                  height="16px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path
                                      fill="rgba(0,0,0,1)"
                                      d="
                  M1,0 
                  h20 a1,1 0 0 1 1,1 
                  v14 a1,1 0 0 1 -1,1 
                  h-20 a1,1 0 0 1 -1,-1 
                  v-14 a1,1 0 0 1 1,-1 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                className="ContainerLayer"
                                data-layer-id="263a4323-5b8a-45b1-b00a-ffcb02435d93"
                                data-layer-name="Group 2"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 14,
                                  height: 12,
                                  borderRadius: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0)"
                                }}
                              >
                                <svg
                                  width="14px"
                                  height="12px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                                <div
                                  className="ContainerLayerContent"
                                  style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    top: 0,
                                    left: 0
                                  }}
                                >
                                  <div
                                    data-layer-id="72cca70f-b48a-4501-8fea-e0ee3fdcd9fe"
                                    data-layer-name="Rectangle 11"
                                    style={{
                                      position: "absolute",
                                      boxSizing: "border-box",
                                      pointerEvents: "none",
                                      left: 0,
                                      top: 0,
                                      transformOrigin: "0% 0%",
                                      opacity: 0,
                                      width: 14,
                                      height: 12
                                    }}
                                  >
                                    <svg
                                      width="14px"
                                      height="12px"
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        overflow: "visible"
                                      }}
                                    >
                                      <defs>
                                        <clipPath id="pp-gen-36">
                                          <path
                                            d="
                  M0,0 
                  h14 a0,0 0 0 1 0,0 
                  v12 a0,0 0 0 1 -0,0 
                  h-14 a0,0 0 0 1 -0,-0 
                  v-12 a0,0 0 0 1 0,-0 
                  z
              "
                                            transform="translate(0 0)"
                                          />
                                        </clipPath>
                                      </defs>
                                      <g>
                                        <path
                                          fill="rgba(255,255,255,1)"
                                          d="
                  M0,0 
                  h14 a0,0 0 0 1 0,0 
                  v12 a0,0 0 0 1 -0,0 
                  h-14 a0,0 0 0 1 -0,-0 
                  v-12 a0,0 0 0 1 0,-0 
                  z
              "
                                        />
                                      </g>
                                    </svg>
                                  </div>
                                  <div
                                    className="maskGroup"
                                    maskelmid="pp-gen-36"
                                    style={{
                                      clipPath: 'url("#pp-gen-36")',
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%"
                                    }}
                                  >
                                    <div
                                      data-layer-id="83912366-b8c8-4ec3-9132-88ac8f4e6da7"
                                      data-layer-name="Rectangle 10"
                                      style={{
                                        position: "absolute",
                                        boxSizing: "border-box",
                                        pointerEvents: "none",
                                        left: 1,
                                        top: 1,
                                        transformOrigin: "0% 0%",
                                        opacity: 1,
                                        width: 12,
                                        height: 12
                                      }}
                                    >
                                      <svg
                                        width="12px"
                                        height="12px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(210,210,210,0)"
                                            d="
                  M6,0 
                  h0 a6,6 0 0 1 6,6 
                  v6 a0,0 0 0 1 -0,0 
                  h-12 a0,0 0 0 1 -0,-0 
                  v-6 a6,6 0 0 1 6,-6 
                  z
              "
                                          />
                                          <path
                                            fill="none"
                                            stroke="rgba(0,0,0,1)"
                                            d="
                  M6,0 
                  h0 a6,6 0 0 1 6,6 
                  v6 a0,0 0 0 1 -0,0 
                  h-12 a0,0 0 0 1 -0,-0 
                  v-6 a6,6 0 0 1 6,-6 
                  z
              "
                                            strokeWidth={2}
                                            clipPath=""
                                            style={{ visibility: "visible" }}
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="ContainerLayer"
                        data-layer-id="78701aaa-d0af-489c-9945-cf32e50ad97f"
                        data-layer-name="music"
                        style={{
                          position: "absolute",
                          boxSizing: "border-box",
                          pointerEvents: "none",
                          left: 740,
                          top: 638,
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 1160,
                          height: 398,
                          borderRadius: 0,
                          backgroundColor: "rgba(255, 255, 255, 0)"
                        }}
                      >
                        <svg
                          width="1160px"
                          height="398px"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            overflow: "visible"
                          }}
                        >
                          <defs />
                          <g>
                            <path />
                          </g>
                        </svg>
                        <div
                          className="ContainerLayerContent"
                          style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0
                          }}
                        >
                          <div
                            data-layer-id="4bbbf6d7-2cec-43ca-9382-14431593e0a0"
                            data-layer-name="scrubber"
                            style={{
                              position: "absolute",
                              top: 132,
                              left: 0,
                              pointerEvents: "auto",
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 1160,
                              height: 2
                            }}
                          >
                            <div
                              className="ContainerLayer"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                transform:
                                  "perspective(200px) rotateX(0deg) rotateY(0deg)",
                                transformOrigin: "50% 50%",
                                width: 1160,
                                height: 2,
                                borderRadius: 0,
                                backgroundColor: "rgba(255, 255, 255, 0)"
                              }}
                            >
                              <svg
                                width="1160px"
                                height="2px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                              <div
                                className="ContainerLayerContent"
                                style={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "100%",
                                  top: 0,
                                  left: 0
                                }}
                              >
                                <div
                                  data-layer-id="9ea1b08b-3751-4687-bc9e-9f86188efb32"
                                  data-layer-name="background"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 0,
                                    top: 0,
                                    transformOrigin: "0% 50%",
                                    opacity: "0.3",
                                    width: 1160,
                                    height: 2
                                  }}
                                >
                                  <svg
                                    width="1160px"
                                    height="2px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible"
                                    }}
                                  >
                                    <defs />
                                    <g>
                                      <path
                                        fill="rgba(223,88,90,1)"
                                        d="
                  M0,0 
                  h1160 a0,0 0 0 1 0,0 
                  v2 a0,0 0 0 1 -0,0 
                  h-1160 a0,0 0 0 1 -0,-0 
                  v-2 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </g>
                                  </svg>
                                </div>
                                <div
                                  data-layer-id="ad989751-f2a0-4b47-99fa-15f1ef3d1a43"
                                  data-layer-name="progress"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 0,
                                    top: 0,
                                    transformOrigin: "0% 50%",
                                    opacity: 1,
                                    width: 0,
                                    height: 2
                                  }}
                                >
                                  <svg
                                    width="0px"
                                    height="2px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible"
                                    }}
                                  >
                                    <defs />
                                    <g>
                                      <path
                                        fill="rgba(223,88,90,1)"
                                        d="
                  M0,0 
                  h0 a0,0 0 0 1 0,0 
                  v2 a0,0 0 0 1 -0,0 
                  h-0 a0,0 0 0 1 -0,-0 
                  v-2 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </g>
                                  </svg>
                                </div>
                                <div
                                  data-layer-id="a9f58334-cf07-4bd8-ae15-f09de4d89c0a"
                                  data-layer-name="indicator"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: "-1px",
                                    top: 0,
                                    transformOrigin: "50% 50%",
                                    opacity: 1,
                                    width: 2,
                                    height: 2
                                  }}
                                >
                                  <svg
                                    width="2px"
                                    height="2px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible"
                                    }}
                                  >
                                    <defs />
                                    <g>
                                      <ellipse
                                        fill="rgba(223,88,90,1)"
                                        cx={1}
                                        cy={1}
                                        rx={1}
                                        ry={1}
                                      />
                                    </g>
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                inset: "-20px"
                              }}
                            />
                          </div>
                          <div
                            className="ContainerLayer"
                            data-layer-id="cccf54dc-8475-4617-9105-ec04405521af"
                            data-layer-name="Group"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 649,
                              top: 50,
                              transformOrigin: "0% 0%",
                              transform: "translate(0.43px, 0px)",
                              opacity: 1,
                              width: 22,
                              height: 23,
                              borderRadius: 0,
                              backgroundColor: "rgba(255, 255, 255, 0)"
                            }}
                          >
                            <svg
                              width="22px"
                              height="23px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path />
                              </g>
                            </svg>
                            <div
                              className="ContainerLayerContent"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0
                              }}
                            >
                              <div
                                data-layer-id="7e078b37-c9cb-4c7d-87ab-0260be11fceb"
                                data-layer-name="Vector"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  transform: "translate(0px, 0.01px)",
                                  opacity: 1,
                                  width: 22,
                                  height: 24
                                }}
                              >
                                <svg
                                  preserveAspectRatio="none"
                                  viewBox="0 0 22 24"
                                  width="22px"
                                  height="24px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs />
                                  <g
                                    fill="rgba(0,0,0,0.85)"
                                    stroke="rgba(255,255,255,1)"
                                    strokeWidth={0}
                                    strokeLinejoin="miter"
                                    strokeLinecap="butt"
                                  >
                                    <path d="M20.5313 23.2454C21.1922 23.2454 21.7265 22.7391 21.7265 22.0782V1.19537C21.7265 0.534427 21.1922 0.0141142 20.5313 0.0141142C19.8703 0.0141142 19.3219 0.534427 19.3219 1.19537V22.0782C19.3219 22.7391 19.8703 23.2454 20.5313 23.2454ZM2.02501 22.6829C2.60157 22.6829 3.06563 22.5 3.64219 22.1625L17.9719 13.725C18.9703 13.1344 19.3922 12.4313 19.3922 11.6297C19.3922 10.8282 18.9703 10.125 17.9719 9.53441L3.64219 1.09692C3.06563 0.759423 2.60157 0.576614 2.02501 0.576614C0.91407 0.576614 6.10352e-06 1.42037 6.10352e-06 2.99536V20.2641C6.10352e-06 21.8391 0.91407 22.6829 2.02501 22.6829ZM2.64376 20.0813C2.43282 20.0813 2.25001 19.9407 2.25001 19.6594V3.60005C2.25001 3.3188 2.43282 3.17818 2.64376 3.17818C2.72813 3.17818 2.84063 3.22036 2.98126 3.30474L16.3547 11.236C16.5515 11.3485 16.65 11.4329 16.65 11.6297C16.65 11.8125 16.5375 11.911 16.3547 12.0235L2.98126 19.9547C2.84063 20.0391 2.72813 20.0813 2.64376 20.0813Z" />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="ContainerLayer"
                            data-layer-id="e495a4f0-88b3-4518-be2f-71909d1bb857"
                            data-layer-name="Group"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 488,
                              top: 50,
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 22,
                              height: 23,
                              borderRadius: 0,
                              backgroundColor: "rgba(255, 255, 255, 0)"
                            }}
                          >
                            <svg
                              width="22px"
                              height="23px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path />
                              </g>
                            </svg>
                            <div
                              className="ContainerLayerContent"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0
                              }}
                            >
                              <div
                                data-layer-id="79fa7ee9-a314-4360-9a4e-8b038b00f662"
                                data-layer-name="Vector"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  transform: "translate(0px, 0.01px)",
                                  opacity: 1,
                                  width: 22,
                                  height: 24
                                }}
                              >
                                <svg
                                  preserveAspectRatio="none"
                                  viewBox="0 0 22 24"
                                  width="22px"
                                  height="24px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs />
                                  <g
                                    fill="rgba(0,0,0,0.85)"
                                    stroke="rgba(255,255,255,1)"
                                    strokeWidth={0}
                                    strokeLinejoin="miter"
                                    strokeLinecap="butt"
                                  >
                                    <path d="M1.19531 23.2454C1.87031 23.2454 2.40469 22.7391 2.40469 22.0782V1.19537C2.40469 0.534427 1.87031 0.0141142 1.19531 0.0141142C0.534375 0.0141142 0 0.534427 0 1.19537V22.0782C0 22.7391 0.534375 23.2454 1.19531 23.2454ZM19.7015 22.6829C20.8125 22.6829 21.7265 21.8391 21.7265 20.2641V2.99536C21.7265 1.42037 20.8125 0.576614 19.7015 0.576614C19.125 0.576614 18.661 0.759423 18.0844 1.09692L3.75469 9.53441C2.75625 10.125 2.33437 10.8282 2.33437 11.6297C2.33437 12.4313 2.75625 13.1344 3.75469 13.725L18.0844 22.1625C18.661 22.5 19.125 22.6829 19.7015 22.6829ZM19.0969 20.0813C18.9985 20.0813 18.886 20.0391 18.7453 19.9547L5.38594 12.0235C5.18906 11.911 5.07656 11.8125 5.07656 11.6297C5.07656 11.4329 5.175 11.3485 5.38594 11.236L18.7453 3.30474C18.886 3.22036 18.9985 3.17818 19.0969 3.17818C19.2937 3.17818 19.4765 3.3188 19.4765 3.60005V19.6594C19.4765 19.9407 19.2937 20.0813 19.0969 20.0813Z" />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="ContainerLayer"
                            data-layer-id="2663ae52-9abf-43b8-8750-0389b3a65cee"
                            data-layer-name="Group"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 735,
                              top: 49,
                              transformOrigin: "0% 0%",
                              transform: "translate(0.08px, 0px)",
                              opacity: "0.4",
                              width: 32,
                              height: 26,
                              borderRadius: 0,
                              backgroundColor: "rgba(255, 255, 255, 0)"
                            }}
                          >
                            <svg
                              width="32px"
                              height="26px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path />
                              </g>
                            </svg>
                            <div
                              className="ContainerLayerContent"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0
                              }}
                            >
                              <div
                                data-layer-id="9456b5e6-d9ef-4c5f-b995-73f715127283"
                                data-layer-name="Vector"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  transform: "translate(0px, 0.03px)",
                                  opacity: 1,
                                  width: 33,
                                  height: 26
                                }}
                              >
                                <svg
                                  preserveAspectRatio="none"
                                  viewBox="0 0 33 26"
                                  width="33px"
                                  height="26px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs />
                                  <g
                                    fill="rgba(0,0,0,0.85)"
                                    stroke="rgba(255,255,255,1)"
                                    strokeWidth={0}
                                    strokeLinejoin="miter"
                                    strokeLinecap="butt"
                                  >
                                    <path d="M3.05176e-06 19.9687C3.05176e-06 20.6719 0.520316 21.136 1.29375 21.136H4.5C6.83436 21.136 8.17032 20.475 9.87186 18.5063L18.3937 8.56404C19.6031 7.15782 20.6156 6.6375 22.1625 6.6375H25.0313V9.81564C25.0313 10.3781 25.3547 10.7015 25.9313 10.7015C26.1985 10.7015 26.4515 10.6031 26.6625 10.4344L31.9781 6.03282C32.4281 5.66719 32.4281 5.09063 31.9781 4.69687L26.6625 0.281253C26.4515 0.112503 26.1985 0.0281281 25.9313 0.0281281C25.3547 0.0281281 25.0313 0.337503 25.0313 0.900003V4.28907H22.0922C19.7437 4.28907 18.3937 4.95 16.7063 6.91872L8.19846 16.861C6.975 18.2813 6.00468 18.8015 4.57032 18.8015H1.29375C0.534378 18.8015 3.05176e-06 19.2656 3.05176e-06 19.9687ZM3.05176e-06 5.47032C3.05176e-06 6.15936 0.534378 6.6375 1.29375 6.6375H4.57032C6.01872 6.6375 6.98904 7.15782 8.19846 8.57814L16.7063 18.5203C18.3937 20.475 19.7437 21.136 22.0922 21.136H25.0313V24.6235C25.0313 25.186 25.3547 25.4953 25.9313 25.4953C26.1985 25.4953 26.4515 25.411 26.6625 25.2422L31.9781 20.8406C32.4281 20.461 32.4281 19.8985 31.9781 19.5047L26.6625 15.089C26.4515 14.9203 26.1985 14.8219 25.9313 14.8219C25.3547 14.8219 25.0313 15.1453 25.0313 15.7078V18.8015H22.1625C20.6156 18.8015 19.6031 18.2813 18.3937 16.861L9.87186 6.91872C8.17032 4.96407 6.83436 4.30313 4.5 4.30313H1.29375C0.520316 4.30313 3.05176e-06 4.76719 3.05176e-06 5.47032Z" />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="ContainerLayer"
                            data-layer-id="76fa4b59-7b32-4471-ae9b-7772a49c20a1"
                            data-layer-name="Group"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 968,
                              top: 48,
                              transformOrigin: "0% 0%",
                              opacity: "0.4",
                              width: 37,
                              height: 29,
                              borderRadius: 0,
                              backgroundColor: "rgba(255, 255, 255, 0)"
                            }}
                          >
                            <svg
                              width="37px"
                              height="29px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path />
                              </g>
                            </svg>
                            <div
                              className="ContainerLayerContent"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0
                              }}
                            >
                              <div
                                data-layer-id="fcd3f40d-824f-4f37-a64b-4ccc6044bc5e"
                                data-layer-name="Vector"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 38,
                                  height: 28
                                }}
                              >
                                <svg
                                  preserveAspectRatio="none"
                                  viewBox="0 0 38 28"
                                  width="38px"
                                  height="28px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs />
                                  <g
                                    fill="rgba(0,0,0,0.85)"
                                    stroke="rgba(255,255,255,1)"
                                    strokeWidth={0}
                                    strokeLinejoin="miter"
                                    strokeLinecap="butt"
                                  >
                                    <path d="M9.92814 27.0667H36.1265C36.7172 27.0667 37.1953 26.6026 37.1953 26.012C37.1953 25.4214 36.7172 24.9433 36.1265 24.9433H9.92814C9.3375 24.9433 8.87346 25.4214 8.87346 26.012C8.87346 26.6026 9.3375 27.0667 9.92814 27.0667ZM9.92814 19.8526H36.1265C36.7172 19.8526 37.1953 19.3745 37.1953 18.7839C37.1953 18.1933 36.7172 17.7292 36.1265 17.7292H9.92814C9.3375 17.7292 8.87346 18.1933 8.87346 18.7839C8.87346 19.3745 9.3375 19.8526 9.92814 19.8526ZM9.92814 12.6245H36.1265C36.7172 12.6245 37.1953 12.1604 37.1953 11.5558C37.1953 10.9651 36.7172 10.5011 36.1265 10.5011H9.92814C9.3375 10.5011 8.87346 10.9651 8.87346 11.5558C8.87346 12.1604 9.3375 12.6245 9.92814 12.6245ZM10.6453 6.1839H35.4235C36.6047 6.1839 37.1953 5.60733 37.1953 4.42609V3.38546C37.1953 2.21827 36.6047 1.62765 35.4235 1.62765H10.6453C9.46404 1.62765 8.87346 2.21827 8.87346 3.38546V4.42609C8.87346 5.60733 9.46404 6.1839 10.6453 6.1839ZM1.47656 7.61826L6.17346 4.76359C6.90468 4.32765 6.91872 3.4839 6.17346 3.04796L1.47656 0.193272C0.717186 -0.256728 0 0.108897 0 0.980772V6.83076C0 7.71672 0.73125 8.06826 1.47656 7.61826Z" />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="ContainerLayer"
                            data-layer-id="17df5ad7-45a5-4bca-8931-d86ea31da5df"
                            data-layer-name="Group"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 1069,
                              top: 48,
                              transformOrigin: "0% 0%",
                              opacity: "0.4",
                              width: 27,
                              height: 28,
                              borderRadius: 0,
                              backgroundColor: "rgba(255, 255, 255, 0)"
                            }}
                          >
                            <svg
                              width="27px"
                              height="28px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path />
                              </g>
                            </svg>
                            <div
                              className="ContainerLayerContent"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0
                              }}
                            >
                              <div
                                data-layer-id="a64ff870-689b-4a3e-8b31-913ea8513ae1"
                                data-layer-name="Vector"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 28,
                                  height: 28
                                }}
                              >
                                <svg
                                  preserveAspectRatio="none"
                                  viewBox="0 0 28 28"
                                  width="28px"
                                  height="28px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs />
                                  <g
                                    fill="rgba(0,0,0,0.85)"
                                    stroke="rgba(255,255,255,1)"
                                    strokeWidth={0}
                                    strokeLinejoin="miter"
                                    strokeLinecap="butt"
                                  >
                                    <path d="M0 11.2219C0 17.4094 5.03437 22.4437 11.2219 22.4437C13.6687 22.4437 15.9047 21.6563 17.7469 20.3344L24.6656 27.2672C24.989 27.5906 25.411 27.7453 25.861 27.7453C26.8172 27.7453 27.4781 27.0281 27.4781 26.086C27.4781 25.636 27.3094 25.2281 27.014 24.9328L20.1375 18.014C21.586 16.1297 22.4437 13.7813 22.4437 11.2219C22.4437 5.03437 17.4094 0 11.2219 0C5.03437 0 0 5.03437 0 11.2219ZM2.40469 11.2219C2.40469 6.35628 6.35628 2.40469 11.2219 2.40469C16.0875 2.40469 20.039 6.35628 20.039 11.2219C20.039 16.0875 16.0875 20.039 11.2219 20.039C6.35628 20.039 2.40469 16.0875 2.40469 11.2219Z" />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="ContainerLayer"
                            data-layer-id="66dc7fce-7eed-4897-ad38-6b937a0145f5"
                            data-layer-name="Group"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 396,
                              top: 49,
                              transformOrigin: "0% 0%",
                              opacity: "0.4",
                              width: 28,
                              height: 27,
                              borderRadius: 0,
                              backgroundColor: "rgba(255, 255, 255, 0)"
                            }}
                          >
                            <svg
                              width="28px"
                              height="27px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path />
                              </g>
                            </svg>
                            <div
                              className="ContainerLayerContent"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0
                              }}
                            >
                              <div
                                data-layer-id="830b4e67-c5ce-4d8d-a16a-6529eea18aba"
                                data-layer-name="Vector"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 1,
                                  transformOrigin: "0% 0%",
                                  transform: "translate(0px, -0.14px)",
                                  opacity: 1,
                                  width: 28,
                                  height: 27
                                }}
                              >
                                <svg
                                  preserveAspectRatio="none"
                                  viewBox="0 0 28 27"
                                  width="28px"
                                  height="27px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs />
                                  <g
                                    fill="rgba(0,0,0,0.85)"
                                    stroke="rgba(255,255,255,1)"
                                    strokeWidth={0}
                                    strokeLinejoin="miter"
                                    strokeLinecap="butt"
                                  >
                                    <path d="M-1.2207e-05 9.35152C-1.2207e-05 15.3422 5.0203 21.2343 12.9515 26.2968C13.2468 26.4796 13.6687 26.6765 13.964 26.6765C14.2593 26.6765 14.6813 26.4796 14.9906 26.2968C22.9078 21.2343 27.9281 15.3422 27.9281 9.35152C27.9281 4.37341 24.5109 0.857792 19.9547 0.857792C17.3531 0.857792 15.2437 2.09529 13.964 3.99373C12.7125 2.10935 10.575 0.857792 7.97345 0.857792C3.41717 0.857792 -1.2207e-05 4.37341 -1.2207e-05 9.35152ZM2.26405 9.35152C2.26405 5.61091 4.6828 3.12185 7.94531 3.12185C10.589 3.12185 12.1078 4.76716 13.0078 6.17344C13.3875 6.73594 13.6265 6.89062 13.964 6.89062C14.3015 6.89062 14.5125 6.72184 14.9203 6.17344C15.8906 4.79529 17.3531 3.12185 19.9828 3.12185C23.2453 3.12185 25.664 5.61091 25.664 9.35152C25.664 14.5828 20.1375 20.2218 14.2593 24.1313C14.1187 24.2297 14.0203 24.3 13.964 24.3C13.9078 24.3 13.8093 24.2297 13.6828 24.1313C7.79063 20.2218 2.26405 14.5828 2.26405 9.35152Z" />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            data-layer-id="d3cfa43f-71d4-4fa2-bad4-4abdcf403aff"
                            data-layer-name="play pause"
                            style={{
                              position: "absolute",
                              top: 50,
                              left: 570,
                              pointerEvents: "none",
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 21,
                              height: 23
                            }}
                          >
                            <div
                              className="ContainerLayer"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                transform:
                                  "perspective(200px) rotateX(0deg) rotateY(0deg)",
                                transformOrigin: "50% 50%",
                                width: 21,
                                height: 23,
                                borderRadius: 0,
                                backgroundColor: "rgba(255, 255, 255, 0)"
                              }}
                            >
                              <svg
                                width="21px"
                                height="23px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                              <div
                                className="ContainerLayerContent"
                                style={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "100%",
                                  top: 0,
                                  left: 0
                                }}
                              >
                                <div
                                  className="ContainerLayer"
                                  data-layer-id="473d05b9-1c8a-41bb-a5f3-23862848663d"
                                  data-layer-name="pause"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 4,
                                    top: 0,
                                    transformOrigin: "0% 0%",
                                    transform: "translate(-0.27px, 0px)",
                                    opacity: 0,
                                    width: 12,
                                    height: 23,
                                    borderRadius: 0,
                                    backgroundColor: "rgba(255, 255, 255, 0)"
                                  }}
                                >
                                  <svg
                                    width="12px"
                                    height="23px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible"
                                    }}
                                  >
                                    <defs />
                                    <g>
                                      <path />
                                    </g>
                                  </svg>
                                  <div
                                    className="ContainerLayerContent"
                                    style={{
                                      position: "absolute",
                                      width: "100%",
                                      height: "100%",
                                      top: 0,
                                      left: 0
                                    }}
                                  >
                                    <div
                                      data-layer-id="22fedb4f-a15b-44ea-9f26-46eb3b306177"
                                      data-layer-name="Vector"
                                      style={{
                                        position: "absolute",
                                        boxSizing: "border-box",
                                        pointerEvents: "none",
                                        left: 0,
                                        top: 0,
                                        transformOrigin: "0% 0%",
                                        transform: "translate(0px, 0.01px)",
                                        opacity: 1,
                                        width: 12,
                                        height: 24
                                      }}
                                    >
                                      <svg
                                        preserveAspectRatio="none"
                                        viewBox="0 0 12 24"
                                        width="12px"
                                        height="24px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g
                                          fill="rgba(0,0,0,0.85)"
                                          stroke="rgba(255,255,255,1)"
                                          strokeWidth={0}
                                          strokeLinejoin="miter"
                                          strokeLinecap="butt"
                                        >
                                          <path d="M1.19531 23.2454C1.87031 23.2454 2.40469 22.7391 2.40469 22.0782V1.19537C2.40469 0.534427 1.87031 0.0141142 1.19531 0.0141142C0.534375 0.0141142 0 0.534427 0 1.19537V22.0782C0 22.7391 0.534375 23.2454 1.19531 23.2454ZM10.4906 23.2454C11.1515 23.2454 11.7 22.7391 11.7 22.0782V1.19537C11.7 0.534427 11.1515 0.0141142 10.4906 0.0141142C9.82968 0.0141142 9.29532 0.534427 9.29532 1.19537V22.0782C9.29532 22.7391 9.82968 23.2454 10.4906 23.2454Z" />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="ContainerLayer"
                                  data-layer-id="0a6b7d34-7b72-413e-80b1-70292711b80d"
                                  data-layer-name="play"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 0,
                                    top: 0,
                                    transformOrigin: "0% 0%",
                                    opacity: 1,
                                    width: 21,
                                    height: 23,
                                    borderRadius: 0,
                                    backgroundColor: "rgba(255, 255, 255, 0)"
                                  }}
                                >
                                  <svg
                                    width="21px"
                                    height="23px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible"
                                    }}
                                  >
                                    <defs />
                                    <g>
                                      <path />
                                    </g>
                                  </svg>
                                  <div
                                    className="ContainerLayerContent"
                                    style={{
                                      position: "absolute",
                                      width: "100%",
                                      height: "100%",
                                      top: 0,
                                      left: 0
                                    }}
                                  >
                                    <div
                                      data-layer-id="f833c2c1-a056-4b15-b01d-1a3cb78f7008"
                                      data-layer-name="Vector"
                                      style={{
                                        position: "absolute",
                                        boxSizing: "border-box",
                                        pointerEvents: "none",
                                        left: 0,
                                        top: 0,
                                        transformOrigin: "0% 0%",
                                        opacity: 1,
                                        width: 21,
                                        height: 24
                                      }}
                                    >
                                      <svg
                                        preserveAspectRatio="none"
                                        viewBox="0 0 21 24"
                                        width="21px"
                                        height="24px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g
                                          fill="rgba(0,0,0,0.85)"
                                          stroke="rgba(255,255,255,1)"
                                          strokeWidth={0}
                                          strokeLinejoin="miter"
                                          strokeLinecap="butt"
                                        >
                                          <path d="M1.64796 23.25C2.19728 23.25 2.6642 23.0303 3.21352 22.7144L19.2262 13.4583C20.366 12.7854 20.7643 12.346 20.7643 11.6181C20.7643 10.8903 20.366 10.4508 19.2262 9.79162L3.21352 0.521854C2.6642 0.205995 2.19728 0 1.64796 0C0.631715 0 0 0.769051 0 1.96382V21.2724C0 22.4672 0.631715 23.25 1.64796 23.25ZM2.34834 20.627C2.26595 20.627 2.21101 20.572 2.21101 20.4622V2.77407C2.21101 2.6642 2.26595 2.60927 2.34834 2.60927C2.40327 2.60927 2.45821 2.63674 2.51314 2.67794L17.7156 11.4671C17.7843 11.5083 17.8392 11.5495 17.8392 11.6181C17.8392 11.6868 17.7843 11.7417 17.7156 11.7692L2.51314 20.572C2.45821 20.5995 2.40327 20.627 2.34834 20.627Z" />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                inset: "-10px"
                              }}
                            />
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="0cc3bd1e-9c05-425d-9405-6759a7c5bc34"
                            data-layer-name="Frank Ocean"
                            style={{
                              position: "absolute",
                              top: 48,
                              left: 136,
                              pointerEvents: "none",
                              transformOrigin: "0% 50%",
                              opacity: "0.4",
                              width: 92,
                              height: 19,
                              transform: "scale(1.00524, 1)"
                            }}
                          >
                            <svg
                              width="92px"
                              height="19px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h92 a0,0 0 0 1 0,0 
                  v19 a0,0 0 0 1 -0,0 
                  h-92 a0,0 0 0 1 -0,-0 
                  v-19 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre",
                                  fontSize: 16,
                                  textAlign: "left",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily: "Gotham-Book, Gotham, sans-serif",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                Frank Ocean
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="3dd7d001-d213-4709-ac24-cf58c5520513"
                            data-layer-name="Lost"
                            style={{
                              position: "absolute",
                              top: 21,
                              left: 136,
                              pointerEvents: "none",
                              transformOrigin: "0% 50%",
                              transform:
                                "translate(0px, -0.5px) scale(0.994834, 1)",
                              opacity: 1,
                              width: 38,
                              height: 23
                            }}
                          >
                            <svg
                              width="38px"
                              height="23px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h38 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-38 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre",
                                  fontSize: 20,
                                  textAlign: "left",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily:
                                    "Gotham-Medium, Gotham, sans-serif",
                                  fontWeight: 500,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                Lost
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="e1841f4b-9f9d-4f18-b325-b92fac308b48"
                            data-layer-name="Playlist"
                            style={{
                              position: "absolute",
                              top: 167,
                              left: 24,
                              pointerEvents: "none",
                              transformOrigin: "0% 50%",
                              transform:
                                "translate(0px, -0.5px) scale(0.999642, 1)",
                              opacity: 1,
                              width: 109,
                              height: 23
                            }}
                          >
                            <svg
                              width="109px"
                              height="23px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h109 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-109 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre",
                                  fontSize: 20,
                                  textAlign: "left",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily:
                                    "Gotham-Medium, Gotham, sans-serif",
                                  fontWeight: 500,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                Playing next
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="a7fa772c-7688-4a04-945d-526eb0b5e4cc"
                            data-layer-name="Recents & Favorites"
                            style={{
                              position: "absolute",
                              top: 167,
                              left: 809,
                              pointerEvents: "none",
                              transformOrigin: "0% 50%",
                              transform:
                                "translate(0px, -0.5px) scale(1.00039, 1)",
                              opacity: "0.4",
                              width: 180,
                              height: 23
                            }}
                          >
                            <svg
                              width="180px"
                              height="23px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h180 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-180 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre",
                                  fontSize: 20,
                                  textAlign: "left",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily:
                                    "Gotham-Medium, Gotham, sans-serif",
                                  fontWeight: 500,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                Recents &amp; Favorites
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="6e0595c1-307d-470b-94f9-d1cf3bb868be"
                            data-layer-name="Sources"
                            style={{
                              position: "absolute",
                              top: 167,
                              left: 1056,
                              pointerEvents: "none",
                              transformOrigin: "0% 50%",
                              transform:
                                "translate(0px, -0.5px) scale(1.00511, 1)",
                              opacity: "0.4",
                              width: 73,
                              height: 23
                            }}
                          >
                            <svg
                              width="73px"
                              height="23px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h73 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-73 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre",
                                  fontSize: 20,
                                  textAlign: "left",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily:
                                    "Gotham-Medium, Gotham, sans-serif",
                                  fontWeight: 500,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                Sources
                              </div>
                            </div>
                          </div>
                          <div
                            data-layer-id="02db02fa-befb-4ae9-9bd4-ef32d31a5cc2"
                            data-layer-name="channel album"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 24,
                              top: 16,
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 92,
                              height: 92
                            }}
                          >
                            <img
                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/27f12f2d3be60bfadb41084fa56fbde84e8f8192.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8yN2YxMmYyZDNiZTYwYmZhZGI0MTA4NGZhNTZmYmRlODRlOGY4MTkyLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=UUkMFgNKmkC61GxcR7-HxnSuf5juYbH40ctrRceoj6qj1kfHzHBOCzK2ftzrEmHkxSGHt1PeqOBP2XoIA8xb2E28kYVuhfnz2thODw06eb2PH6xdLxiL6bWGkM3Du-6KsImhjOlvBaJOvmpPpKshXggHzSlyTdizyhQON8RYSYzVFKHcNV8CGtzqGGk8V1K2yPrjM-sJBeNQK-uYCeuy6VhYORdby883uo9C0ErD7X5P~vusl-OM9xXS9ImCxjXHRqHjgJGoXbwYum39oheCURbvEovQu9REzX~XbuT5u6cNmODbRJ6ZZLbqKPAiP09U38UJ110ABHKYTwp5rD9ggQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                              style={{
                                objectFit: "fill",
                                position: "absolute",
                                boxSizing: "border-box",
                                width: "100%",
                                height: "100%",
                                display: "block",
                                opacity: 1,
                                clipPath: 'url("#pp-gen-13")'
                              }}
                            />
                            <svg
                              width="92px"
                              height="92px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs>
                                <filter
                                  id="pp-gen-12"
                                  filterUnits="objectBoundingBox"
                                  colorInterpolationFilters="sRGB"
                                  x="-7%"
                                  y="-7%"
                                  width="113%"
                                  height="113%"
                                >
                                  <feGaussianBlur
                                    in="SourceAlpha"
                                    result="step0"
                                    stdDeviation={2}
                                  />
                                  <feComposite
                                    in="step0"
                                    result="step1"
                                    in2="SourceAlpha"
                                    operator="out"
                                  />
                                  <feColorMatrix
                                    in="step1"
                                    values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.25 0"
                                    type="matrix"
                                  />
                                </filter>
                                <clipPath id="pp-gen-13">
                                  <path
                                    d="
                  M2,0 
                  h88 a2,2 0 0 1 2,2 
                  v88 a2,2 0 0 1 -2,2 
                  h-88 a2,2 0 0 1 -2,-2 
                  v-88 a2,2 0 0 1 2,-2 
                  z
              "
                                  />
                                </clipPath>
                              </defs>
                              <g>
                                <path
                                  fill="black"
                                  fillOpacity={1}
                                  filter="url(#pp-gen-12)"
                                  d="
                  M2,0 
                  h88 a2,2 0 0 1 2,2 
                  v88 a2,2 0 0 1 -2,2 
                  h-88 a2,2 0 0 1 -2,-2 
                  v-88 a2,2 0 0 1 2,-2 
                  z
              "
                                />
                                <path
                                  fill="rgba(210,210,210,0)"
                                  d="
                  M2,0 
                  h88 a2,2 0 0 1 2,2 
                  v88 a2,2 0 0 1 -2,2 
                  h-88 a2,2 0 0 1 -2,-2 
                  v-88 a2,2 0 0 1 2,-2 
                  z
              "
                                />
                              </g>
                            </svg>
                          </div>
                          <div
                            data-layer-id="a1195d06-d7dd-423a-9626-c6a3d4902bf8"
                            data-layer-name="Rectangle 17"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 504,
                              overflow: "visible",
                              pointerEvents: "none",
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 152,
                              height: 4
                            }}
                          >
                            <img
                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/c895cb8b3de065be38d01ee7c0ac682831d73984.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9jODk1Y2I4YjNkZTA2NWJlMzhkMDFlZTdjMGFjNjgyODMxZDczOTg0LnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=XNwiB0vt7aFJ7D6wtnNZgGY7kd46kta4K5Au~Mcaohlog95258SEUHv3wz8ATm7H3zAOBw~2K2YS~2kRtTFK7PwYS2fw49uyZ0~~Ll1jJ9l5k~9Cz~-Rcmo8qt7iQvBwN0t3saKMl0rIwHqFvbfukuUV73PBwbBRcAP5dRx1824WsHBP1tWikJfdf-~MB1sIche6XaQ6EnWkA~uiA4IEtiL2leCWe1FjRQetEhAY4BRPn5wEYAbuXtnlG5SdLWm-S-1egEizj2YsN4-VwwD9CTqi3dCQpRcFu7VQNRR3XKOfSokXJtoiE13L46PBdHaENcAWZrVoG2xqR7EHRd2nyg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                borderRadius: 0
                              }}
                            />
                            <svg
                              width="152px"
                              height="4px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path />
                              </g>
                            </svg>
                          </div>
                          <div
                            className="ContainerLayer"
                            data-layer-id="9a1dfec6-809f-45c1-b8c4-a32cc3119bcb"
                            data-layer-name="top songs"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 20,
                              top: 210,
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 1105,
                              height: 192,
                              borderRadius: 0,
                              backgroundColor: "rgba(255, 255, 255, 0)"
                            }}
                          >
                            <svg
                              width="1105px"
                              height="192px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path />
                              </g>
                            </svg>
                            <div
                              className="ContainerLayerContent"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0
                              }}
                            >
                              <div
                                className="ContainerLayer"
                                data-layer-id="9a6d6524-dbef-498d-a097-b76da0321782"
                                data-layer-name="Container 1"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 284,
                                  height: 88,
                                  borderRadius: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0)"
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    boxSizing: "border-box",
                                    overflow: "hidden",
                                    borderRadius: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayerContent"
                                    style={{
                                      position: "absolute",
                                      width: "100%",
                                      height: "100%",
                                      top: 0,
                                      left: 0
                                    }}
                                  >
                                    <div
                                      className="TextLayer"
                                      data-layer-id="20f7094e-b3fd-4780-991a-bb45ef39f7d3"
                                      data-layer-name="Artist 1"
                                      style={{
                                        position: "absolute",
                                        top: 45,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        opacity: "0.4",
                                        width: 36,
                                        height: 19,
                                        transform: "scale(1.01222, 1)"
                                      }}
                                    >
                                      <svg
                                        width="36px"
                                        height="19px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h36 a0,0 0 0 1 0,0 
                  v19 a0,0 0 0 1 -0,0 
                  h-36 a0,0 0 0 1 -0,-0 
                  v-19 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 16,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Book, Gotham, sans-serif",
                                            fontWeight: 400,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Artist
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="TextLayer"
                                      data-layer-id="bde77003-bfcd-4b92-907b-637e57188d4e"
                                      data-layer-name="Title 1"
                                      style={{
                                        position: "absolute",
                                        top: 18,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        transform:
                                          "translate(0px, -0.5px) scale(1.00148, 1)",
                                        opacity: 1,
                                        width: 37,
                                        height: 23
                                      }}
                                    >
                                      <svg
                                        width="37px"
                                        height="23px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h37 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-37 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 20,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Medium, Gotham, sans-serif",
                                            fontWeight: 500,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Title
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-layer-id="99c4e61d-d5d9-4f92-97f0-01b662fb6ae2"
                                      data-layer-name="album 1"
                                      style={{
                                        position: "absolute",
                                        boxSizing: "border-box",
                                        pointerEvents: "none",
                                        left: 4,
                                        top: 4,
                                        transformOrigin: "0% 0%",
                                        opacity: 1,
                                        width: 80,
                                        height: 80
                                      }}
                                    >
                                      <svg
                                        width="80px"
                                        height="80px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs>
                                          <filter
                                            id="pp-gen-37"
                                            filterUnits="objectBoundingBox"
                                            colorInterpolationFilters="sRGB"
                                            x="-8%"
                                            y="-8%"
                                            width="115%"
                                            height="115%"
                                          >
                                            <feGaussianBlur
                                              in="SourceAlpha"
                                              result="step0"
                                              stdDeviation={2}
                                            />
                                            <feComposite
                                              in="step0"
                                              result="step1"
                                              in2="SourceAlpha"
                                              operator="out"
                                            />
                                            <feColorMatrix
                                              in="step1"
                                              values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.25 0"
                                              type="matrix"
                                            />
                                          </filter>
                                        </defs>
                                        <g>
                                          <path
                                            fill="black"
                                            fillOpacity={1}
                                            filter="url(#pp-gen-37)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                          <path
                                            fill="rgba(210,210,210,1)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <svg
                                  width="284px"
                                  height="88px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible",
                                    pointerEvents: "none"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                              </div>
                              <div
                                className="ContainerLayer"
                                data-layer-id="81907709-d8c1-46e2-98de-8b586176c128"
                                data-layer-name="Container 2"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 104,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 284,
                                  height: 88,
                                  borderRadius: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0)"
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    boxSizing: "border-box",
                                    overflow: "hidden",
                                    borderRadius: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayerContent"
                                    style={{
                                      position: "absolute",
                                      width: "100%",
                                      height: "100%",
                                      top: 0,
                                      left: 0
                                    }}
                                  >
                                    <div
                                      className="TextLayer"
                                      data-layer-id="71038955-d622-4e9e-9f16-dce0ed723d6b"
                                      data-layer-name="Artist 2"
                                      style={{
                                        position: "absolute",
                                        top: 50,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        opacity: "0.4",
                                        width: 36,
                                        height: 19,
                                        transform: "scale(1.01222, 1)"
                                      }}
                                    >
                                      <svg
                                        width="36px"
                                        height="19px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h36 a0,0 0 0 1 0,0 
                  v19 a0,0 0 0 1 -0,0 
                  h-36 a0,0 0 0 1 -0,-0 
                  v-19 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 16,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Book, Gotham, sans-serif",
                                            fontWeight: 400,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Artist
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="TextLayer"
                                      data-layer-id="69372e50-c995-4355-918c-ed5207fe1bdf"
                                      data-layer-name="Title 2"
                                      style={{
                                        position: "absolute",
                                        top: 23,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        transform:
                                          "translate(0px, -0.5px) scale(1.00148, 1)",
                                        opacity: 1,
                                        width: 37,
                                        height: 23
                                      }}
                                    >
                                      <svg
                                        width="37px"
                                        height="23px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h37 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-37 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 20,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Medium, Gotham, sans-serif",
                                            fontWeight: 500,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Title
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-layer-id="e1ba5af9-9df5-4ed9-80dd-265f5444d1a7"
                                      data-layer-name="album 2"
                                      style={{
                                        position: "absolute",
                                        boxSizing: "border-box",
                                        pointerEvents: "none",
                                        left: 4,
                                        top: 4,
                                        transformOrigin: "0% 0%",
                                        opacity: 1,
                                        width: 80,
                                        height: 80
                                      }}
                                    >
                                      <svg
                                        width="80px"
                                        height="80px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs>
                                          <filter
                                            id="pp-gen-38"
                                            filterUnits="objectBoundingBox"
                                            colorInterpolationFilters="sRGB"
                                            x="-8%"
                                            y="-8%"
                                            width="115%"
                                            height="115%"
                                          >
                                            <feGaussianBlur
                                              in="SourceAlpha"
                                              result="step0"
                                              stdDeviation={2}
                                            />
                                            <feComposite
                                              in="step0"
                                              result="step1"
                                              in2="SourceAlpha"
                                              operator="out"
                                            />
                                            <feColorMatrix
                                              in="step1"
                                              values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.25 0"
                                              type="matrix"
                                            />
                                          </filter>
                                        </defs>
                                        <g>
                                          <path
                                            fill="black"
                                            fillOpacity={1}
                                            filter="url(#pp-gen-38)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                          <path
                                            fill="rgba(210,210,210,1)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <svg
                                  width="284px"
                                  height="88px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible",
                                    pointerEvents: "none"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                              </div>
                              <div
                                className="ContainerLayer"
                                data-layer-id="6f179727-d0da-4277-89ce-e61883198b7b"
                                data-layer-name="Container 3"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 300,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 284,
                                  height: 88,
                                  borderRadius: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0)"
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    boxSizing: "border-box",
                                    overflow: "hidden",
                                    borderRadius: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayerContent"
                                    style={{
                                      position: "absolute",
                                      width: "100%",
                                      height: "100%",
                                      top: 0,
                                      left: 0
                                    }}
                                  >
                                    <div
                                      className="TextLayer"
                                      data-layer-id="62598f85-4ab4-4787-98e0-929b3cc7eaf9"
                                      data-layer-name="Artist 3"
                                      style={{
                                        position: "absolute",
                                        top: 45,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        opacity: "0.4",
                                        width: 36,
                                        height: 19,
                                        transform: "scale(1.01222, 1)"
                                      }}
                                    >
                                      <svg
                                        width="36px"
                                        height="19px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h36 a0,0 0 0 1 0,0 
                  v19 a0,0 0 0 1 -0,0 
                  h-36 a0,0 0 0 1 -0,-0 
                  v-19 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 16,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Book, Gotham, sans-serif",
                                            fontWeight: 400,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Artist
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="TextLayer"
                                      data-layer-id="0a797ab3-e297-4d61-87fa-dcf47c4bea3a"
                                      data-layer-name="Title 3"
                                      style={{
                                        position: "absolute",
                                        top: 18,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        transform:
                                          "translate(0px, -0.5px) scale(1.00148, 1)",
                                        opacity: 1,
                                        width: 37,
                                        height: 23
                                      }}
                                    >
                                      <svg
                                        width="37px"
                                        height="23px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h37 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-37 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 20,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Medium, Gotham, sans-serif",
                                            fontWeight: 500,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Title
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-layer-id="bdd9bde8-cd69-49d6-a28f-91f18ea26819"
                                      data-layer-name="album 3"
                                      style={{
                                        position: "absolute",
                                        boxSizing: "border-box",
                                        pointerEvents: "none",
                                        left: 4,
                                        top: 4,
                                        transformOrigin: "0% 0%",
                                        opacity: 1,
                                        width: 80,
                                        height: 80
                                      }}
                                    >
                                      <svg
                                        width="80px"
                                        height="80px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs>
                                          <filter
                                            id="pp-gen-39"
                                            filterUnits="objectBoundingBox"
                                            colorInterpolationFilters="sRGB"
                                            x="-8%"
                                            y="-8%"
                                            width="115%"
                                            height="115%"
                                          >
                                            <feGaussianBlur
                                              in="SourceAlpha"
                                              result="step0"
                                              stdDeviation={2}
                                            />
                                            <feComposite
                                              in="step0"
                                              result="step1"
                                              in2="SourceAlpha"
                                              operator="out"
                                            />
                                            <feColorMatrix
                                              in="step1"
                                              values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.25 0"
                                              type="matrix"
                                            />
                                          </filter>
                                        </defs>
                                        <g>
                                          <path
                                            fill="black"
                                            fillOpacity={1}
                                            filter="url(#pp-gen-39)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                          <path
                                            fill="rgba(210,210,210,1)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <svg
                                  width="284px"
                                  height="88px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible",
                                    pointerEvents: "none"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                              </div>
                              <div
                                className="ContainerLayer"
                                data-layer-id="a4da4a14-d7b1-41f3-bfb1-cd4c10fcaadc"
                                data-layer-name="Container 4"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 300,
                                  top: 104,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 284,
                                  height: 88,
                                  borderRadius: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0)"
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    boxSizing: "border-box",
                                    overflow: "hidden",
                                    borderRadius: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayerContent"
                                    style={{
                                      position: "absolute",
                                      width: "100%",
                                      height: "100%",
                                      top: 0,
                                      left: 0
                                    }}
                                  >
                                    <div
                                      className="TextLayer"
                                      data-layer-id="74332d99-5b5d-4205-b9e5-2d1241809e12"
                                      data-layer-name="Artist 4"
                                      style={{
                                        position: "absolute",
                                        top: 50,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        opacity: "0.4",
                                        width: 36,
                                        height: 19,
                                        transform: "scale(1.01222, 1)"
                                      }}
                                    >
                                      <svg
                                        width="36px"
                                        height="19px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h36 a0,0 0 0 1 0,0 
                  v19 a0,0 0 0 1 -0,0 
                  h-36 a0,0 0 0 1 -0,-0 
                  v-19 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 16,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Book, Gotham, sans-serif",
                                            fontWeight: 400,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Artist
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="TextLayer"
                                      data-layer-id="53bf6720-fdd8-41eb-b85c-68c346d7e36b"
                                      data-layer-name="Title 4"
                                      style={{
                                        position: "absolute",
                                        top: 23,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        transform:
                                          "translate(0px, -0.5px) scale(1.00148, 1)",
                                        opacity: 1,
                                        width: 37,
                                        height: 23
                                      }}
                                    >
                                      <svg
                                        width="37px"
                                        height="23px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h37 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-37 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 20,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Medium, Gotham, sans-serif",
                                            fontWeight: 500,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Title
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-layer-id="f45062e3-063f-401e-9a8e-f5fec2149ad5"
                                      data-layer-name="album 4"
                                      style={{
                                        position: "absolute",
                                        boxSizing: "border-box",
                                        pointerEvents: "none",
                                        left: 4,
                                        top: 4,
                                        transformOrigin: "0% 0%",
                                        opacity: 1,
                                        width: 80,
                                        height: 80
                                      }}
                                    >
                                      <svg
                                        width="80px"
                                        height="80px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs>
                                          <filter
                                            id="pp-gen-40"
                                            filterUnits="objectBoundingBox"
                                            colorInterpolationFilters="sRGB"
                                            x="-8%"
                                            y="-8%"
                                            width="115%"
                                            height="115%"
                                          >
                                            <feGaussianBlur
                                              in="SourceAlpha"
                                              result="step0"
                                              stdDeviation={2}
                                            />
                                            <feComposite
                                              in="step0"
                                              result="step1"
                                              in2="SourceAlpha"
                                              operator="out"
                                            />
                                            <feColorMatrix
                                              in="step1"
                                              values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.25 0"
                                              type="matrix"
                                            />
                                          </filter>
                                        </defs>
                                        <g>
                                          <path
                                            fill="black"
                                            fillOpacity={1}
                                            filter="url(#pp-gen-40)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                          <path
                                            fill="rgba(210,210,210,1)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <svg
                                  width="284px"
                                  height="88px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible",
                                    pointerEvents: "none"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                              </div>
                              <div
                                className="ContainerLayer"
                                data-layer-id="2855ea35-93b7-4c22-b5f2-29b39e116cac"
                                data-layer-name="Container 5"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 600,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 284,
                                  height: 88,
                                  borderRadius: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0)"
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    boxSizing: "border-box",
                                    overflow: "hidden",
                                    borderRadius: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayerContent"
                                    style={{
                                      position: "absolute",
                                      width: "100%",
                                      height: "100%",
                                      top: 0,
                                      left: 0
                                    }}
                                  >
                                    <div
                                      className="TextLayer"
                                      data-layer-id="5d22a7b3-117f-4b91-a85a-af43b9f6398f"
                                      data-layer-name="Artist 5"
                                      style={{
                                        position: "absolute",
                                        top: 45,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        opacity: "0.4",
                                        width: 36,
                                        height: 19,
                                        transform: "scale(1.01222, 1)"
                                      }}
                                    >
                                      <svg
                                        width="36px"
                                        height="19px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h36 a0,0 0 0 1 0,0 
                  v19 a0,0 0 0 1 -0,0 
                  h-36 a0,0 0 0 1 -0,-0 
                  v-19 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 16,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Book, Gotham, sans-serif",
                                            fontWeight: 400,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Artist
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="TextLayer"
                                      data-layer-id="3f5adaac-f542-4e10-a2ec-6118b8e911e4"
                                      data-layer-name="Title 5"
                                      style={{
                                        position: "absolute",
                                        top: 18,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        transform:
                                          "translate(0px, -0.5px) scale(1.00148, 1)",
                                        opacity: 1,
                                        width: 37,
                                        height: 23
                                      }}
                                    >
                                      <svg
                                        width="37px"
                                        height="23px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h37 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-37 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 20,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Medium, Gotham, sans-serif",
                                            fontWeight: 500,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Title
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-layer-id="4a046980-4f4a-4cd8-a42b-d3dfeaa0445d"
                                      data-layer-name="album 5"
                                      style={{
                                        position: "absolute",
                                        boxSizing: "border-box",
                                        pointerEvents: "none",
                                        left: 4,
                                        top: 4,
                                        transformOrigin: "0% 0%",
                                        opacity: 1,
                                        width: 80,
                                        height: 80
                                      }}
                                    >
                                      <svg
                                        width="80px"
                                        height="80px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs>
                                          <filter
                                            id="pp-gen-41"
                                            filterUnits="objectBoundingBox"
                                            colorInterpolationFilters="sRGB"
                                            x="-8%"
                                            y="-8%"
                                            width="115%"
                                            height="115%"
                                          >
                                            <feGaussianBlur
                                              in="SourceAlpha"
                                              result="step0"
                                              stdDeviation={2}
                                            />
                                            <feComposite
                                              in="step0"
                                              result="step1"
                                              in2="SourceAlpha"
                                              operator="out"
                                            />
                                            <feColorMatrix
                                              in="step1"
                                              values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.25 0"
                                              type="matrix"
                                            />
                                          </filter>
                                        </defs>
                                        <g>
                                          <path
                                            fill="black"
                                            fillOpacity={1}
                                            filter="url(#pp-gen-41)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                          <path
                                            fill="rgba(210,210,210,1)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <svg
                                  width="284px"
                                  height="88px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible",
                                    pointerEvents: "none"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                              </div>
                              <div
                                className="ContainerLayer"
                                data-layer-id="560603e8-342c-44a0-8eaa-2bb3e1b01a0e"
                                data-layer-name="Container 6"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 600,
                                  top: 104,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 284,
                                  height: 88,
                                  borderRadius: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0)"
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    boxSizing: "border-box",
                                    overflow: "hidden",
                                    borderRadius: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayerContent"
                                    style={{
                                      position: "absolute",
                                      width: "100%",
                                      height: "100%",
                                      top: 0,
                                      left: 0
                                    }}
                                  >
                                    <div
                                      className="TextLayer"
                                      data-layer-id="07ee12da-e740-4cfb-8dd8-36098314e485"
                                      data-layer-name="Artist 6"
                                      style={{
                                        position: "absolute",
                                        top: 50,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        opacity: "0.4",
                                        width: 36,
                                        height: 19,
                                        transform: "scale(1.01222, 1)"
                                      }}
                                    >
                                      <svg
                                        width="36px"
                                        height="19px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h36 a0,0 0 0 1 0,0 
                  v19 a0,0 0 0 1 -0,0 
                  h-36 a0,0 0 0 1 -0,-0 
                  v-19 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 16,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Book, Gotham, sans-serif",
                                            fontWeight: 400,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Artist
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="TextLayer"
                                      data-layer-id="a6420c29-3363-46bb-b572-9f90a9cd84af"
                                      data-layer-name="Title 6"
                                      style={{
                                        position: "absolute",
                                        top: 23,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        transform:
                                          "translate(0px, -0.5px) scale(1.00148, 1)",
                                        opacity: 1,
                                        width: 37,
                                        height: 23
                                      }}
                                    >
                                      <svg
                                        width="37px"
                                        height="23px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h37 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-37 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 20,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Medium, Gotham, sans-serif",
                                            fontWeight: 500,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Title
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-layer-id="4b20359f-016e-4d2c-988b-3b0cad63e020"
                                      data-layer-name="album 6"
                                      style={{
                                        position: "absolute",
                                        boxSizing: "border-box",
                                        pointerEvents: "none",
                                        left: 4,
                                        top: 4,
                                        transformOrigin: "0% 0%",
                                        opacity: 1,
                                        width: 80,
                                        height: 80
                                      }}
                                    >
                                      <svg
                                        width="80px"
                                        height="80px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs>
                                          <filter
                                            id="pp-gen-42"
                                            filterUnits="objectBoundingBox"
                                            colorInterpolationFilters="sRGB"
                                            x="-8%"
                                            y="-8%"
                                            width="115%"
                                            height="115%"
                                          >
                                            <feGaussianBlur
                                              in="SourceAlpha"
                                              result="step0"
                                              stdDeviation={2}
                                            />
                                            <feComposite
                                              in="step0"
                                              result="step1"
                                              in2="SourceAlpha"
                                              operator="out"
                                            />
                                            <feColorMatrix
                                              in="step1"
                                              values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.25 0"
                                              type="matrix"
                                            />
                                          </filter>
                                        </defs>
                                        <g>
                                          <path
                                            fill="black"
                                            fillOpacity={1}
                                            filter="url(#pp-gen-42)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                          <path
                                            fill="rgba(210,210,210,1)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <svg
                                  width="284px"
                                  height="88px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible",
                                    pointerEvents: "none"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                              </div>
                              <div
                                className="ContainerLayer"
                                data-layer-id="b60913b9-3cce-4600-8c6d-0ec2bb666f3f"
                                data-layer-name="Container 7"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 900,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 284,
                                  height: 88,
                                  borderRadius: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0)"
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    boxSizing: "border-box",
                                    overflow: "hidden",
                                    borderRadius: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayerContent"
                                    style={{
                                      position: "absolute",
                                      width: "100%",
                                      height: "100%",
                                      top: 0,
                                      left: 0
                                    }}
                                  >
                                    <div
                                      className="TextLayer"
                                      data-layer-id="2af21f08-1fb1-49d7-805d-429da593983b"
                                      data-layer-name="Artist 7"
                                      style={{
                                        position: "absolute",
                                        top: 45,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        opacity: "0.4",
                                        width: 36,
                                        height: 19,
                                        transform: "scale(1.01222, 1)"
                                      }}
                                    >
                                      <svg
                                        width="36px"
                                        height="19px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h36 a0,0 0 0 1 0,0 
                  v19 a0,0 0 0 1 -0,0 
                  h-36 a0,0 0 0 1 -0,-0 
                  v-19 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 16,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Book, Gotham, sans-serif",
                                            fontWeight: 400,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Artist
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="TextLayer"
                                      data-layer-id="ce849b32-e32a-4ede-8fde-454b91132ec4"
                                      data-layer-name="Title 7"
                                      style={{
                                        position: "absolute",
                                        top: 18,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        transform:
                                          "translate(0px, -0.5px) scale(1.00148, 1)",
                                        opacity: 1,
                                        width: 37,
                                        height: 23
                                      }}
                                    >
                                      <svg
                                        width="37px"
                                        height="23px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h37 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-37 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 20,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Medium, Gotham, sans-serif",
                                            fontWeight: 500,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Title
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-layer-id="be65253e-ebbe-4bb0-bf5b-7f7b10954624"
                                      data-layer-name="album 7"
                                      style={{
                                        position: "absolute",
                                        boxSizing: "border-box",
                                        pointerEvents: "none",
                                        left: 4,
                                        top: 4,
                                        transformOrigin: "0% 0%",
                                        opacity: 1,
                                        width: 80,
                                        height: 80
                                      }}
                                    >
                                      <svg
                                        width="80px"
                                        height="80px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs>
                                          <filter
                                            id="pp-gen-43"
                                            filterUnits="objectBoundingBox"
                                            colorInterpolationFilters="sRGB"
                                            x="-8%"
                                            y="-8%"
                                            width="115%"
                                            height="115%"
                                          >
                                            <feGaussianBlur
                                              in="SourceAlpha"
                                              result="step0"
                                              stdDeviation={2}
                                            />
                                            <feComposite
                                              in="step0"
                                              result="step1"
                                              in2="SourceAlpha"
                                              operator="out"
                                            />
                                            <feColorMatrix
                                              in="step1"
                                              values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.25 0"
                                              type="matrix"
                                            />
                                          </filter>
                                        </defs>
                                        <g>
                                          <path
                                            fill="black"
                                            fillOpacity={1}
                                            filter="url(#pp-gen-43)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                          <path
                                            fill="rgba(210,210,210,1)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <svg
                                  width="284px"
                                  height="88px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible",
                                    pointerEvents: "none"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                              </div>
                              <div
                                className="ContainerLayer"
                                data-layer-id="3ee1eaca-957b-4384-97cc-bc624324f3a3"
                                data-layer-name="Container 8"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 900,
                                  top: 104,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 284,
                                  height: 88,
                                  borderRadius: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0)"
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    boxSizing: "border-box",
                                    overflow: "hidden",
                                    borderRadius: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayerContent"
                                    style={{
                                      position: "absolute",
                                      width: "100%",
                                      height: "100%",
                                      top: 0,
                                      left: 0
                                    }}
                                  >
                                    <div
                                      className="TextLayer"
                                      data-layer-id="579754d6-4d14-49a8-b3e1-b4aec44ec301"
                                      data-layer-name="Artist 8"
                                      style={{
                                        position: "absolute",
                                        top: 50,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        opacity: "0.4",
                                        width: 36,
                                        height: 19,
                                        transform: "scale(1.01222, 1)"
                                      }}
                                    >
                                      <svg
                                        width="36px"
                                        height="19px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h36 a0,0 0 0 1 0,0 
                  v19 a0,0 0 0 1 -0,0 
                  h-36 a0,0 0 0 1 -0,-0 
                  v-19 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 16,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Book, Gotham, sans-serif",
                                            fontWeight: 400,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Artist
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="TextLayer"
                                      data-layer-id="580fb168-e3d4-4034-aed2-a535658f0785"
                                      data-layer-name="Title 8"
                                      style={{
                                        position: "absolute",
                                        top: 23,
                                        left: 104,
                                        pointerEvents: "none",
                                        transformOrigin: "0% 50%",
                                        transform:
                                          "translate(0px, -0.5px) scale(1.00148, 1)",
                                        opacity: 1,
                                        width: 37,
                                        height: 23
                                      }}
                                    >
                                      <svg
                                        width="37px"
                                        height="23px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs />
                                        <g>
                                          <path
                                            fill="rgba(207,207,207,0)"
                                            d="
                  M0,0 
                  h37 a0,0 0 0 1 0,0 
                  v23 a0,0 0 0 1 -0,0 
                  h-37 a0,0 0 0 1 -0,-0 
                  v-23 a0,0 0 0 1 0,-0 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          boxSizing: "border-box",
                                          overflow: "hidden"
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            WebkitFontSmoothing: "antialiased",
                                            whiteSpace: "pre",
                                            fontSize: 20,
                                            textAlign: "left",
                                            lineHeight: "1.2",
                                            letterSpacing: 0,
                                            fontFamily:
                                              "Gotham-Medium, Gotham, sans-serif",
                                            fontWeight: 500,
                                            fontStyle: "normal",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            color: "rgb(0, 0, 0)"
                                          }}
                                        >
                                          Title
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-layer-id="09a57df8-7e85-4ac2-a115-54e6b341595a"
                                      data-layer-name="album 8"
                                      style={{
                                        position: "absolute",
                                        boxSizing: "border-box",
                                        pointerEvents: "none",
                                        left: 4,
                                        top: 4,
                                        transformOrigin: "0% 0%",
                                        opacity: 1,
                                        width: 80,
                                        height: 80
                                      }}
                                    >
                                      <svg
                                        width="80px"
                                        height="80px"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <defs>
                                          <filter
                                            id="pp-gen-44"
                                            filterUnits="objectBoundingBox"
                                            colorInterpolationFilters="sRGB"
                                            x="-8%"
                                            y="-8%"
                                            width="115%"
                                            height="115%"
                                          >
                                            <feGaussianBlur
                                              in="SourceAlpha"
                                              result="step0"
                                              stdDeviation={2}
                                            />
                                            <feComposite
                                              in="step0"
                                              result="step1"
                                              in2="SourceAlpha"
                                              operator="out"
                                            />
                                            <feColorMatrix
                                              in="step1"
                                              values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.25 0"
                                              type="matrix"
                                            />
                                          </filter>
                                        </defs>
                                        <g>
                                          <path
                                            fill="black"
                                            fillOpacity={1}
                                            filter="url(#pp-gen-44)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                          <path
                                            fill="rgba(210,210,210,1)"
                                            d="
                  M2,0 
                  h76 a2,2 0 0 1 2,2 
                  v76 a2,2 0 0 1 -2,2 
                  h-76 a2,2 0 0 1 -2,-2 
                  v-76 a2,2 0 0 1 2,-2 
                  z
              "
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <svg
                                  width="284px"
                                  height="88px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible",
                                    pointerEvents: "none"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="ContainerLayer"
                        data-layer-id="a2b8ae22-c803-440f-af9b-585885cb46a3"
                        data-layer-name="bottom"
                        style={{
                          position: "absolute",
                          boxSizing: "border-box",
                          pointerEvents: "none",
                          left: 0,
                          top: 1100,
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 1900,
                          height: 100,
                          borderRadius: 0,
                          backgroundColor: "rgb(0, 0, 0)"
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            boxSizing: "border-box",
                            overflow: "hidden",
                            borderRadius: 0
                          }}
                        >
                          <div
                            className="ContainerLayerContent"
                            style={{
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              top: 0,
                              left: 0
                            }}
                          >
                            <div
                              className="ContainerLayer"
                              data-layer-id="ab80bef9-e897-4ea0-b116-a66f0ac6bc62"
                              data-layer-name="fanblades 1"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: 239,
                                top: 25,
                                transformOrigin: "0% 0%",
                                opacity: "0.9",
                                width: 50,
                                height: 50,
                                borderRadius: 0,
                                backgroundColor: "rgba(255, 255, 255, 0)"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  boxSizing: "border-box",
                                  overflow: "hidden",
                                  borderRadius: 0
                                }}
                              >
                                <div
                                  className="ContainerLayerContent"
                                  style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    top: 0,
                                    left: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayer"
                                    data-layer-id="49cdfac1-ffa3-4ee9-b3c0-bb911ce8adca"
                                    data-layer-name="Group"
                                    style={{
                                      position: "absolute",
                                      boxSizing: "border-box",
                                      pointerEvents: "none",
                                      left: 0,
                                      top: 0,
                                      transformOrigin: "0% 0%",
                                      opacity: 1,
                                      width: 50,
                                      height: 50,
                                      borderRadius: 0,
                                      backgroundColor: "rgba(255, 255, 255, 0)"
                                    }}
                                  >
                                    <svg
                                      width="50px"
                                      height="50px"
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        overflow: "visible"
                                      }}
                                    >
                                      <defs />
                                      <g>
                                        <path />
                                      </g>
                                    </svg>
                                    <div
                                      className="ContainerLayerContent"
                                      style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        left: 0
                                      }}
                                    >
                                      <div
                                        data-layer-id="18d9390d-cf54-4ca7-bcbe-ba17371fc79b"
                                        data-layer-name="Vector"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible",
                                          pointerEvents: "none",
                                          transformOrigin: "0% 0%",
                                          opacity: 0,
                                          width: 51,
                                          height: 51
                                        }}
                                      >
                                        <img
                                          src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/c27d7406f7835f41113447b8832708a582c16b02.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9jMjdkNzQwNmY3ODM1ZjQxMTEzNDQ3Yjg4MzI3MDhhNTgyYzE2YjAyLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=EESe~5Qvm4IwG6ohJATO6IoO7sdny26l118JXdSSgtliVpOMEbSO98Hutp2BZnB2lpnwoFu8IRo8F5AhxKx-qDut6UhrleNsFai8ZpaKJhTEUX4MQCnVf9TuGJ7yNBoxnjMCdgsH1658fLxxwuz0zBdYhi4LtLDMYjAI5vrAx0OxZFVgW9V1S8kAzabnfGZhrZj~0SqPlnUaV~Gy7SD0nBvLNcUxL2ibK-wNkYmDnAtGSvqc9C1IZDjAAiOXLHBBfAZqtQ5O4T4BZsNGreyUWXZbPjmOgQYxG9IJtHz1eX8u4sxG8apvP4gOBNNgfUKnDXarZE~YDlA5kN4f9qZdGQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: 0
                                          }}
                                        />
                                        <svg
                                          width="51px"
                                          height="51px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                      </div>
                                      <div
                                        data-layer-id="affc83ae-f255-4354-8776-b96590984d02"
                                        data-layer-name="Vector"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible",
                                          pointerEvents: "none",
                                          transformOrigin: "0% 0%",
                                          opacity: 1,
                                          width: 51,
                                          height: 51
                                        }}
                                      >
                                        <img
                                          src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/ef61821bce8bb2d02b4f98e7cb3cb043f6a403ac.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9lZjYxODIxYmNlOGJiMmQwMmI0Zjk4ZTdjYjNjYjA0M2Y2YTQwM2FjLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=hEyp1mBerdbWMSKgSzMr4mBeh0itUfcY7iLekGSutaFJeIwXh7hU586p0wLg3m5OCWXE-t~akR3JkNr6EoG5WjF2WH09Yf0v6p5WX9nbxFFvGk6cnhBdnatRplBDacKDu0qJiyq7Z~~N7gx7M~ZfW-otcAx-eQGmhPj9pBtyPqxs7e7cJ~lYE1Rm7YxoWkwpatu5jdrATxB9waLK7B-7j2xwkzoA1KmlMMgqgYorp16VYMoeHLcYYXd2X6qZmo6ebEiuQThS8ysokOvf9mke45-yvEBQ1sZoooS2cpqQ72sC8QeIu~4TAp4jeJyB7E1spL7vuOgevjOufBOSu7VdAA__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: 0
                                          }}
                                        />
                                        <svg
                                          width="51px"
                                          height="51px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <svg
                                width="50px"
                                height="50px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible",
                                  pointerEvents: "none"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                            </div>
                            <div
                              className="ContainerLayer"
                              data-layer-id="9ef77875-8df6-41f7-88f4-8586bd5c82ab"
                              data-layer-name="hazardsign 1"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: 925,
                                top: 28,
                                transformOrigin: "0% 0%",
                                opacity: "0.9",
                                width: 49,
                                height: 45,
                                borderRadius: 0,
                                backgroundColor: "rgba(255, 255, 255, 0)"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  boxSizing: "border-box",
                                  overflow: "hidden",
                                  borderRadius: 0
                                }}
                              >
                                <div
                                  className="ContainerLayerContent"
                                  style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    top: 0,
                                    left: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayer"
                                    data-layer-id="683abd35-f0ed-466c-bcff-ffd7364d3d1c"
                                    data-layer-name="Group"
                                    style={{
                                      position: "absolute",
                                      boxSizing: "border-box",
                                      pointerEvents: "none",
                                      left: 0,
                                      top: 0,
                                      transformOrigin: "0% 0%",
                                      opacity: 1,
                                      width: 49,
                                      height: 45,
                                      borderRadius: 0,
                                      backgroundColor: "rgba(255, 255, 255, 0)"
                                    }}
                                  >
                                    <svg
                                      width="49px"
                                      height="45px"
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        overflow: "visible"
                                      }}
                                    >
                                      <defs />
                                      <g>
                                        <path />
                                      </g>
                                    </svg>
                                    <div
                                      className="ContainerLayerContent"
                                      style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        left: 0
                                      }}
                                    >
                                      <div
                                        data-layer-id="9e5ba5f2-0b9b-47e5-8137-00841b89b555"
                                        data-layer-name="Vector"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible",
                                          pointerEvents: "none",
                                          transformOrigin: "0% 0%",
                                          opacity: 0,
                                          width: 50,
                                          height: 45
                                        }}
                                      >
                                        <img
                                          src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/6f5617268922e99fff8bc577b6c519a4e01a1d20.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy82ZjU2MTcyNjg5MjJlOTlmZmY4YmM1NzdiNmM1MTlhNGUwMWExZDIwLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=HYsLqf4e8BWlr9ATElgqaXa5FieCP7h1bTiV5iIYp1Qr3~sDMJwSMOQEF63jlutNX6S9MRoSyuKPpBYjoxI6B2Z5iv69Yl7MzMrMEOc9bdcJOn2oZdjSQiJjeRiP7qPBpQgnWX4R87rtKFQD4nUvQKUSmOrgn7S3s3Mmr1Dg0a-d5vvgfiwZzCIKbnNdBWbnu8SZaip~bbTwBkSvMhHD~CRnfxWsgCT-GKOauIAA5PANl25O3-nTVYxR-FHSprNxLfPlx5nx04-b9XfmUcPvG56m8ShKsIJSgqKCP9nghvuU7S0IrBtJPRj-qgcKQXvNp5LyHn~-t9BEJiz59jB0qQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: 0
                                          }}
                                        />
                                        <svg
                                          width="50px"
                                          height="45px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                      </div>
                                      <div
                                        data-layer-id="84599736-49cb-4b30-abc0-a60633f310db"
                                        data-layer-name="Vector"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible",
                                          pointerEvents: "none",
                                          transformOrigin: "0% 0%",
                                          opacity: 1,
                                          width: 50,
                                          height: 45
                                        }}
                                      >
                                        <img
                                          src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/3cd6307c9ff75997c5ec2d4c0354c26c71bbbd23.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8zY2Q2MzA3YzlmZjc1OTk3YzVlYzJkNGMwMzU0YzI2YzcxYmJiZDIzLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=csa22n0bqg3b1T~CMT2AijFDnQmQpMQhdTfrb4r8HGFnxZk274r2mxMbHOZmA8bAzbSePQ0ej6zYO5OqapbqJ8ro92n~~Ovo8nMx5ycS8Lic5jLFr-LvUcaRdR5bOr7OHva33Jzo-hjPlmAUgGVA3FZOU9tG0lMXoYXoN9hf8V0hhRr7cqo3X40jIrl4BWbXnyLnoq~wSrxHDrmE-Gu9dyhHmKdGwI7IfLg5di0BmNJ39zlvqrQLLC1adYX4o3X6C15fYzqD5DwWiDrDVjCDFOir4t3hXLVjeDqOn7szN9SvCIoTdVq4Ug1hXaO-fJzpfUConPdqkA0VUQ0eSFvdsQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: 0
                                          }}
                                        />
                                        <svg
                                          width="50px"
                                          height="45px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <svg
                                width="49px"
                                height="45px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible",
                                  pointerEvents: "none"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                            </div>
                            <div
                              className="ContainerLayer"
                              data-layer-id="880594cf-439c-4353-b68d-3fdbf4900744"
                              data-layer-name="figure.seated.side.windshield.front.and.heat.waves 1"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: 1096,
                                top: 26,
                                transformOrigin: "0% 0%",
                                opacity: "0.9",
                                width: 51,
                                height: 48,
                                borderRadius: 0,
                                backgroundColor: "rgba(255, 255, 255, 0)"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  boxSizing: "border-box",
                                  overflow: "hidden",
                                  borderRadius: 0
                                }}
                              >
                                <div
                                  className="ContainerLayerContent"
                                  style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    top: 0,
                                    left: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayer"
                                    data-layer-id="67573a9a-b5dc-406b-a8ab-6fdecb62c7f6"
                                    data-layer-name="Group"
                                    style={{
                                      position: "absolute",
                                      boxSizing: "border-box",
                                      pointerEvents: "none",
                                      left: 0,
                                      top: 0,
                                      transformOrigin: "0% 0%",
                                      opacity: 1,
                                      width: 51,
                                      height: 48,
                                      borderRadius: 0,
                                      backgroundColor: "rgba(255, 255, 255, 0)"
                                    }}
                                  >
                                    <svg
                                      width="51px"
                                      height="48px"
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        overflow: "visible"
                                      }}
                                    >
                                      <defs />
                                      <g>
                                        <path />
                                      </g>
                                    </svg>
                                    <div
                                      className="ContainerLayerContent"
                                      style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        left: 0
                                      }}
                                    >
                                      <div
                                        data-layer-id="05bd6f28-0985-4df9-a403-912740168a7a"
                                        data-layer-name="Vector"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible",
                                          pointerEvents: "none",
                                          transformOrigin: "0% 0%",
                                          opacity: 0,
                                          width: 51,
                                          height: 48
                                        }}
                                      >
                                        <img
                                          src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/28b2c063408c5ead653cf2579cc9f2069393d6d8.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8yOGIyYzA2MzQwOGM1ZWFkNjUzY2YyNTc5Y2M5ZjIwNjkzOTNkNmQ4LnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=QuGyN~aYIWFleAEk83sEWU3ODmUd8XFTJOgAGh-ITAox3agQfktohL-YGOZ36Sb51eftq-UpdzA9EEiXTtrrT2JnwpOz7~cKTL52ZnolU3tHTQ7hCVfmc70Wu8~49oYZQ5y2uaQB-J3x0Irgm-QMPo0JCRZrpAPd4b5R3ZLFGTTVyzapn2klwxh6QrHLQdHo76ZgVHyJ0DINAfzgYrj5x6roporqcePRBcmsbGQV8rsxW6FANz~llhuozBwutkwk8ySuKHIQvL6P0T13IueWt1J3al7AdrwUHuIGcpnLDOuFIkAsOAkDJ7nmiuAqsFCtBiZEvieTwpUgQTiP6Q~QBg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: 0
                                          }}
                                        />
                                        <svg
                                          width="51px"
                                          height="48px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                      </div>
                                      <div
                                        data-layer-id="e7934bde-14b6-49a0-bfa2-86fc7036602a"
                                        data-layer-name="Vector"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible",
                                          pointerEvents: "none",
                                          transformOrigin: "0% 0%",
                                          opacity: 1,
                                          width: 51,
                                          height: 48
                                        }}
                                      >
                                        <img
                                          src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/e0b7ff399141e46d768641b19ee48aad917f41d4.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9lMGI3ZmYzOTkxNDFlNDZkNzY4NjQxYjE5ZWU0OGFhZDkxN2Y0MWQ0LnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=KZmYIKY4fs7xeNTcC9Ez~f3-o7m7UW5JTiMrq6rBVEQkWEUQFVih-xNH~EIafeVWs7o-CcqvLv6Dopq52UOMp1q2eLnxb23wrVsl~YK9gsNc1Z94g14V89xO0UeLUL8vEfwtfyFeFJOLkj2l-FxFyY0bvdiX5U~cJmz2brxJh-AJOLanasfarnQlEFNY2OiW72aIe-vgOTr1dhpw0pd2GdNdwGGX7YVavdPuZhprZtvWLUovl~jP3XSx6grWH1Q-5euSe1J8VJ6hbyC-Nsmc1sAnn0BVqA2zMIFU3QmYYkmezaoyvapTyQC-FFOvQGGXtbPo~uqazRvZgctG9ZqpkA__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: 0
                                          }}
                                        />
                                        <svg
                                          width="51px"
                                          height="48px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <svg
                                width="51px"
                                height="48px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible",
                                  pointerEvents: "none"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                            </div>
                            <div
                              className="ContainerLayer"
                              data-layer-id="e87bd38c-0af1-4c0e-8cbe-d3a3d95aa762"
                              data-layer-name="steeringwheel.and.heat.waves 1"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: 746,
                                top: 22,
                                transformOrigin: "0% 0%",
                                opacity: "0.9",
                                width: 57,
                                height: 56,
                                borderRadius: 0,
                                backgroundColor: "rgba(255, 255, 255, 0)"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  boxSizing: "border-box",
                                  overflow: "hidden",
                                  borderRadius: 0
                                }}
                              >
                                <div
                                  className="ContainerLayerContent"
                                  style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    top: 0,
                                    left: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayer"
                                    data-layer-id="c7766575-73ac-4908-bd72-dab66c9827c6"
                                    data-layer-name="Group"
                                    style={{
                                      position: "absolute",
                                      boxSizing: "border-box",
                                      pointerEvents: "none",
                                      left: 0,
                                      top: 0,
                                      transformOrigin: "0% 0%",
                                      opacity: 1,
                                      width: 57,
                                      height: 56,
                                      borderRadius: 0,
                                      backgroundColor: "rgba(255, 255, 255, 0)"
                                    }}
                                  >
                                    <svg
                                      width="57px"
                                      height="56px"
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        overflow: "visible"
                                      }}
                                    >
                                      <defs />
                                      <g>
                                        <path />
                                      </g>
                                    </svg>
                                    <div
                                      className="ContainerLayerContent"
                                      style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        left: 0
                                      }}
                                    >
                                      <div
                                        data-layer-id="51fbb3bb-5b9d-4f36-b5fd-cd2323d53c6b"
                                        data-layer-name="Vector"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible",
                                          pointerEvents: "none",
                                          transformOrigin: "0% 0%",
                                          opacity: 0,
                                          width: 57,
                                          height: 57
                                        }}
                                      >
                                        <img
                                          src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/81c3f34cdb4cb0480721531dd0e0eb17057a70e2.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy84MWMzZjM0Y2RiNGNiMDQ4MDcyMTUzMWRkMGUwZWIxNzA1N2E3MGUyLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=X5M54lvS4ms8xs7dXkB4cNqmP0lpQwEe27rZeEkp3aeXxqJj0jmHhWs3n3mT0Q4wg-L2hZZ~gfVtZzE70JbhVrAjl4xPMpfYYBckpq2DoYtRRIJAaY1NdHlFMsjCapIwJ1YPkt6pwQysxwkuEkLpKpFQMusTqsz8D0Oum19w1JqSW-MmTXDqL2C~QuCSAU4QvzMT5bUYaDp7Gz0TK3Ew2U85Jvosz~aZ6tgSoWR91qvBrLjhb05m7D8HREvPV0VBdASZwSKqQ~~CexPqIbL33ikKUYB75qUjaP1FOWoFwulqGPe7Ldc3DtegnGZtDepbpaDC9SIrtvzpTbwJi6lyIw__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: 0
                                          }}
                                        />
                                        <svg
                                          width="57px"
                                          height="57px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                      </div>
                                      <div
                                        data-layer-id="8c59c1bb-6e0d-441a-b631-be6f6d48bf53"
                                        data-layer-name="Vector"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible",
                                          pointerEvents: "none",
                                          transformOrigin: "0% 0%",
                                          opacity: 1,
                                          width: 57,
                                          height: 52
                                        }}
                                      >
                                        <img
                                          src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/12a1ec5c9a7794b8799225ff47f9a9794a8a3084.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8xMmExZWM1YzlhNzc5NGI4Nzk5MjI1ZmY0N2Y5YTk3OTRhOGEzMDg0LnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=cxUroTBO78Ci79sNZyXTDkenKQ6fK7NqQ0lFOS8d0tUQccsQ8LCAH7Ebt1LP~b1Pn2FQegyFISrhG2QFfjCwSDwUgfU9x4n-g338kXfZUX2MFQw~rgalhmiwK6eFVpF6uCKXYP3F9M9lTq8g2rv3y0CoBH~zaOeL4I9vxcxZ~PEQc6oXS-DZhGtpl1m9mPlcIrJEv~nnLjI2w9DPJbHk9EHFpgolYMHNarbYiyU7xCewENUXw33GnRJQ57U5OeaWZFdyR-TJ0CAW8Pxu2~rhCVApbdCZ2Wwu81Fjylg83G0qxWcCCy~TqX8p1sblWHTRvNlcZyI4S4DcTJ1fFKMbFA__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: 0
                                          }}
                                        />
                                        <svg
                                          width="57px"
                                          height="52px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <svg
                                width="57px"
                                height="56px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible",
                                  pointerEvents: "none"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                            </div>
                            <div
                              className="ContainerLayer"
                              data-layer-id="bb0b927f-782b-409a-a506-7d5c9c0a4366"
                              data-layer-name="Group 6"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: 59,
                                top: 10,
                                transformOrigin: "0% 0%",
                                opacity: "0.9",
                                width: 59,
                                height: 80,
                                borderRadius: 0,
                                backgroundColor: "rgba(255, 255, 255, 0)"
                              }}
                            >
                              <svg
                                width="59px"
                                height="80px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                              <div
                                className="ContainerLayerContent"
                                style={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "100%",
                                  top: 0,
                                  left: 0
                                }}
                              >
                                <div
                                  data-layer-id="17ac86b6-b2bd-4035-b064-5db29d9513cf"
                                  data-layer-name="19°"
                                  style={{
                                    position: "absolute",
                                    top: 16,
                                    left: 0,
                                    overflow: "visible",
                                    pointerEvents: "none",
                                    transformOrigin: "50% 50%",
                                    opacity: 1,
                                    width: 59,
                                    height: 48
                                  }}
                                >
                                  <img
                                    src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/9852fa5294cd56ef663dc18ef6b82ac459573292.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy85ODUyZmE1Mjk0Y2Q1NmVmNjYzZGMxOGVmNmI4MmFjNDU5NTczMjkyLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=Mwa7nKsPgZgwoZrUkE48UGIMABYPxPo6OkY1RyPe~FsvIuGr5h4aoIhWUtJAfDDzEAX1mBzLgas8J6wBcIS4GqWBu9kedfAq6vvxJaauKpEkMAj5BNDK1jF1F6NJK21ZqiHf5h69pyJC2TteqzR0Xq-kx215pSkgMWMN3k8rIbSBnG2xlFdLles~H9KddECrn8my70pE1GDeqMcsvklyfemNuUWPOGpQNtoGFaYck642Hy68l3I~XdCQ0~uXv73B-uX1Mrv-pBm45P2Veb9eDKOFIVJA7Oio3M1uFvL3j3LSwms0lPReDBWZ7SCYV41MXRHdZddarJhGoOCDJy9Lnw__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      borderRadius: 0
                                    }}
                                  />
                                  <svg
                                    width="59px"
                                    height="48px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible"
                                    }}
                                  >
                                    <defs />
                                    <g>
                                      <path />
                                    </g>
                                  </svg>
                                </div>
                                <div
                                  className="ContainerLayer"
                                  data-layer-id="aa4fc304-6792-4963-a99b-5d6a7c830324"
                                  data-layer-name="chevron.up 1"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 21,
                                    top: 0,
                                    transformOrigin: "0% 0%",
                                    opacity: 1,
                                    width: 16,
                                    height: 10,
                                    borderRadius: 0,
                                    backgroundColor: "rgba(255, 255, 255, 0)"
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "absolute",
                                      inset: 0,
                                      boxSizing: "border-box",
                                      overflow: "hidden",
                                      borderRadius: 0
                                    }}
                                  >
                                    <div
                                      className="ContainerLayerContent"
                                      style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        left: 0
                                      }}
                                    >
                                      <div
                                        className="ContainerLayer"
                                        data-layer-id="e3544258-9135-44f8-967c-df9564e72eda"
                                        data-layer-name="Group"
                                        style={{
                                          position: "absolute",
                                          boxSizing: "border-box",
                                          pointerEvents: "none",
                                          left: 0,
                                          top: 0,
                                          transformOrigin: "0% 0%",
                                          opacity: 1,
                                          width: 16,
                                          height: 10,
                                          borderRadius: 0,
                                          backgroundColor:
                                            "rgba(255, 255, 255, 0)"
                                        }}
                                      >
                                        <svg
                                          width="16px"
                                          height="10px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                        <div
                                          className="ContainerLayerContent"
                                          style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            top: 0,
                                            left: 0
                                          }}
                                        >
                                          <div
                                            data-layer-id="2641d8c5-542a-4a06-81c6-40ae6c39ed37"
                                            data-layer-name="Vector"
                                            style={{
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                              overflow: "visible",
                                              pointerEvents: "none",
                                              transformOrigin: "0% 0%",
                                              opacity: 0,
                                              width: 17,
                                              height: 10
                                            }}
                                          >
                                            <img
                                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/d2cab825a62075cfa6679e522e693cda456ae518.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9kMmNhYjgyNWE2MjA3NWNmYTY2NzllNTIyZTY5M2NkYTQ1NmFlNTE4LnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=ARUM~OMTDRiIaANcWI8C4uECICTmstfmqvNYAeWXGtXvz~e4R-pP0nHnmXlFuVjFODT6te9s7fPjruhZ3~mUytet1TqBk2jAicJz3ZyyyZ6Ie0rkAGEuEZG03~MpioKHKZ3x8Jh1doRd15niik4vpWPNb16C9E0j-xvfvbWZS-ezfxqVE3BycXQFiR6LV2W-BJWvcNNbXhfDyV1yrdvY9x8RK8ZF6CHSDG~wL~wCyW-hKwDkyCv9p2mM2gVogkCe8iPH-XdloTkcIgiAFqEuCJHImpsFpIHsXXhX0OPu90MQDeXHhzCTReP8BDze1AJKlp4UoAb2n4Pu~EMXxHT6pg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: 0
                                              }}
                                            />
                                            <svg
                                              width="17px"
                                              height="10px"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                overflow: "visible"
                                              }}
                                            >
                                              <defs />
                                              <g>
                                                <path />
                                              </g>
                                            </svg>
                                          </div>
                                          <div
                                            data-layer-id="2b57f2aa-9768-4fbd-8cd9-a70fe236d197"
                                            data-layer-name="Vector"
                                            style={{
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                              overflow: "visible",
                                              pointerEvents: "none",
                                              transformOrigin: "0% 0%",
                                              opacity: 1,
                                              width: 17,
                                              height: 10
                                            }}
                                          >
                                            <img
                                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/e820048b4326bc846110d7b908c54d26f3978b32.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9lODIwMDQ4YjQzMjZiYzg0NjExMGQ3YjkwOGM1NGQyNmYzOTc4YjMyLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=eYRWRh1Mk8pAfSgH6k0qncxPIDmJkipMm9eI~m7TNEgGfNpb63RvYNvxC4GRvUkKu0ASuDaF8LIAEjLnc-QkR~cz8a1SuoWm4Wqi7OSNjjbSDj8ikAAf7jfAhSLkQCLUyEdVkz177AdobBUzynBKlcfL1MgR7Nx~EextnE6MnnMxUM35MTbUoPfmvOJGGWsJUX05g05ryJ8jDH6-QZFv2uh0QF7~kkfm176cHjZFurKIB1VgB~LAdcq9nfvcmr-V6~N22Ua4xDM8zcEs~VVyvkkod5bUsUEy-sLUCsGCZ-esNhnasCemOHJ9R74WMlgzu4WBcCpWSxfp1EZIDoDWGw__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: 0
                                              }}
                                            />
                                            <svg
                                              width="17px"
                                              height="10px"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                overflow: "visible"
                                              }}
                                            >
                                              <defs />
                                              <g>
                                                <path />
                                              </g>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <svg
                                    width="16px"
                                    height="10px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible",
                                      pointerEvents: "none"
                                    }}
                                  >
                                    <defs />
                                    <g>
                                      <path />
                                    </g>
                                  </svg>
                                </div>
                                <div
                                  className="ContainerLayer"
                                  data-layer-id="18920056-1d0d-4098-88f6-329e67585a93"
                                  data-layer-name="chevron.up 2"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 21,
                                    top: 70,
                                    transformOrigin: "50% 50%",
                                    transform:
                                      "translate(-0.14px, 0.04px) rotate(180deg)",
                                    opacity: 1,
                                    width: 16,
                                    height: 10,
                                    borderRadius: 0,
                                    backgroundColor: "rgba(255, 255, 255, 0)"
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "absolute",
                                      inset: 0,
                                      boxSizing: "border-box",
                                      overflow: "hidden",
                                      borderRadius: 0
                                    }}
                                  >
                                    <div
                                      className="ContainerLayerContent"
                                      style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        left: 0
                                      }}
                                    >
                                      <div
                                        className="ContainerLayer"
                                        data-layer-id="585e54e7-219d-4315-819f-496511887aa3"
                                        data-layer-name="Group"
                                        style={{
                                          position: "absolute",
                                          boxSizing: "border-box",
                                          pointerEvents: "none",
                                          left: 0,
                                          top: 0,
                                          transformOrigin: "0% 0%",
                                          opacity: 1,
                                          width: 16,
                                          height: 10,
                                          borderRadius: 0,
                                          backgroundColor:
                                            "rgba(255, 255, 255, 0)"
                                        }}
                                      >
                                        <svg
                                          width="16px"
                                          height="10px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                        <div
                                          className="ContainerLayerContent"
                                          style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            top: 0,
                                            left: 0
                                          }}
                                        >
                                          <div
                                            data-layer-id="4e1ebe7b-a0aa-4c8c-92f0-ea25908c3f90"
                                            data-layer-name="Vector"
                                            style={{
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                              overflow: "visible",
                                              pointerEvents: "none",
                                              transformOrigin: "0% 0%",
                                              opacity: 0,
                                              width: 17,
                                              height: 10
                                            }}
                                          >
                                            <img
                                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/d2cab825a62075cfa6679e522e693cda456ae518.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9kMmNhYjgyNWE2MjA3NWNmYTY2NzllNTIyZTY5M2NkYTQ1NmFlNTE4LnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=ARUM~OMTDRiIaANcWI8C4uECICTmstfmqvNYAeWXGtXvz~e4R-pP0nHnmXlFuVjFODT6te9s7fPjruhZ3~mUytet1TqBk2jAicJz3ZyyyZ6Ie0rkAGEuEZG03~MpioKHKZ3x8Jh1doRd15niik4vpWPNb16C9E0j-xvfvbWZS-ezfxqVE3BycXQFiR6LV2W-BJWvcNNbXhfDyV1yrdvY9x8RK8ZF6CHSDG~wL~wCyW-hKwDkyCv9p2mM2gVogkCe8iPH-XdloTkcIgiAFqEuCJHImpsFpIHsXXhX0OPu90MQDeXHhzCTReP8BDze1AJKlp4UoAb2n4Pu~EMXxHT6pg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: 0
                                              }}
                                            />
                                            <svg
                                              width="17px"
                                              height="10px"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                overflow: "visible"
                                              }}
                                            >
                                              <defs />
                                              <g>
                                                <path />
                                              </g>
                                            </svg>
                                          </div>
                                          <div
                                            data-layer-id="e1da5013-1e19-4357-a7b4-a7c7138ce3ff"
                                            data-layer-name="Vector"
                                            style={{
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                              overflow: "visible",
                                              pointerEvents: "none",
                                              transformOrigin: "0% 0%",
                                              opacity: 1,
                                              width: 17,
                                              height: 10
                                            }}
                                          >
                                            <img
                                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/e820048b4326bc846110d7b908c54d26f3978b32.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9lODIwMDQ4YjQzMjZiYzg0NjExMGQ3YjkwOGM1NGQyNmYzOTc4YjMyLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=eYRWRh1Mk8pAfSgH6k0qncxPIDmJkipMm9eI~m7TNEgGfNpb63RvYNvxC4GRvUkKu0ASuDaF8LIAEjLnc-QkR~cz8a1SuoWm4Wqi7OSNjjbSDj8ikAAf7jfAhSLkQCLUyEdVkz177AdobBUzynBKlcfL1MgR7Nx~EextnE6MnnMxUM35MTbUoPfmvOJGGWsJUX05g05ryJ8jDH6-QZFv2uh0QF7~kkfm176cHjZFurKIB1VgB~LAdcq9nfvcmr-V6~N22Ua4xDM8zcEs~VVyvkkod5bUsUEy-sLUCsGCZ-esNhnasCemOHJ9R74WMlgzu4WBcCpWSxfp1EZIDoDWGw__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: 0
                                              }}
                                            />
                                            <svg
                                              width="17px"
                                              height="10px"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                overflow: "visible"
                                              }}
                                            >
                                              <defs />
                                              <g>
                                                <path />
                                              </g>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <svg
                                    width="16px"
                                    height="10px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible",
                                      pointerEvents: "none"
                                    }}
                                  >
                                    <defs />
                                    <g>
                                      <path />
                                    </g>
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div
                              className="ContainerLayer"
                              data-layer-id="071bc124-731f-4ed0-bdfa-511e4be75c06"
                              data-layer-name="fanblades 2"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: 1611,
                                top: 25,
                                transformOrigin: "0% 0%",
                                opacity: "0.9",
                                width: 50,
                                height: 50,
                                borderRadius: 0,
                                backgroundColor: "rgba(255, 255, 255, 0)"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  boxSizing: "border-box",
                                  overflow: "hidden",
                                  borderRadius: 0
                                }}
                              >
                                <div
                                  className="ContainerLayerContent"
                                  style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    top: 0,
                                    left: 0
                                  }}
                                >
                                  <div
                                    className="ContainerLayer"
                                    data-layer-id="8a390aaf-e827-423b-819f-d74f82715fca"
                                    data-layer-name="Group"
                                    style={{
                                      position: "absolute",
                                      boxSizing: "border-box",
                                      pointerEvents: "none",
                                      left: 0,
                                      top: 0,
                                      transformOrigin: "0% 0%",
                                      opacity: 1,
                                      width: 50,
                                      height: 50,
                                      borderRadius: 0,
                                      backgroundColor: "rgba(255, 255, 255, 0)"
                                    }}
                                  >
                                    <svg
                                      width="50px"
                                      height="50px"
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        overflow: "visible"
                                      }}
                                    >
                                      <defs />
                                      <g>
                                        <path />
                                      </g>
                                    </svg>
                                    <div
                                      className="ContainerLayerContent"
                                      style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        left: 0
                                      }}
                                    >
                                      <div
                                        data-layer-id="9f15bbcf-69ae-4d01-815d-c32577983ea7"
                                        data-layer-name="Vector"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible",
                                          pointerEvents: "none",
                                          transformOrigin: "0% 0%",
                                          opacity: 0,
                                          width: 51,
                                          height: 51
                                        }}
                                      >
                                        <img
                                          src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/c27d7406f7835f41113447b8832708a582c16b02.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9jMjdkNzQwNmY3ODM1ZjQxMTEzNDQ3Yjg4MzI3MDhhNTgyYzE2YjAyLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=EESe~5Qvm4IwG6ohJATO6IoO7sdny26l118JXdSSgtliVpOMEbSO98Hutp2BZnB2lpnwoFu8IRo8F5AhxKx-qDut6UhrleNsFai8ZpaKJhTEUX4MQCnVf9TuGJ7yNBoxnjMCdgsH1658fLxxwuz0zBdYhi4LtLDMYjAI5vrAx0OxZFVgW9V1S8kAzabnfGZhrZj~0SqPlnUaV~Gy7SD0nBvLNcUxL2ibK-wNkYmDnAtGSvqc9C1IZDjAAiOXLHBBfAZqtQ5O4T4BZsNGreyUWXZbPjmOgQYxG9IJtHz1eX8u4sxG8apvP4gOBNNgfUKnDXarZE~YDlA5kN4f9qZdGQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: 0
                                          }}
                                        />
                                        <svg
                                          width="51px"
                                          height="51px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                      </div>
                                      <div
                                        data-layer-id="3ce3ebbf-3dc6-41f8-8663-6f66f037303a"
                                        data-layer-name="Vector"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          overflow: "visible",
                                          pointerEvents: "none",
                                          transformOrigin: "0% 0%",
                                          opacity: 1,
                                          width: 51,
                                          height: 51
                                        }}
                                      >
                                        <img
                                          src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/ef61821bce8bb2d02b4f98e7cb3cb043f6a403ac.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9lZjYxODIxYmNlOGJiMmQwMmI0Zjk4ZTdjYjNjYjA0M2Y2YTQwM2FjLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=hEyp1mBerdbWMSKgSzMr4mBeh0itUfcY7iLekGSutaFJeIwXh7hU586p0wLg3m5OCWXE-t~akR3JkNr6EoG5WjF2WH09Yf0v6p5WX9nbxFFvGk6cnhBdnatRplBDacKDu0qJiyq7Z~~N7gx7M~ZfW-otcAx-eQGmhPj9pBtyPqxs7e7cJ~lYE1Rm7YxoWkwpatu5jdrATxB9waLK7B-7j2xwkzoA1KmlMMgqgYorp16VYMoeHLcYYXd2X6qZmo6ebEiuQThS8ysokOvf9mke45-yvEBQ1sZoooS2cpqQ72sC8QeIu~4TAp4jeJyB7E1spL7vuOgevjOufBOSu7VdAA__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: 0
                                          }}
                                        />
                                        <svg
                                          width="51px"
                                          height="51px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <svg
                                width="50px"
                                height="50px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible",
                                  pointerEvents: "none"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                            </div>
                            <div
                              className="ContainerLayer"
                              data-layer-id="a56c203c-d3c1-429a-bf7c-7ecf8454f528"
                              data-layer-name="Group 7"
                              style={{
                                position: "absolute",
                                boxSizing: "border-box",
                                pointerEvents: "none",
                                left: 1777,
                                top: 10,
                                transformOrigin: "0% 0%",
                                opacity: "0.9",
                                width: 71,
                                height: 80,
                                borderRadius: 0,
                                backgroundColor: "rgba(255, 255, 255, 0)"
                              }}
                            >
                              <svg
                                width="71px"
                                height="80px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                              <div
                                className="ContainerLayerContent"
                                style={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "100%",
                                  top: 0,
                                  left: 0
                                }}
                              >
                                <div
                                  data-layer-id="1ad15f60-528a-4fe6-b2a1-fb927fc44362"
                                  data-layer-name="20°"
                                  style={{
                                    position: "absolute",
                                    top: 16,
                                    left: 0,
                                    overflow: "visible",
                                    pointerEvents: "none",
                                    transformOrigin: "50% 50%",
                                    opacity: 1,
                                    width: 71,
                                    height: 48
                                  }}
                                >
                                  <img
                                    src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/8dd4d77f061c74e91231040834d254229810edf1.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy84ZGQ0ZDc3ZjA2MWM3NGU5MTIzMTA0MDgzNGQyNTQyMjk4MTBlZGYxLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=REZbAGfsx-8I9BcaNWvSiQ-BwQDOrXVuiq5hDbdTFZE9OGrLXcBvTtq-M4mRG0F8q-XPrliPC~-9T~stfJ41cNMFcbDL1DREiL87--vN7ZJNFqaFo7Rq64K39JB9OfBW-CsP1FgNDkqXRzj69MeZOXcLaY2PCkb6lu7DweDV7-iSGpjif7g1CWmWVVfJ4yVxpig7SkI0OUlkgBOuzCpbw8tVS-4nOw1ZsgYEkYkwxuWBimXsiRPFuCrixCjz8nVdgTZ1v2wTiRjwRobzsDt8hYRSkYqjlRXz~wB86HuooeU04TXsLeJ2rNyUl-uO6QYPQpPBYuEYrfTgq1LNrpPFiw__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      borderRadius: 0
                                    }}
                                  />
                                  <svg
                                    width="71px"
                                    height="48px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible"
                                    }}
                                  >
                                    <defs />
                                    <g>
                                      <path />
                                    </g>
                                  </svg>
                                </div>
                                <div
                                  className="ContainerLayer"
                                  data-layer-id="9459de67-0bc6-4f78-9832-9c1a0c0cf738"
                                  data-layer-name="chevron.up 1"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 27,
                                    top: 0,
                                    transformOrigin: "0% 0%",
                                    opacity: 1,
                                    width: 16,
                                    height: 10,
                                    borderRadius: 0,
                                    backgroundColor: "rgba(255, 255, 255, 0)"
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "absolute",
                                      inset: 0,
                                      boxSizing: "border-box",
                                      overflow: "hidden",
                                      borderRadius: 0
                                    }}
                                  >
                                    <div
                                      className="ContainerLayerContent"
                                      style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        left: 0
                                      }}
                                    >
                                      <div
                                        className="ContainerLayer"
                                        data-layer-id="b74d8ef7-e489-401f-bb89-37fb40555065"
                                        data-layer-name="Group"
                                        style={{
                                          position: "absolute",
                                          boxSizing: "border-box",
                                          pointerEvents: "none",
                                          left: 0,
                                          top: 0,
                                          transformOrigin: "0% 0%",
                                          opacity: 1,
                                          width: 16,
                                          height: 10,
                                          borderRadius: 0,
                                          backgroundColor:
                                            "rgba(255, 255, 255, 0)"
                                        }}
                                      >
                                        <svg
                                          width="16px"
                                          height="10px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                        <div
                                          className="ContainerLayerContent"
                                          style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            top: 0,
                                            left: 0
                                          }}
                                        >
                                          <div
                                            data-layer-id="0a724ab1-6229-4066-8c8e-b5a110aab90c"
                                            data-layer-name="Vector"
                                            style={{
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                              overflow: "visible",
                                              pointerEvents: "none",
                                              transformOrigin: "0% 0%",
                                              opacity: 0,
                                              width: 17,
                                              height: 10
                                            }}
                                          >
                                            <img
                                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/d2cab825a62075cfa6679e522e693cda456ae518.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9kMmNhYjgyNWE2MjA3NWNmYTY2NzllNTIyZTY5M2NkYTQ1NmFlNTE4LnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=ARUM~OMTDRiIaANcWI8C4uECICTmstfmqvNYAeWXGtXvz~e4R-pP0nHnmXlFuVjFODT6te9s7fPjruhZ3~mUytet1TqBk2jAicJz3ZyyyZ6Ie0rkAGEuEZG03~MpioKHKZ3x8Jh1doRd15niik4vpWPNb16C9E0j-xvfvbWZS-ezfxqVE3BycXQFiR6LV2W-BJWvcNNbXhfDyV1yrdvY9x8RK8ZF6CHSDG~wL~wCyW-hKwDkyCv9p2mM2gVogkCe8iPH-XdloTkcIgiAFqEuCJHImpsFpIHsXXhX0OPu90MQDeXHhzCTReP8BDze1AJKlp4UoAb2n4Pu~EMXxHT6pg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: 0
                                              }}
                                            />
                                            <svg
                                              width="17px"
                                              height="10px"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                overflow: "visible"
                                              }}
                                            >
                                              <defs />
                                              <g>
                                                <path />
                                              </g>
                                            </svg>
                                          </div>
                                          <div
                                            data-layer-id="925091a8-4850-4903-a909-2c26a194d4af"
                                            data-layer-name="Vector"
                                            style={{
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                              overflow: "visible",
                                              pointerEvents: "none",
                                              transformOrigin: "0% 0%",
                                              opacity: 1,
                                              width: 17,
                                              height: 10
                                            }}
                                          >
                                            <img
                                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/e820048b4326bc846110d7b908c54d26f3978b32.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9lODIwMDQ4YjQzMjZiYzg0NjExMGQ3YjkwOGM1NGQyNmYzOTc4YjMyLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=eYRWRh1Mk8pAfSgH6k0qncxPIDmJkipMm9eI~m7TNEgGfNpb63RvYNvxC4GRvUkKu0ASuDaF8LIAEjLnc-QkR~cz8a1SuoWm4Wqi7OSNjjbSDj8ikAAf7jfAhSLkQCLUyEdVkz177AdobBUzynBKlcfL1MgR7Nx~EextnE6MnnMxUM35MTbUoPfmvOJGGWsJUX05g05ryJ8jDH6-QZFv2uh0QF7~kkfm176cHjZFurKIB1VgB~LAdcq9nfvcmr-V6~N22Ua4xDM8zcEs~VVyvkkod5bUsUEy-sLUCsGCZ-esNhnasCemOHJ9R74WMlgzu4WBcCpWSxfp1EZIDoDWGw__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: 0
                                              }}
                                            />
                                            <svg
                                              width="17px"
                                              height="10px"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                overflow: "visible"
                                              }}
                                            >
                                              <defs />
                                              <g>
                                                <path />
                                              </g>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <svg
                                    width="16px"
                                    height="10px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible",
                                      pointerEvents: "none"
                                    }}
                                  >
                                    <defs />
                                    <g>
                                      <path />
                                    </g>
                                  </svg>
                                </div>
                                <div
                                  className="ContainerLayer"
                                  data-layer-id="56c4de89-65e0-42ce-a5b3-e9fa7536d73b"
                                  data-layer-name="chevron.up 2"
                                  style={{
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    pointerEvents: "none",
                                    left: 27,
                                    top: 70,
                                    transformOrigin: "50% 50%",
                                    transform:
                                      "translate(-0.14px, 0.04px) rotate(180deg)",
                                    opacity: 1,
                                    width: 16,
                                    height: 10,
                                    borderRadius: 0,
                                    backgroundColor: "rgba(255, 255, 255, 0)"
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "absolute",
                                      inset: 0,
                                      boxSizing: "border-box",
                                      overflow: "hidden",
                                      borderRadius: 0
                                    }}
                                  >
                                    <div
                                      className="ContainerLayerContent"
                                      style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        left: 0
                                      }}
                                    >
                                      <div
                                        className="ContainerLayer"
                                        data-layer-id="6dff43dc-05ec-4546-a654-b548b57ff75b"
                                        data-layer-name="Group"
                                        style={{
                                          position: "absolute",
                                          boxSizing: "border-box",
                                          pointerEvents: "none",
                                          left: 0,
                                          top: 0,
                                          transformOrigin: "0% 0%",
                                          opacity: 1,
                                          width: 16,
                                          height: 10,
                                          borderRadius: 0,
                                          backgroundColor:
                                            "rgba(255, 255, 255, 0)"
                                        }}
                                      >
                                        <svg
                                          width="16px"
                                          height="10px"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            overflow: "visible"
                                          }}
                                        >
                                          <defs />
                                          <g>
                                            <path />
                                          </g>
                                        </svg>
                                        <div
                                          className="ContainerLayerContent"
                                          style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            top: 0,
                                            left: 0
                                          }}
                                        >
                                          <div
                                            data-layer-id="70c5a0f5-f574-4342-a3d4-ec4a62fbe77d"
                                            data-layer-name="Vector"
                                            style={{
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                              overflow: "visible",
                                              pointerEvents: "none",
                                              transformOrigin: "0% 0%",
                                              opacity: 0,
                                              width: 17,
                                              height: 10
                                            }}
                                          >
                                            <img
                                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/d2cab825a62075cfa6679e522e693cda456ae518.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9kMmNhYjgyNWE2MjA3NWNmYTY2NzllNTIyZTY5M2NkYTQ1NmFlNTE4LnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=ARUM~OMTDRiIaANcWI8C4uECICTmstfmqvNYAeWXGtXvz~e4R-pP0nHnmXlFuVjFODT6te9s7fPjruhZ3~mUytet1TqBk2jAicJz3ZyyyZ6Ie0rkAGEuEZG03~MpioKHKZ3x8Jh1doRd15niik4vpWPNb16C9E0j-xvfvbWZS-ezfxqVE3BycXQFiR6LV2W-BJWvcNNbXhfDyV1yrdvY9x8RK8ZF6CHSDG~wL~wCyW-hKwDkyCv9p2mM2gVogkCe8iPH-XdloTkcIgiAFqEuCJHImpsFpIHsXXhX0OPu90MQDeXHhzCTReP8BDze1AJKlp4UoAb2n4Pu~EMXxHT6pg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: 0
                                              }}
                                            />
                                            <svg
                                              width="17px"
                                              height="10px"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                overflow: "visible"
                                              }}
                                            >
                                              <defs />
                                              <g>
                                                <path />
                                              </g>
                                            </svg>
                                          </div>
                                          <div
                                            data-layer-id="60709ef2-0fae-4c22-817f-6e0f421674aa"
                                            data-layer-name="Vector"
                                            style={{
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                              overflow: "visible",
                                              pointerEvents: "none",
                                              transformOrigin: "0% 0%",
                                              opacity: 1,
                                              width: 17,
                                              height: 10
                                            }}
                                          >
                                            <img
                                              src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/e820048b4326bc846110d7b908c54d26f3978b32.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9lODIwMDQ4YjQzMjZiYzg0NjExMGQ3YjkwOGM1NGQyNmYzOTc4YjMyLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=eYRWRh1Mk8pAfSgH6k0qncxPIDmJkipMm9eI~m7TNEgGfNpb63RvYNvxC4GRvUkKu0ASuDaF8LIAEjLnc-QkR~cz8a1SuoWm4Wqi7OSNjjbSDj8ikAAf7jfAhSLkQCLUyEdVkz177AdobBUzynBKlcfL1MgR7Nx~EextnE6MnnMxUM35MTbUoPfmvOJGGWsJUX05g05ryJ8jDH6-QZFv2uh0QF7~kkfm176cHjZFurKIB1VgB~LAdcq9nfvcmr-V6~N22Ua4xDM8zcEs~VVyvkkod5bUsUEy-sLUCsGCZ-esNhnasCemOHJ9R74WMlgzu4WBcCpWSxfp1EZIDoDWGw__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: 0
                                              }}
                                            />
                                            <svg
                                              width="17px"
                                              height="10px"
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                overflow: "visible"
                                              }}
                                            >
                                              <defs />
                                              <g>
                                                <path />
                                              </g>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <svg
                                    width="16px"
                                    height="10px"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      overflow: "visible",
                                      pointerEvents: "none"
                                    }}
                                  >
                                    <defs />
                                    <g>
                                      <path />
                                    </g>
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <svg
                          width="1900px"
                          height="100px"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            overflow: "visible",
                            pointerEvents: "none"
                          }}
                        >
                          <defs />
                          <g>
                            <path />
                          </g>
                        </svg>
                      </div>
                      <div
                        className="ContainerLayer"
                        data-layer-id="61a692ec-b8c3-4d92-9b71-d49e17bdbad6"
                        data-layer-name="navbar"
                        style={{
                          position: "absolute",
                          boxSizing: "border-box",
                          pointerEvents: "none",
                          left: 20,
                          top: 0,
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 1860,
                          height: 48,
                          borderRadius: 0,
                          backgroundColor: "rgba(255, 255, 255, 0)"
                        }}
                      >
                        <svg
                          width="1860px"
                          height="48px"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            overflow: "visible"
                          }}
                        >
                          <defs />
                          <g>
                            <path />
                          </g>
                        </svg>
                        <div
                          className="ContainerLayerContent"
                          style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0
                          }}
                        >
                          <div
                            className="ContainerLayer"
                            data-layer-id="2e65e16c-4084-4e31-9334-4df02f42c5cd"
                            data-layer-name="weather icon"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 730,
                              top: 0,
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 48,
                              height: 48,
                              borderRadius: 0,
                              backgroundColor: "rgba(255, 255, 255, 0)"
                            }}
                          >
                            <svg
                              width="48px"
                              height="48px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path />
                              </g>
                            </svg>
                            <div
                              className="ContainerLayerContent"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0
                              }}
                            >
                              <div
                                data-layer-id="c9d235aa-1623-438a-9b27-5356d6001ecc"
                                data-layer-name="01d"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/7591e549db3bc54f959c0d431fb3374135dd1a30.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy83NTkxZTU0OWRiM2JjNTRmOTU5YzBkNDMxZmIzMzc0MTM1ZGQxYTMwLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=UEo3bNWGM2dbnNOdEe5zYKtJ-x92aHdP7MiG97SVGPvBfoGRckjjloKY43TBM8AnnzeTCc~AwaOQuYIu3~BbqOO6eTUsIm6nJ65ZYxj1bmOiUjcmTwIuFIYrglogAQ6E00VXnSOoDS~dx7f6x~k0l6HnjaLtdm2c5-t9LX2mcQ5vYv-GQlsjrLHLrfueIjj1NUnFQEjqFbo80-qGpJLYhEuhNPj~de-HLjZI-ssItpvv0X-QUUHCW1WpWxhk60C4TGhAL6xZw1Cy220RnDzluC2nN-j8Aem8PGM8Ywl32ynyy8N6QA6kV~GNDc6hCBdt8LTshheF9L8AzhZdo1kxyg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-18")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-18">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="442f8ed9-c48b-411b-aa5a-06d391d60193"
                                data-layer-name="01n"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/5b9dd5c7734d65e68e5467f34daa5d39a6dcdfdd.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy81YjlkZDVjNzczNGQ2NWU2OGU1NDY3ZjM0ZGFhNWQzOWE2ZGNkZmRkLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=KW3Y~dGzFxPg9ch5sGxONR5~qAWuIo68AKojV1tbyLbHpw-MIO3OcPoVbL5MDsKHf44K7giSZsxin7Mq-jz534dYX6lDlt8sHwBJunXTKbHoSmK~pdiBSLp-LPKRDIwAGOgc~1FrAzgPbc6vg0Cv0~ct5cCFwr1G9Gtcwd2U8zlA0tixmzFAGvm8bWrOmw8~JooNInUuIYA3IjN8zao7u-4DRwHn0fbaDM~XXIVNUy3Ha62IIqlXR-ae~WdHT8nUQoBMpPdg3ZqxL3HWDHqYgSFmVA3MrSe2350KgMHCn1IExJVzVdZnMXyP1jgasTsdNDthcJ-x3RvAfhkwuoF3Lg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-19")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-19">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="a5954e3a-844b-4c1a-b23b-cbdc62bd7541"
                                data-layer-name="02d"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/b8e5a4ca593984c1755a8ca81f614b019a4cc570.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9iOGU1YTRjYTU5Mzk4NGMxNzU1YThjYTgxZjYxNGIwMTlhNGNjNTcwLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=BuEISLaVp1K2MZDFnGvm0Ec7Cx1EsZi4aGCYUo0ZHH5IT4ErDi~JaimXGFEHyQUx8ypDu9yieXj931VFYa7FDzErYK5qAP6VL70C10YuxTPSyqMKAe0yXV4WU5Wz6MRS4NjQSh3PfJQRtcYCIz7oKkezH-C8MaSFVOK5XmDh-WPH3qdNKTb1StOhhoiIYGC3phI9OtJ3q64OIN-FmU7Xbv7eavg8CbdYa06g70Lkzegw3ZUreYBzWPF5fiP2hHU6NatJu9p-nCz1cEd8KaI1IlQSs9ROorNfseWXhc8Mb~NfipFDtXl6NvN7FvYio3~zN9HWLw9Swl50CJx-HBIwgQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-20")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-20">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="6f859c35-008a-4310-8cba-82c3d6be50ca"
                                data-layer-name="02n"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/2e6d68c1bfa09c4915ce01d633700c74b49a1901.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8yZTZkNjhjMWJmYTA5YzQ5MTVjZTAxZDYzMzcwMGM3NGI0OWExOTAxLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=DJK0-R~Qy-xQe3g65omb4iCHr9~QRmyAcTVKdZ6zc-2MOsVH9-7AyHVYmiC~--1-QmWttCI~avYDscWXS4eAySWLD0N7pHQRWdGZKDhXCL7BUf0q8quiAPX8gM3PLk6xQwJYw~6lhJE3jBOrmgr~O2YHP~b-M8SqpD5I27JZMjdLKIIu9oSU7ypN3GzxHaGr~elzTM-NJ9rA29Uj~2A3lwy7MRuhb5-pBZmtME54sK8VNv1n-C6vP~5itJ6zG8DxkBBCowixdw0XWsssbiGOON6vcHCdGpHTnRrndk~HFl7sLPEts187bPXFOVZSsKMajBVsbxsqxqJsQ8avDyFCRQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-21")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-21">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="c545b232-e0e6-4a54-ac2d-777dbe97812b"
                                data-layer-name="03d"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/3253f5b16fd282e1b36645b9c89644f05fb8ac91.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8zMjUzZjViMTZmZDI4MmUxYjM2NjQ1YjljODk2NDRmMDVmYjhhYzkxLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=ZexHG6a9dUNMmoxODWf7HOrxTJBdmfXZOvH89Z1g~tUnp2GOlbNI40~3UwqW5i8aWzeRCRwwLE9s5Y0hmsGhHdCkfiymlo~zy9GhjCbq9erGo5TOkNZrkoyFAHojhaQlY8Je5HTwveDLoKid1ZgXYpUvNt-Rgd9lHtLIJu3Is3i8TO9E9RAtfxBkGYhKxvEmBf5D21CZI1XK25i3qhd6pawkJLlySlSmcERRc6f-y9gxQ05IvQydt~VqP8OKvJ~HLO3f5PqK7wsPfzHnVKH6J-sNw5JlnJeRr8fbtmogNTUBGig157~vS6CMb9P2~QZVLKIgMWVPc0L2FtnmrL8-tA__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-22")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-22">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="40a1e489-4414-4fce-a80a-ae6b391c9254"
                                data-layer-name="03n"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/3253f5b16fd282e1b36645b9c89644f05fb8ac91.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8zMjUzZjViMTZmZDI4MmUxYjM2NjQ1YjljODk2NDRmMDVmYjhhYzkxLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=ZexHG6a9dUNMmoxODWf7HOrxTJBdmfXZOvH89Z1g~tUnp2GOlbNI40~3UwqW5i8aWzeRCRwwLE9s5Y0hmsGhHdCkfiymlo~zy9GhjCbq9erGo5TOkNZrkoyFAHojhaQlY8Je5HTwveDLoKid1ZgXYpUvNt-Rgd9lHtLIJu3Is3i8TO9E9RAtfxBkGYhKxvEmBf5D21CZI1XK25i3qhd6pawkJLlySlSmcERRc6f-y9gxQ05IvQydt~VqP8OKvJ~HLO3f5PqK7wsPfzHnVKH6J-sNw5JlnJeRr8fbtmogNTUBGig157~vS6CMb9P2~QZVLKIgMWVPc0L2FtnmrL8-tA__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-23")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-23">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="f5f26fce-5068-4289-843b-481b2310f361"
                                data-layer-name="04d"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/76bfa452fe904c4acdd0f6563614d5051ee5f142.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy83NmJmYTQ1MmZlOTA0YzRhY2RkMGY2NTYzNjE0ZDUwNTFlZTVmMTQyLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=WzYUtYWTMuHkEMYoD0QbJD7uNC4-pq7q3l9sxtb-CVKDxJ3U2UOKpp2OA-05Oc55c2y4jKY-R3n3y9xRdABYTCvzFabQlxbr25xtMqwRgSgbIpmSPVyRR0RsbDPsrKEjhJmkzp1y0dH7UHlFZvX~i6afU8rqbMK-jIp0D2eKd5cav0RAv07p8-ZRfAlsFyZMflmMG6h2v2k1dNbPPLOYWwyqgkoiVwsheIG4PDsLIr2hnFBZ5N-qk50NpjywNJLu~2aoA4NK~IF3YHyFGY9RBlyJF0A7~Q50Py-TV8sKgWKJQiBP-GmU3SmJRxyyJO90dYr1A10RnwnM~TyBL1AnNA__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-24")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-24">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="a329331a-3ecd-4931-9bf2-a541839ff5eb"
                                data-layer-name="04n"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/76bfa452fe904c4acdd0f6563614d5051ee5f142.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy83NmJmYTQ1MmZlOTA0YzRhY2RkMGY2NTYzNjE0ZDUwNTFlZTVmMTQyLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=WzYUtYWTMuHkEMYoD0QbJD7uNC4-pq7q3l9sxtb-CVKDxJ3U2UOKpp2OA-05Oc55c2y4jKY-R3n3y9xRdABYTCvzFabQlxbr25xtMqwRgSgbIpmSPVyRR0RsbDPsrKEjhJmkzp1y0dH7UHlFZvX~i6afU8rqbMK-jIp0D2eKd5cav0RAv07p8-ZRfAlsFyZMflmMG6h2v2k1dNbPPLOYWwyqgkoiVwsheIG4PDsLIr2hnFBZ5N-qk50NpjywNJLu~2aoA4NK~IF3YHyFGY9RBlyJF0A7~Q50Py-TV8sKgWKJQiBP-GmU3SmJRxyyJO90dYr1A10RnwnM~TyBL1AnNA__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-25")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-25">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="59266fe3-47b7-4ac9-be77-ba37f03b166b"
                                data-layer-name="09d"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/042184300e48ae0fca466e3153fa3e5585725442.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8wNDIxODQzMDBlNDhhZTBmY2E0NjZlMzE1M2ZhM2U1NTg1NzI1NDQyLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=cko07JNpRr8CcrgJYquGxcrIjf8SbQP1h1XHtItRbGl5yAjin1SetzTQRu-G04fBmtxho2FC4Psm~kYPsPvVq9bFMbr7D2UkvupiG8TKmgj~7sF-KByt1J-MYfpKqbbbhh5tLrF~VrP2YB3VUCB9XuNsq-699-RNSCbAeX6pCXfZUxcKa46TnSWhphgg7ihJiG~vhH-KtLJCHKhKXM1Zro8xDDqQWss8LPZQj5sN2gS5J6CH1JF-c3WG~~vwtoP1IQdinSIX7KCTHL8~p8fdPaWiMswwINkiT2aaFLKT6vrdkFVycn93UQkDLKBjn7VwlV7JZzsM5eAk4kxpSO~vVg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-26")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-26">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="20c22f85-d883-4c21-89ba-3e4a64abc0ab"
                                data-layer-name="09n"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/042184300e48ae0fca466e3153fa3e5585725442.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8wNDIxODQzMDBlNDhhZTBmY2E0NjZlMzE1M2ZhM2U1NTg1NzI1NDQyLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=cko07JNpRr8CcrgJYquGxcrIjf8SbQP1h1XHtItRbGl5yAjin1SetzTQRu-G04fBmtxho2FC4Psm~kYPsPvVq9bFMbr7D2UkvupiG8TKmgj~7sF-KByt1J-MYfpKqbbbhh5tLrF~VrP2YB3VUCB9XuNsq-699-RNSCbAeX6pCXfZUxcKa46TnSWhphgg7ihJiG~vhH-KtLJCHKhKXM1Zro8xDDqQWss8LPZQj5sN2gS5J6CH1JF-c3WG~~vwtoP1IQdinSIX7KCTHL8~p8fdPaWiMswwINkiT2aaFLKT6vrdkFVycn93UQkDLKBjn7VwlV7JZzsM5eAk4kxpSO~vVg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-27")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-27">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="bb02c77c-aae0-4877-8473-91d9ba704b3b"
                                data-layer-name="10d"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/45578ae531f6dba58efc6037696727b687425079.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy80NTU3OGFlNTMxZjZkYmE1OGVmYzYwMzc2OTY3MjdiNjg3NDI1MDc5LnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=OgrPvw8qUmoiDiya~PRsBkWxo6-sCcWoVNU3f8NcVLAqsQI7y8D-97bUqkcLGwa4I~HtUFCfVKaN1EAvroRItn0SQfBzb3dOiq8GWz2GlVrOxOIuRzkC~otLOaho01TpKtQKzSMuW-dYdaXQV1RtwR-rlraGMM8t7JNtrMhgOize1jkt~Hw~4nnK2faFjUUtvepDRDYimyb4aVI7CcelpX4KXtFx~Q6WxIEQVhiricqGKXGWYGyZFpebHR9oO26txNCBntdG01dsg~0QhPpRb994sljiITo~hg57jiWP80KOiOWRvAoKsC35PoFZ8Jin1sETx-U6wgWQvp~dTQiHOw__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-28")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-28">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="190dba0b-d654-4710-84d6-6314e93446fa"
                                data-layer-name="10n"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/a8d437a4a9e51723a01df94546a47b6259b121e3.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9hOGQ0MzdhNGE5ZTUxNzIzYTAxZGY5NDU0NmE0N2I2MjU5YjEyMWUzLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=IT672TB3uvdT0tOM4-p2q~TE5EA90cYm5kuvU1XF5mP4Tyuf0X1S5335KZ6an9PIqwQJP7f87dF-1ANJl6TJsg2j7ahGyuAuAqXeDEUPDpsXCSvpG8HXRhIQfCweaSGacXcgQ9ZalCHpPX1XN1~eO7AppM2QkX9p4YuGIhZhMdRgFzqVwqjd7rtN5D40PbffIMhrZDAoyI0tLqn9FwmIQerz1wkaNNHQXWXo-bw1rc9q9ZUzgbyBYanR-QBpcqnlrYKqN2gqXGji1o~2sx6N~~O~yB5oa0uF4IUwOAgghPrDTIJcBLBnc1dxw6Zpsi40I5vipsZUPFQ1sKseEJPQrg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-29")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-29">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="d53ce1a3-a8eb-40d6-961f-4b4346c9d8c7"
                                data-layer-name="11d"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/e8e60a82c27633015ce98bca356d1dc8c02352dd.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9lOGU2MGE4MmMyNzYzMzAxNWNlOThiY2EzNTZkMWRjOGMwMjM1MmRkLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=TttNl~S9VhXCI8Fd-lx2Zt0rKgOV8Su6Y-vKhZiShuYP9tk9stkOR7NXD47dQ3QZ~Bhz-U7ZHjV0L53fA7ZiQYps167d7QWSOOPbXL6bBM26bwe0GdSsNmzb~TJgKXSeGYfZaYYdr6boqH-Lu2jcYVa4aqRFxB2XJ~~RLRUs0ETq1x5GrU1A6vfEBSVQ7Q8~hGJ8C06eNQ6Y7rdqlGdfox6xBdkh~SWnXzG8sH9~9PGww-VvIEKRdXHvliW2YbgwldORWb6j9OsERM2c9sudyKEkf~Z-5t1htHj60KIqA~Wjn7lLNlkCLQJ35wkudnZb~H2ZhJXPfiPiUZiJQNG0Pg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-30")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-30">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="0501c1e1-b745-4b9d-8be3-3dd1d218bf40"
                                data-layer-name="11n"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/e8e60a82c27633015ce98bca356d1dc8c02352dd.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9lOGU2MGE4MmMyNzYzMzAxNWNlOThiY2EzNTZkMWRjOGMwMjM1MmRkLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=TttNl~S9VhXCI8Fd-lx2Zt0rKgOV8Su6Y-vKhZiShuYP9tk9stkOR7NXD47dQ3QZ~Bhz-U7ZHjV0L53fA7ZiQYps167d7QWSOOPbXL6bBM26bwe0GdSsNmzb~TJgKXSeGYfZaYYdr6boqH-Lu2jcYVa4aqRFxB2XJ~~RLRUs0ETq1x5GrU1A6vfEBSVQ7Q8~hGJ8C06eNQ6Y7rdqlGdfox6xBdkh~SWnXzG8sH9~9PGww-VvIEKRdXHvliW2YbgwldORWb6j9OsERM2c9sudyKEkf~Z-5t1htHj60KIqA~Wjn7lLNlkCLQJ35wkudnZb~H2ZhJXPfiPiUZiJQNG0Pg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-31")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-31">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="c02a53dd-cc23-4fa6-8273-bb57feea6403"
                                data-layer-name="13d"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/818d492c71301ac1dd0b9a048c146a698525f908.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy84MThkNDkyYzcxMzAxYWMxZGQwYjlhMDQ4YzE0NmE2OTg1MjVmOTA4LnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=hr0DQmUmKU~Nkd~io3eWUfkIKIOGeK6tzagtBY2lo3CUheC-5GTsCi7ZkgQhQLalAktKWn1RToAtJntrVLaTRnrP0vRbWvy3w4QYn3OeNS4xTl6Vi5uJf7DQn~l88gcxJ07mtMAk77ytSbQ1u12DWF9Rw0clGvEEuNUVdLYQptUxeqQH-emcsRTciD9JkemkRh0zQa7wMBPyN~GG6k9l-U7H6BECx8j--6ndzdMZpZvFFUmcSoNchMEnfWtVVysZOzTxvtsmNb-gVaNCgCQsxDNroi4KA39QZAzeBzQpwWZcc4SoFXlBsaD36xGfi-91YwG~F9AH7vxMoOLjYSWneQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-32")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-32">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="7e9e8296-7ec1-4acf-863b-b6e51c18a2b3"
                                data-layer-name="13n"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/818d492c71301ac1dd0b9a048c146a698525f908.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy84MThkNDkyYzcxMzAxYWMxZGQwYjlhMDQ4YzE0NmE2OTg1MjVmOTA4LnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=hr0DQmUmKU~Nkd~io3eWUfkIKIOGeK6tzagtBY2lo3CUheC-5GTsCi7ZkgQhQLalAktKWn1RToAtJntrVLaTRnrP0vRbWvy3w4QYn3OeNS4xTl6Vi5uJf7DQn~l88gcxJ07mtMAk77ytSbQ1u12DWF9Rw0clGvEEuNUVdLYQptUxeqQH-emcsRTciD9JkemkRh0zQa7wMBPyN~GG6k9l-U7H6BECx8j--6ndzdMZpZvFFUmcSoNchMEnfWtVVysZOzTxvtsmNb-gVaNCgCQsxDNroi4KA39QZAzeBzQpwWZcc4SoFXlBsaD36xGfi-91YwG~F9AH7vxMoOLjYSWneQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-33")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-33">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="61759a44-3000-4d9f-b482-cfa9782fb0de"
                                data-layer-name="50d"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/7e2394484df258e1c2e95a3ae8fd9ba6113998f3.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy83ZTIzOTQ0ODRkZjI1OGUxYzJlOTVhM2FlOGZkOWJhNjExMzk5OGYzLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=Wrs4jqjZJb4XkAF1Nb0MroVfMSn4ytGgqkKoIRRcjKkwH5wVnraQAEvrggn2IqPY96uWBKW6kmcOdDrBroE5iY3GcJ6r3kT4DG821Yylpk~QcR6Dls1zflPrO267W~IIsnptmvxnX-fbKs0FvJZzkK2Ik0BEFc1B7kAYEWYCUJkytkitopJv8sg4rZiBpBxTXraxllxDDUGYNluL53ThTNyMCBU5T4UiUIQjdx9msfruv5NyAftoFdDD0DPyCLbCsbFKyny55OqtpmHGsWvV3ZNRw~065r~6MZYp69vDbIZp68AjcH550pGltPmxyQvlkPHy1BIXyWU4s0-U4drReQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-34")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-34">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="469e385a-dfab-48b8-8518-5288bdafc063"
                                data-layer-name="50n"
                                style={{
                                  position: "absolute",
                                  boxSizing: "border-box",
                                  pointerEvents: "none",
                                  left: 0,
                                  top: 0,
                                  transformOrigin: "0% 0%",
                                  opacity: 0,
                                  width: 48,
                                  height: 48
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/7e2394484df258e1c2e95a3ae8fd9ba6113998f3.png?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy83ZTIzOTQ0ODRkZjI1OGUxYzJlOTVhM2FlOGZkOWJhNjExMzk5OGYzLnBuZyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=Wrs4jqjZJb4XkAF1Nb0MroVfMSn4ytGgqkKoIRRcjKkwH5wVnraQAEvrggn2IqPY96uWBKW6kmcOdDrBroE5iY3GcJ6r3kT4DG821Yylpk~QcR6Dls1zflPrO267W~IIsnptmvxnX-fbKs0FvJZzkK2Ik0BEFc1B7kAYEWYCUJkytkitopJv8sg4rZiBpBxTXraxllxDDUGYNluL53ThTNyMCBU5T4UiUIQjdx9msfruv5NyAftoFdDD0DPyCLbCsbFKyny55OqtpmHGsWvV3ZNRw~065r~6MZYp69vDbIZp68AjcH550pGltPmxyQvlkPHy1BIXyWU4s0-U4drReQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    objectFit: "cover",
                                    position: "absolute",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                    opacity: 1,
                                    clipPath: 'url("#pp-gen-35")'
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="48px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs>
                                    <clipPath id="pp-gen-35">
                                      <path
                                        d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                      />
                                    </clipPath>
                                  </defs>
                                  <g>
                                    <path
                                      fill="rgba(210,210,210,0)"
                                      d="
                  M0,0 
                  h48 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-48 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="5ca1bdf1-e868-4793-a863-54a87b75fd93"
                            data-layer-name="range"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 493,
                              pointerEvents: "none",
                              transformOrigin: "100% 50%",
                              opacity: 1,
                              width: 145,
                              height: 48
                            }}
                          >
                            <svg
                              width="145px"
                              height="48px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h145 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-145 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                  width: "100%",
                                  fontSize: 20,
                                  textAlign: "right",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily:
                                    "Gotham-Medium, Gotham, sans-serif",
                                  fontWeight: 500,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                192 km
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="6e7a24d4-f9c6-4700-a666-804947b4b9b4"
                            data-layer-name="gear"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              pointerEvents: "none",
                              transformOrigin: "0% 50%",
                              opacity: 1,
                              width: 147,
                              height: 48
                            }}
                          >
                            <svg
                              width="147px"
                              height="48px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h147 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-147 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                  width: "100%",
                                  fontSize: 20,
                                  textAlign: "left",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily:
                                    "Gotham-Medium, Gotham, sans-serif",
                                  fontWeight: 500,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                P R N D
                              </div>
                            </div>
                          </div>
                          <div
                            className="ContainerLayer"
                            data-layer-id="4eba03aa-c956-42a7-9621-525bef9d5397"
                            data-layer-name="battery"
                            style={{
                              position: "absolute",
                              boxSizing: "border-box",
                              pointerEvents: "none",
                              left: 648,
                              top: 15,
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 52,
                              height: 20,
                              borderRadius: 0,
                              backgroundColor: "rgba(255, 255, 255, 0)"
                            }}
                          >
                            <svg
                              width="52px"
                              height="20px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path />
                              </g>
                            </svg>
                            <div
                              className="ContainerLayerContent"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0
                              }}
                            >
                              <div
                                data-layer-id="f2992620-1317-4c37-a4da-5996549a0ef2"
                                data-layer-name="Rectangle 6"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible",
                                  pointerEvents: "none",
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 48,
                                  height: 20
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/f9438400b7d3ef1b42c041adf1a9c3042d83446c.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9mOTQzODQwMGI3ZDNlZjFiNDJjMDQxYWRmMWE5YzMwNDJkODM0NDZjLnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=UpwOcVIsP5xyEKRMlCpolK03CrZJ6YaACxJx2qNk9Gd7zqGlihm7d75nR6kGNV24InZBK7-7MIA7DIZXyQg2p69Mb4M2DbRvckJqtbvNCTD0-NzXuyF9va~gMOV9REstFEsa8bjCJNPkgCFv2VuO9mqqpLxhLGPx2Cer1sIeQJbjld-A8xI1mJapX9HcrHPdHPadei10vXzOzsuaIc~5FGTX3kRXsRyYhxSOYFtM~vRK~IPHm~0zXWm4iHQDXo43GvIgGC48rAD~XkjUxax1C5ILo0o~wXI05c2ZyAWYXeQEDQKOOlEsF8WgP52qM8UBNloJZOtgxpheX3Nt4b3Ftg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: 0
                                  }}
                                />
                                <svg
                                  width="48px"
                                  height="20px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="5b703901-43c4-48b0-a453-97789f9a7709"
                                data-layer-name="Rectangle 8"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible",
                                  pointerEvents: "none",
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 35,
                                  height: 20
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/109482d2c47557e36f2f2b8b74ea0be6dd424467.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy8xMDk0ODJkMmM0NzU1N2UzNmYyZjJiOGI3NGVhMGJlNmRkNDI0NDY3LnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=Zc1CmTQKdVXSD-TDAqNTn1udUboyu0XD3BxD~RltO2MHkq6ls6nXGFCGajemyhqwQVFC1BQZXcSJ9EL9zBDQSnXfAvHrKErtrFZuwCuxdhB5xNOc4~X3QR6p1-kJD-ZjAeCqQCWpj8D-vJsgsLZLkjMGdZ5ypBdL5DtYSaXGeWSznR2x7HRDm4bM1ocaUvtewmghSXe1b7Jr-PXdyQYVss1nhiehZxP3CU8yVR-NFQXy9PxRHQNaBMnUa-7Q2LSFCUJPC5nEw9YLBp2w0oVejSxKYyZD5x-3qPMGtzM42hGF-pjTx~ZQmePmMglbLjxI8drRqHg4xxNVDg3m2sFedw__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: 0
                                  }}
                                />
                                <svg
                                  width="35px"
                                  height="20px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                              </div>
                              <div
                                data-layer-id="3364685a-4e89-4e74-8c26-b16d17a9cb33"
                                data-layer-name="Rectangle 7"
                                style={{
                                  position: "absolute",
                                  top: 5,
                                  left: 49,
                                  overflow: "visible",
                                  pointerEvents: "none",
                                  transformOrigin: "0% 0%",
                                  opacity: 1,
                                  width: 3,
                                  height: 10
                                }}
                              >
                                <img
                                  src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/d0ed4a6e713ba45e0dc540c89ad06b4f46b31576.svg?response-content-type=image%2Fsvg%2Bxml&Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy9kMGVkNGE2ZTcxM2JhNDVlMGRjNTQwYzg5YWQwNmI0ZjQ2YjMxNTc2LnN2Zz9yZXNwb25zZS1jb250ZW50LXR5cGU9aW1hZ2UlMkZzdmclMkJ4bWwiLCJDb25kaXRpb24iOnsiRGF0ZUxlc3NUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxODI4MDB9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNzAwMTY4NDAwfX19XX0_&Signature=hwj7TIeKZeQiZgkCJuyUO9ef2L3hj0PyxbZRtWmkGt4DWZPfVx6xv-aQ6JcmVI8HsH~4fV87YNnNumNBxq6roE2ZU3tjzlauWK3Di6tEVQmg6VfH-~ip1ui7e~pjTHIQukPjYSSDRV465M7E-s-Ho28OEHCtgv-BoY11DRV1wGunjBaY~UKM5XxNULmitBQ6ljHp6xkBd4mJnU1hO26ipTibftCepnX6ocPbYb3uCBVR-Y-MioFRpKkcFzl1h02P-JVSjhKGLOewfx9tY8Eq8oSmDbBhSsM4eExJaF6DIwJqrifyEEFtONh0uQ5M4MBTJ-~im5u1J8kRuskT234VXQ__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: 0
                                  }}
                                />
                                <svg
                                  width="3px"
                                  height="10px"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    overflow: "visible"
                                  }}
                                >
                                  <defs />
                                  <g>
                                    <path />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="e4fb3b5a-a238-4b9d-823d-456421f22318"
                            data-layer-name="temperature and weather"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 788,
                              pointerEvents: "none",
                              transformOrigin: "0% 50%",
                              opacity: 1,
                              width: 413,
                              height: 48
                            }}
                          >
                            <svg
                              width="413px"
                              height="48px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h413 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-413 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                  width: "100%",
                                  fontSize: 20,
                                  textAlign: "left",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily:
                                    "Gotham-Medium, Gotham, sans-serif",
                                  fontWeight: 500,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                15°C – Scattered clouds
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="747bfe16-65cd-4115-aa7f-244c7d5d98ef"
                            data-layer-name="time"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 1585,
                              pointerEvents: "none",
                              transformOrigin: "100% 50%",
                              opacity: 1,
                              width: 275,
                              height: 48
                            }}
                          >
                            <svg
                              width="275px"
                              height="48px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h275 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-275 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                  width: "100%",
                                  fontSize: 20,
                                  textAlign: "right",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily:
                                    "Gotham-Medium, Gotham, sans-serif",
                                  fontWeight: 500,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                16:03
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="c44a7308-c8d4-4144-bd8f-8fa28e1220c3"
                            data-layer-name="Location"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 1063,
                              pointerEvents: "none",
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 494,
                              height: 48
                            }}
                          >
                            <svg
                              width="494px"
                              height="48px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h494 a0,0 0 0 1 0,0 
                  v48 a0,0 0 0 1 -0,0 
                  h-494 a0,0 0 0 1 -0,-0 
                  v-48 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                  width: "100%",
                                  fontSize: 20,
                                  textAlign: "center",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily:
                                    "Gotham-Medium, Gotham, sans-serif",
                                  fontWeight: 500,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                Location
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="TextLayer"
                        data-layer-id="07e5cdfe-c1ff-41af-b3ae-851e4ef07708"
                        data-layer-name="Message"
                        style={{
                          position: "absolute",
                          top: 783,
                          left: 60,
                          pointerEvents: "none",
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 608,
                          height: 310
                        }}
                      >
                        <svg
                          width="608px"
                          height="310px"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            overflow: "visible"
                          }}
                        >
                          <defs />
                          <g>
                            <path
                              fill="rgba(207,207,207,0)"
                              d="
                  M0,0 
                  h608 a0,0 0 0 1 0,0 
                  v310 a0,0 0 0 1 -0,0 
                  h-608 a0,0 0 0 1 -0,-0 
                  v-310 a0,0 0 0 1 0,-0 
                  z
              "
                            />
                          </g>
                        </svg>
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            boxSizing: "border-box",
                            overflow: "hidden"
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              WebkitFontSmoothing: "antialiased",
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                              width: "100%",
                              fontSize: 12,
                              textAlign: "left",
                              lineHeight: "1.2",
                              letterSpacing: 0,
                              fontFamily: "Gotham-Book, Gotham, sans-serif",
                              fontWeight: 400,
                              fontStyle: "normal",
                              left: 0,
                              top: 0,
                              color: "rgb(0, 0, 0)"
                            }}
                          ></div>
                        </div>
                      </div>
                      <div
                        className="ContainerLayer"
                        data-layer-id="e9712295-163a-4b25-b262-778e1135d59b"
                        data-layer-name="Input"
                        style={{
                          position: "absolute",
                          boxSizing: "border-box",
                          pointerEvents: "none",
                          left: 60,
                          top: 684,
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 390,
                          height: 70,
                          borderRadius: 0,
                          backgroundColor: "rgba(255, 255, 255, 0)"
                        }}
                      >
                        <svg
                          width="390px"
                          height="70px"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            overflow: "visible"
                          }}
                        >
                          <defs />
                          <g>
                            <path />
                          </g>
                        </svg>
                        <div
                          className="ContainerLayerContent"
                          style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0
                          }}
                        >
                          <div
                            data-layer-id="2f0d0802-af90-4170-bc2a-1d45c8a57dea"
                            data-layer-name="Go"
                            style={{
                              position: "absolute",
                              top: 30,
                              left: 330,
                              pointerEvents: "none",
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 60,
                              height: 40
                            }}
                          >
                            <div
                              className="TextLayer"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                transform:
                                  "perspective(200px) rotateX(0deg) rotateY(0deg)",
                                transformOrigin: "50% 50%",
                                width: 60,
                                height: 40
                              }}
                            >
                              <svg
                                width="60px"
                                height="40px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs />
                                <g>
                                  <path
                                    fill="rgba(34,139,230,1)"
                                    d="
                  M4,0 
                  h52 a4,4 0 0 1 4,4 
                  v32 a4,4 0 0 1 -4,4 
                  h-52 a4,4 0 0 1 -4,-4 
                  v-32 a4,4 0 0 1 4,-4 
                  z
              "
                                  />
                                </g>
                              </svg>
                              <div
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  boxSizing: "border-box",
                                  overflow: "hidden"
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    WebkitFontSmoothing: "antialiased",
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    width: "100%",
                                    fontSize: 16,
                                    textAlign: "center",
                                    lineHeight: "1.2",
                                    letterSpacing: 0,
                                    fontFamily:
                                      "Gotham-Book, Gotham, sans-serif",
                                    fontWeight: 400,
                                    fontStyle: "normal",
                                    left: 0,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "rgb(255, 255, 255)"
                                  }}
                                >
                                  Go
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            data-layer-id="fb8e8dc2-71ff-4be0-8aac-76d01697e679"
                            data-layer-name="Location Input"
                            style={{
                              position: "absolute",
                              top: 30,
                              left: 0,
                              pointerEvents: "none",
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 320,
                              height: 40
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                transform:
                                  "perspective(200px) rotateX(0deg) rotateY(0deg)",
                                transformOrigin: "50% 50%",
                                width: 320,
                                height: 40
                              }}
                            >
                              <svg
                                width="320px"
                                height="40px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs />
                                <g>
                                  <path
                                    fill="rgba(233,233,233,1)"
                                    d="
                  M4,0 
                  h312 a4,4 0 0 1 4,4 
                  v32 a4,4 0 0 1 -4,4 
                  h-312 a4,4 0 0 1 -4,-4 
                  v-32 a4,4 0 0 1 4,-4 
                  z
              "
                                  />
                                </g>
                              </svg>
                              <div
                                style={{
                                  position: "absolute",
                                  inset: "0px 10px",
                                  boxSizing: "border-box",
                                  overflow: "hidden"
                                }}
                              >
                                <input
                                  name="Location Input"
                                  autoComplete="off"
                                  style={{
                                    padding: 0,
                                    position: "absolute",
                                    width: "100%",
                                    background: "none",
                                    border: "none",
                                    outline: "none",
                                    WebkitFontSmoothing: "antialiased",
                                    fontSize: 16,
                                    textAlign: "left",
                                    lineHeight: "1.2",
                                    letterSpacing: 0,
                                    fontFamily:
                                      "Gotham-Book, Gotham, sans-serif",
                                    fontWeight: 400,
                                    fontStyle: "normal",
                                    color: "rgb(0, 0, 0)",
                                    left: 0,
                                    top: "50%",
                                    transform: "translateY(-50%)"
                                  }}
                                />
                                <div
                                  style={{
                                    position: "absolute",
                                    width: "100%",
                                    pointerEvents: "none",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    WebkitFontSmoothing: "antialiased",
                                    visibility: "hidden"
                                  }}
                                >
                                  Enter a city
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="TextLayer"
                            data-layer-id="6e5612a9-cc78-43d5-95d3-aca24f8e6c78"
                            data-layer-name="Text 1"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              pointerEvents: "none",
                              transformOrigin: "0% 0%",
                              opacity: 1,
                              width: 360,
                              height: 30
                            }}
                          >
                            <svg
                              width="360px"
                              height="30px"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible"
                              }}
                            >
                              <defs />
                              <g>
                                <path
                                  fill="rgba(207,207,207,0)"
                                  d="
                  M0,0 
                  h360 a0,0 0 0 1 0,0 
                  v30 a0,0 0 0 1 -0,0 
                  h-360 a0,0 0 0 1 -0,-0 
                  v-30 a0,0 0 0 1 0,-0 
                  z
              "
                                />
                              </g>
                            </svg>
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                overflow: "hidden"
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  WebkitFontSmoothing: "antialiased",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                  width: "100%",
                                  fontSize: 16,
                                  textAlign: "left",
                                  lineHeight: "1.2",
                                  letterSpacing: 0,
                                  fontFamily: "Gotham-Book, Gotham, sans-serif",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  left: 0,
                                  top: 0,
                                  color: "rgb(0, 0, 0)"
                                }}
                              >
                                Get weather, date, time and music from:
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <audio
                        src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/77c2c611fc80242ce4a69546f642f6f81b35733e.mp3?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy83N2MyYzYxMWZjODAyNDJjZTRhNjk1NDZmNjQyZjZmODFiMzU3MzNlLm1wMyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=EDkiDGWP9gqc~kpOTY8ZlbaOWzxkwHuroLLowLgoREaZg8l8UjW~MdBi2zkAL0NrtsCW1vRX4Tvxt91c6G~~LMXmyhziXFu7cK-0Ti1khRwYpGndudjguf43INp~Zi-GEsJicIgUt7dkobjYTTHLpXE6~KEQ1fZJ9ujSsBPnqdg5Sit2ikMkQ58R4V3bdHiHPhs3CL5rqJxxNetuHANe-CQTXi~nq2SnFZN28bdSMO36kWK1u7QgFK8VcrpAJgtAg-wEAq7pMKuI4LlycF5RAHFwfy6IzaxV-U3Y~BIpSdcS5tAdKu0d4awFlekaV008eK6Z48WytgzbJrA0N3PCgg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA"
                        data-layer-id="30a06913-d827-42fd-aaeb-e1a2e981b296"
                        data-layer-name="Lost"
                        style={{
                          pointerEvents: "none",
                          left: 0,
                          top: 0,
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 50,
                          height: 50
                        }}
                      >
                        <source src="https://cloud-data.protopie.io/xid/upload/pies/5d5a333fdbc83a848cb38105/res/77c2c611fc80242ce4a69546f642f6f81b35733e.mp3?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vY2xvdWQtZGF0YS5wcm90b3BpZS5pby94aWQvdXBsb2FkL3BpZXMvNWQ1YTMzM2ZkYmM4M2E4NDhjYjM4MTA1L3Jlcy83N2MyYzYxMWZjODAyNDJjZTRhNjk1NDZmNjQyZjZmODFiMzU3MzNlLm1wMyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcwMDE4MjgwMH0sIklwQWRkcmVzcyI6eyJBV1M6U291cmNlSXAiOiIwLjAuMC4wLzAifSwiRGF0ZUdyZWF0ZXJUaGFuIjp7IkFXUzpFcG9jaFRpbWUiOjE3MDAxNjg0MDB9fX1dfQ__&Signature=EDkiDGWP9gqc~kpOTY8ZlbaOWzxkwHuroLLowLgoREaZg8l8UjW~MdBi2zkAL0NrtsCW1vRX4Tvxt91c6G~~LMXmyhziXFu7cK-0Ti1khRwYpGndudjguf43INp~Zi-GEsJicIgUt7dkobjYTTHLpXE6~KEQ1fZJ9ujSsBPnqdg5Sit2ikMkQ58R4V3bdHiHPhs3CL5rqJxxNetuHANe-CQTXi~nq2SnFZN28bdSMO36kWK1u7QgFK8VcrpAJgtAg-wEAq7pMKuI4LlycF5RAHFwfy6IzaxV-U3Y~BIpSdcS5tAdKu0d4awFlekaV008eK6Z48WytgzbJrA0N3PCgg__&Key-Pair-Id=APKAJWJARUN3H6JALWTA" />
                      </audio>
                      <div
                        data-layer-id="_KEYBOARD_CONTAINER_"
                        data-layer-name=""
                        style={{
                          position: "absolute",
                          top: 1200,
                          left: 0,
                          transformOrigin: "0% 0%",
                          opacity: 1,
                          width: 1900,
                          height: 0
                        }}
                      >
                        <div
                          className="ContainerLayer"
                          style={{
                            position: "absolute",
                            boxSizing: "border-box",
                            transform:
                              "perspective(200px) rotateX(0deg) rotateY(0deg)",
                            transformOrigin: "50% 50%",
                            width: 1900,
                            height: 0,
                            borderRadius: 0,
                            backgroundColor: "rgba(255, 255, 255, 0)"
                          }}
                        >
                          <svg
                            width="1900px"
                            height="0px"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              overflow: "visible"
                            }}
                          >
                            <defs />
                            <g>
                              <path />
                            </g>
                          </svg>
                          <div
                            className="ContainerLayerContent"
                            style={{
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              top: 0,
                              left: 0
                            }}
                          >
                            <div
                              data-layer-id="_KEYBOARD_MAIN_"
                              data-layer-name=""
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible",
                                transformOrigin: "0% 0%",
                                opacity: 1,
                                width: 1900,
                                height: 0
                              }}
                            >
                              <img
                                src="data:image/gifbase64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: 0
                                }}
                              />
                              <svg
                                width="1900px"
                                height="0px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                            </div>
                            <div
                              data-layer-id="_KEYBOARD_SUB_"
                              data-layer-name=""
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 1900,
                                overflow: "visible",
                                transformOrigin: "100% 100%",
                                opacity: 1,
                                width: 0,
                                height: 0
                              }}
                            >
                              <img
                                src="data:image/gifbase64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: 0
                                }}
                              />
                              <svg
                                width="0px"
                                height="0px"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  overflow: "visible"
                                }}
                              >
                                <defs />
                                <g>
                                  <path />
                                </g>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <svg
                    width="1900px"
                    height="1200px"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      overflow: "visible",
                      pointerEvents: "none"
                    }}
                  >
                    <defs />
                    <g>
                      <path />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                inset: 0,
                boxSizing: "border-box",
                overflow: "hidden",
                pointerEvents: "none"
              }}
            >
              <div
                data-layer-id="DEVICE_FRAME_LAYER"
                data-layer-name=""
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  transformOrigin: "0% 0%",
                  opacity: 0,
                  pointerEvents: "none",
                  width: 1900,
                  height: 1200
                }}
              >
                <div
                  className="ContainerLayer"
                  style={{
                    position: "absolute",
                    boxSizing: "border-box",
                    transform: "perspective(200px) rotateX(0deg) rotateY(0deg)",
                    transformOrigin: "50% 50%",
                    width: 1900,
                    height: 1200,
                    borderRadius: 0,
                    backgroundColor: "rgba(255, 255, 255, 0)"
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      boxSizing: "border-box",
                      overflow: "hidden",
                      borderRadius: 0
                    }}
                  >
                    <div
                      className="ContainerLayerContent"
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        top: 0,
                        left: 0
                      }}
                    />
                  </div>
                  <svg
                    width="1900px"
                    height="1200px"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      overflow: "visible",
                      pointerEvents: "none"
                    }}
                  >
                    <defs />
                    <g>
                      <path />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          className="sc-gZzbk inSpVe"
          href="https://www.protopie.io/"
          target="_blank"
        >
          <svg
            width={14}
            height={14}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="sc-iClJEh erSSIN"
          >
            <g filter="url(#filter0_ii_531_3712)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.02239 11.8647V14.0002C6.66961 14.0002 6.3495 13.8598 6.11416 13.6323C6.11329 13.6323 6.1133 13.6323 6.1133 13.6316L5.93694 13.421L0.162452 6.54786C0.15867 6.54604 0.155945 6.54228 0.153982 6.53844L0.130673 6.51148C0.128854 6.50945 0.127797 6.50764 0.12613 6.50569C0.0979812 6.46743 0.0737666 6.4262 0.0578771 6.38128C0.0363869 6.32795 0.0242796 6.26999 0.0224609 6.21007V6.17456C0.0224609 6.16333 0.0233666 6.15196 0.0253374 6.14073C0.0354739 6.02299 0.0858737 5.91793 0.162452 5.83569C0.256738 5.73367 0.392947 5.66919 0.543082 5.66919H1.81543L7.02145 11.8656L7.02239 11.8647Z"
                fill="url(#paint0_linear_531_3712)"
                style={{ mixBlendMode: "multiply" }}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.02239 11.8647V14.0002C6.66961 14.0002 6.3495 13.8598 6.11416 13.6323C6.11329 13.6323 6.1133 13.6323 6.1133 13.6316L5.93694 13.421L0.162452 6.54786C0.15867 6.54604 0.155945 6.54228 0.153982 6.53844L0.130673 6.51148C0.128854 6.50945 0.127797 6.50764 0.12613 6.50569C0.0979812 6.46743 0.0737666 6.4262 0.0578771 6.38128C0.0363869 6.32795 0.0242796 6.26999 0.0224609 6.21007V6.17456C0.0224609 6.16333 0.0233666 6.15196 0.0253374 6.14073C0.0354739 6.02299 0.0858737 5.91793 0.162452 5.83569C0.256738 5.73367 0.392947 5.66919 0.543082 5.66919H1.81543L7.02145 11.8656L7.02239 11.8647Z"
                fill="url(#paint1_linear_531_3712)"
                style={{ mixBlendMode: "multiply" }}
              />
            </g>
            <g filter="url(#filter1_ii_531_3712)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.02239 11.8647V14.0002C6.66961 14.0002 6.3495 13.8598 6.11416 13.6323C6.11329 13.6323 6.1133 13.6323 6.1133 13.6316L5.93694 13.421L1.62867 8.29338L0.162452 6.54786C0.15867 6.54604 0.155945 6.54228 0.153982 6.53844L0.130673 6.51148C0.128854 6.50945 0.127797 6.50764 0.12613 6.50569C0.0979812 6.46743 0.0737666 6.4262 0.0578771 6.38128C0.0363869 6.32795 0.0242796 6.26999 0.0224609 6.21007V6.17456C0.0224609 6.16333 0.0233666 6.15196 0.0253374 6.14073C0.0354739 6.02299 0.0858737 5.91793 0.162452 5.83569C0.256738 5.73367 0.392947 5.66919 0.543082 5.66919H1.81543L2.41369 6.38128L4.01992 8.29338L6.65359 11.4276L7.02145 11.8656L7.02239 11.8647Z"
                fill="url(#paint2_linear_531_3712)"
                fillOpacity="0.4"
              />
            </g>
            <g filter="url(#filter2_ii_531_3712)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.02239 9.02785V11.8791L7.02145 11.8801L6.65403 11.4433L4.02035 8.31735L2.41383 6.41033L1.81543 5.69969L0.152765 3.72702C0.145809 3.71926 0.138846 3.7105 0.131883 3.70159C0.101314 3.66239 0.0758824 3.61862 0.0574208 3.5703C0.0365392 3.51704 0.0242796 3.45922 0.0224609 3.39807V3.36293C0.0259388 3.23262 0.0784616 3.11531 0.162452 3.02615C0.256137 2.92276 0.392498 2.85889 0.543082 2.85889H1.82587L2.42519 3.5703L4.21902 5.69969L4.81743 6.41033L6.42398 8.31735L7.02239 9.02785Z"
                fill="url(#paint3_linear_531_3712)"
                fillOpacity="0.3"
                style={{ mixBlendMode: "multiply" }}
              />
            </g>
            <g filter="url(#filter3_ii_531_3712)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.520628 0C0.370645 0 0.233226 0.0632608 0.139998 0.166937C0.0560006 0.254717 0.00378941 0.37413 0 0.503985V0.538495C0.00166647 0.60009 0.0137738 0.657901 0.0354162 0.711026C0.0363291 0.715721 0.0382925 0.719503 0.039959 0.724191C0.0569063 0.764302 0.0782517 0.80153 0.105343 0.836192C0.114574 0.849357 0.125014 0.861465 0.136216 0.872514C0.138027 0.875391 0.140752 0.878115 0.143628 0.880991L6.99987 9.01876V14C7.0327 14 7.0645 13.9991 7.09609 13.9964C7.41062 13.9741 7.69436 13.8396 7.9081 13.6333C7.90912 13.6333 7.90911 13.6333 7.90911 13.6322L8.08547 13.4223L13.8685 6.55753C13.8759 6.55014 13.8824 6.54166 13.8891 6.53333C13.9207 6.49413 13.9459 6.45007 13.9644 6.40167C13.9879 6.34385 14 6.28046 14 6.21307V0.520787C14 0.383513 13.9467 0.257441 13.8591 0.166031C13.7648 0.0632607 13.6294 0 13.4782 0H0.520628Z"
                fill="url(#paint4_linear_531_3712)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.520628 0C0.370645 0 0.233226 0.0632608 0.139998 0.166937C0.0560006 0.254717 0.00378941 0.37413 0 0.503985V0.538495C0.00166647 0.60009 0.0137738 0.657901 0.0354162 0.711026C0.0363291 0.715721 0.0382925 0.719503 0.039959 0.724191C0.0569063 0.764302 0.0782517 0.80153 0.105343 0.836192C0.114574 0.849357 0.125014 0.861465 0.136216 0.872514C0.138027 0.875391 0.140752 0.878115 0.143628 0.880991L6.99987 9.01876V14C7.0327 14 7.0645 13.9991 7.09609 13.9964C7.41062 13.9741 7.69436 13.8396 7.9081 13.6333C7.90912 13.6333 7.90911 13.6333 7.90911 13.6322L8.08547 13.4223L13.8685 6.55753C13.8759 6.55014 13.8824 6.54166 13.8891 6.53333C13.9207 6.49413 13.9459 6.45007 13.9644 6.40167C13.9879 6.34385 14 6.28046 14 6.21307V0.520787C14 0.383513 13.9467 0.257441 13.8591 0.166031C13.7648 0.0632607 13.6294 0 13.4782 0H0.520628Z"
                fill="url(#paint5_linear_531_3712)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.520628 0C0.370645 0 0.233226 0.0632608 0.139998 0.166937C0.0560006 0.254717 0.00378941 0.37413 0 0.503985V0.538495C0.00166647 0.60009 0.0137738 0.657901 0.0354162 0.711026C0.0363291 0.715721 0.0382925 0.719503 0.039959 0.724191C0.0569063 0.764302 0.0782517 0.80153 0.105343 0.836192C0.114574 0.849357 0.125014 0.861465 0.136216 0.872514C0.138027 0.875391 0.140752 0.878115 0.143628 0.880991L6.99987 9.01876V14C7.0327 14 7.0645 13.9991 7.09609 13.9964C7.41062 13.9741 7.69436 13.8396 7.9081 13.6333C7.90912 13.6333 7.90911 13.6333 7.90911 13.6322L8.08547 13.4223L13.8685 6.55753C13.8759 6.55014 13.8824 6.54166 13.8891 6.53333C13.9207 6.49413 13.9459 6.45007 13.9644 6.40167C13.9879 6.34385 14 6.28046 14 6.21307V0.520787C14 0.383513 13.9467 0.257441 13.8591 0.166031C13.7648 0.0632607 13.6294 0 13.4782 0H0.520628Z"
                fill="url(#paint6_linear_531_3712)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.520628 0C0.370645 0 0.233226 0.0632608 0.139998 0.166937C0.0560006 0.254717 0.00378941 0.37413 0 0.503985V0.538495C0.00166647 0.60009 0.0137738 0.657901 0.0354162 0.711026C0.0363291 0.715721 0.0382925 0.719503 0.039959 0.724191C0.0569063 0.764302 0.0782517 0.80153 0.105343 0.836192C0.114574 0.849357 0.125014 0.861465 0.136216 0.872514C0.138027 0.875391 0.140752 0.878115 0.143628 0.880991L6.99987 9.01876V14C7.0327 14 7.0645 13.9991 7.09609 13.9964C7.41062 13.9741 7.69436 13.8396 7.9081 13.6333C7.90912 13.6333 7.90911 13.6333 7.90911 13.6322L8.08547 13.4223L13.8685 6.55753C13.8759 6.55014 13.8824 6.54166 13.8891 6.53333C13.9207 6.49413 13.9459 6.45007 13.9644 6.40167C13.9879 6.34385 14 6.28046 14 6.21307V0.520787C14 0.383513 13.9467 0.257441 13.8591 0.166031C13.7648 0.0632607 13.6294 0 13.4782 0H0.520628Z"
                fill="url(#paint7_linear_531_3712)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.520628 0C0.370645 0 0.233226 0.0632608 0.139998 0.166937C0.0560006 0.254717 0.00378941 0.37413 0 0.503985V0.538495C0.00166647 0.60009 0.0137738 0.657901 0.0354162 0.711026C0.0363291 0.715721 0.0382925 0.719503 0.039959 0.724191C0.0569063 0.764302 0.0782517 0.80153 0.105343 0.836192C0.114574 0.849357 0.125014 0.861465 0.136216 0.872514C0.138027 0.875391 0.140752 0.878115 0.143628 0.880991L6.99987 9.01876V14C7.0327 14 7.0645 13.9991 7.09609 13.9964C7.41062 13.9741 7.69436 13.8396 7.9081 13.6333C7.90912 13.6333 7.90911 13.6333 7.90911 13.6322L8.08547 13.4223L13.8685 6.55753C13.8759 6.55014 13.8824 6.54166 13.8891 6.53333C13.9207 6.49413 13.9459 6.45007 13.9644 6.40167C13.9879 6.34385 14 6.28046 14 6.21307V0.520787C14 0.383513 13.9467 0.257441 13.8591 0.166031C13.7648 0.0632607 13.6294 0 13.4782 0H0.520628Z"
                fill="url(#paint8_linear_531_3712)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.520628 0C0.370645 0 0.233226 0.0632608 0.139998 0.166937C0.0560006 0.254717 0.00378941 0.37413 0 0.503985V0.538495C0.00166647 0.60009 0.0137738 0.657901 0.0354162 0.711026C0.0363291 0.715721 0.0382925 0.719503 0.039959 0.724191C0.0569063 0.764302 0.0782517 0.80153 0.105343 0.836192C0.114574 0.849357 0.125014 0.861465 0.136216 0.872514C0.138027 0.875391 0.140752 0.878115 0.143628 0.880991L6.99987 9.01876V14C7.0327 14 7.0645 13.9991 7.09609 13.9964C7.41062 13.9741 7.69436 13.8396 7.9081 13.6333C7.90912 13.6333 7.90911 13.6333 7.90911 13.6322L8.08547 13.4223L13.8685 6.55753C13.8759 6.55014 13.8824 6.54166 13.8891 6.53333C13.9207 6.49413 13.9459 6.45007 13.9644 6.40167C13.9879 6.34385 14 6.28046 14 6.21307V0.520787C14 0.383513 13.9467 0.257441 13.8591 0.166031C13.7648 0.0632607 13.6294 0 13.4782 0H0.520628Z"
                fill="url(#paint9_linear_531_3712)"
              />
            </g>
            <defs>
              <filter
                id="filter0_ii_531_3712"
                x="0.0224609"
                y="5.66919"
                width={7}
                height="8.33093"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="16.4911" dy="40.8694" />
                <feGaussianBlur stdDeviation="12.1891" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.651 0 0 0 0 0.58 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_531_3712"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-13.1995" dy="87.1163" />
                <feGaussianBlur stdDeviation="11.8796" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.875 0 0 0 0 0.843 0 0 0 0.48 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_innerShadow_531_3712"
                  result="effect2_innerShadow_531_3712"
                />
              </filter>
              <filter
                id="filter1_ii_531_3712"
                x="0.0224609"
                y="-2.21789"
                width="16.3211"
                height="16.218"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="0.717007" dy="-8.60408" />
                <feGaussianBlur stdDeviation="3.22653" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.604589 0 0 0 0 0.591667 0 0 0 0.2 0"
                />
                <feBlend
                  mode="multiply"
                  in2="shape"
                  result="effect1_innerShadow_531_3712"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="9.32109" dy="-7.88708" />
                <feGaussianBlur stdDeviation="4.66055" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_innerShadow_531_3712"
                  result="effect2_innerShadow_531_3712"
                />
              </filter>
              <filter
                id="filter2_ii_531_3712"
                x="0.0224609"
                y="1.42487"
                width="12.0191"
                height="12.6062"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="2.15102" dy="-1.43401" />
                <feGaussianBlur stdDeviation="5.37755" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.996078 0 0 0 0 0.458823 0 0 0 0 0.411765 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_531_3712"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="11.4721" dy="2.15102" />
                <feGaussianBlur stdDeviation="2.50953" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_innerShadow_531_3712"
                  result="effect2_innerShadow_531_3712"
                />
              </filter>
              <filter
                id="filter3_ii_531_3712"
                x="-14.3373"
                y="-10.7505"
                width="28.3373"
                height="34.0683"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-14.3373" dy="-10.7505" />
                <feGaussianBlur stdDeviation="10.3948" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="hard-light"
                  in2="shape"
                  result="effect1_innerShadow_531_3712"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1.43273" dy="9.31777" />
                <feGaussianBlur stdDeviation="8.96209" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2={-1}
                  k3={1}
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.87451 0 0 0 0 0.843137 0 0 0 0.7 0"
                />
                <feBlend
                  mode="soft-light"
                  in2="effect1_innerShadow_531_3712"
                  result="effect2_innerShadow_531_3712"
                />
              </filter>
              <linearGradient
                id="paint0_linear_531_3712"
                x1="4.22627"
                y1="8.08063"
                x2="3.00864"
                y2="9.0361"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFA794" stopOpacity="0.3" />
                <stop offset={1} stopColor="#FF9794" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_531_3712"
                x1="4.22627"
                y1="8.08063"
                x2="3.00864"
                y2="9.0361"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFA794" stopOpacity="0.3" />
                <stop offset={1} stopColor="#FF9794" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_531_3712"
                x1="4.12258"
                y1="11.1742"
                x2="5.42856"
                y2="10.0072"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFDFD7" />
                <stop offset={1} stopColor="#FFDFD7" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_531_3712"
                x1="4.51145"
                y1="8.76266"
                x2="5.88557"
                y2="7.36268"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFA694" />
                <stop offset={1} stopColor="#FFB7A9" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_531_3712"
                x1="11.563"
                y1="9.3593"
                x2="2.10021"
                y2="2.85156"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
              <linearGradient
                id="paint5_linear_531_3712"
                x1="11.563"
                y1="9.3593"
                x2="2.10021"
                y2="2.85156"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
              <linearGradient
                id="paint6_linear_531_3712"
                x1="11.563"
                y1="9.3593"
                x2="2.10021"
                y2="2.85156"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
              <linearGradient
                id="paint7_linear_531_3712"
                x1="11.563"
                y1="9.3593"
                x2="2.10021"
                y2="2.85156"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
              <linearGradient
                id="paint8_linear_531_3712"
                x1="11.563"
                y1="9.3593"
                x2="2.10021"
                y2="2.85156"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
              <linearGradient
                id="paint9_linear_531_3712"
                x1="11.563"
                y1="9.3593"
                x2="2.10021"
                y2="2.85156"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF6661" />
                <stop offset={1} stopColor="#FF7D73" />
              </linearGradient>
            </defs>
          </svg>
          Made with ProtoPie
        </a>
      </div>
    </main>
  </div>
  <div id="pop" />
  <div id="dimmer">
    <div />
  </div>
  <div id="dialog">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div>
      <section className="sc-jSgkbs hzabIY">
        <video
          autoPlay=""
          loop=""
          src="https://static.protopie.io/web/videos/onboarding/ur_pie_v1.mp4"
          poster="https://static.protopie.io/web/images/onboarding/ur_pie.png"
        />
        <div className="sc-jzKvxP fWJKkd">
          <h2 className="sc-gDpNkS HodVp">New feature: User Testing</h2>
          <p className="sc-eqGKRV gdUres">
            Test prototypes with participants in secure Test Rooms
          </p>
          <div className="sc-bumcEY lptGFF">
            <button className="sc-dwrfT bKZIyD">Skip</button>
            <button className="sc-dkRvfS bjjBtK">Create</button>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div id="selectOption" />
  <div id="alert">
    <div>
      <div className="sc-kstrdz btjemE" />
    </div>
    <div>
      <div className="sc-gwXINx cMMNln" />
    </div>
  </div>
  <noscript>
    You need to enable javascript in order to use ProtoPie Cloud.
  </noscript>
  <noscript>
    &lt;img height="1" width="1" style="display:none"
    src="https://www.facebook.com/tr?id=1520730218001750&amp;amp;ev=PageView&amp;amp;noscript=1"&gt;
  </noscript>

</>

        <CardsList/>
    </div>
    
  )
}


const cardsData = [
  { 
    id: 1, 
    title: 'Title', 
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit', 
    imageUrl: 'https://i.imgur.com/BoOgXH7_d.webp?maxwidth=520&shape=thumb&fidelity=high', // Replace with your image path
    bgColor: 'white'
  },
  { 
    id: 2, 
    title: 'Title', 
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit', 
    imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqRlq6KmANh_mabwWMj3xlLzJzp3Zq7nPNjHGnguHZvA&s', // Replace with your image path
    bgColor: 'white'
  },
  { 
    id: 3, 
    title: 'Title', 
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit', 
    imageUrl: 'https://img.freepik.com/premium-photo/female-android-robot-head-with-white-metal-wires-face-closeup-creative-ai-high-quality-photo_965671-229.jpg', // Replace with your image path
    bgColor: 'white'
  },
  { 
    id: 4, 
    title: 'Title', 
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit', 
    imageUrl: 'https://ae01.alicdn.com/kf/Sb45a907e8dd94e82997da1dfc776a1bag/Hot-Sale-1-6th-Luke-High-Quality-Male-Head-Sculpture-Carving-Model-For-12inch-Action-Figure.jpg', // Replace with your image path
    bgColor: 'white'
  },
  // ... add other cards
];

const Card = ({ title, description, imageUrl, bgColor }) => (
  <div style={{
    backgroundColor: bgColor,
    width: '250px', // Adjust width as per your design
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    margin: '10px',
    fontFamily: '"Arial", sans-serif', // Use the font from your design
  }}>
    <img src={imageUrl} alt={title} style={{ width: '100%', display: 'block' }} />
    <div style={{ padding: '15px' }}>
      <h1 style={{
        margin: '0 0 10px',
        fontSize: '18px', // Adjust font-size as per your design
        color: '#333', // Adjust title color as per your design
      }}>{title}</h1>
      <p style={{
        margin: 0,
        fontSize: '14px', // Adjust font-size as per your design
        color: '#666', // Adjust paragraph color as per your design
      }}>{description}</p>
    </div>
  </div>
);

const CardsList = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: '10px',
    marginTop: '160px'
    // Add more styling as necessary
  }}>
    {cardsData.map(card => (
      <Card key={card.id} {...card} />
    ))}
  </div>
);


